(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdp-swiper-large-diffuser-free-flow"] && !Shopify.designMode) return;
  try {
    

  // ── External Swiper initialiser ────────────────────────────────────────────
  // Runs at DOMContentLoaded — before Alpine's init() — so Swiper is always
  // created by this function. Slide changes are communicated to Alpine via a
  // custom event on the section root, which Alpine listens for in init().
  const initQtyPdpSwiper = (root) => {
    if (typeof window.Swiper === 'undefined') return

    // Media swipers (left column on slide 0 and review slide)
    root.querySelectorAll('.pdp-swiper__media-swiper').forEach((mediaEl) => {
      if (mediaEl.swiper) return
      new window.Swiper(mediaEl, {
        nested: true,
        slidesPerView: 1,
        speed: 650,
        breakpoints: { 990: { allowTouchMove: false, simulateTouch: false } },
      })
    })

    // Root Swiper — controls all step slides
    const rootEl = root.querySelector('.pdp-swiper__root')
    if (!rootEl || rootEl.swiper) return
    new window.Swiper(rootEl, {
      slidesPerView: 1,
      speed: 700,
      allowTouchMove: false,
      simulateTouch: false,
      autoHeight: true,
      on: {
        slideChange(sw) {
          root.dispatchEvent(
            new CustomEvent('pdp-swiper-ldff:slide-change', {
              bubbles: false,
              detail: { activeIndex: sw.activeIndex },
            })
          )
        },
      },
    })
  }

  const _runQtyPdpSwiperInit = () => {
    document.querySelectorAll('.pdp-swiper-ldff').forEach(initQtyPdpSwiper)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _runQtyPdpSwiperInit)
  } else {
    _runQtyPdpSwiperInit()
  }

  // ── Discount / product-type rule parsers ───────────────────────────────────

  const parseDiscountByProductTypeRules = (raw) => {
    if (!raw || typeof raw !== 'string') return []
    return raw
      .replace(/\r\n/g, '\n')
      .split(/[,\n]+/)
      .map((s) => s.trim())
      .filter(Boolean)
      .map((segment) => {
        const idx = segment.lastIndexOf('/')
        if (idx === -1) return null
        const productType = segment.slice(0, idx).trim()
        const percent = segment.slice(idx + 1).trim()
        if (!productType || !percent) return null
        return { productType, percent: Number(percent) }
      })
      .filter(Boolean)
  }

  const parseQtyAddonProductTypeRules = (raw) => {
    if (!raw || typeof raw !== 'string') return []
    return raw
      .replace(/\r\n/g, '\n')
      .split(/[,\n]+/)
      .map((s) => s.trim())
      .filter(Boolean)
      .map((segment) => {
        const parts = segment.split('|').map((p) => p.trim())
        const match = parts[0]
        const productType = parts[1] || ''
        const collectionFilter = parts[2] || null
        if (!match || !productType) return null
        return { match, productType, collectionFilter }
      })
      .filter(Boolean)
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('pdpSwiperLdffState', () => ({

      // ── Variant data ────────────────────────────────────────────────
      productHandle: '',
      variantsById: {},
      addonVariantsById: {},
      defaultByOption1: {},
      addonProductTypeMap: '',
      discountByProductTypeMap: '',
      reviewImageMappings: [],
      productFeaturedImage: '',
      bundleVariantId: '',
      bundleOnlyMode: false,
      templateSuffix: '',
      freePromo: true,
      subscriptionOnly: true,
      frequencyStep: false,
      frequencyHeadline: 'Select scent delivery frequency',
      subscriptionBestOfferLabel: '',
      bundleVariant: null,
      bundleSlotsByType: {},

      // ── Commitment term step (12/24/36 month) ────────────────────────
      diffuserPromo: '',
      diffuserTypeSlugByOption1: {},
      commitmentTermOptions: [],
      selectedCommitmentTerm: null,

      // ── Step 1 quantity state ────────────────────────────────────────
      // { [option1Key]: 0..3 }
      quantityByOption1: {},

      // ── Step 1 slot color state ──────────────────────────────────────
      // { [option1Key]: [variantId, variantId, ...] }  length === qty
      slotColorByOption1: {},

      // ── Swatch data (baked from Liquid) ──────────────────────────────
      // { [option1Key]: [{ variantId, option2, swatchBg }, ...] }
      swatchesByOption1: {},

      // Ordered list of option1 keys (Liquid render order)
      option1Order: [],

      // ── Bundle list (built on NEXT from Step 1) ──────────────────────
      bundles: [],

      // ── Addon type groups (derived from bundles, drives addon slides) ─
      // [{ productType, count, bundles[], label }]
      addonTypeGroups: [],

      // ── Scent qty per type: { [productType]: { [addonVariantId]: qty } }
      addonQtyByType: {},

      // ── Purchase mode per addon: { [addonVariantId]: 'subscription' | 'one_time' }
      addonPurchaseModeById: {},
      // ── Group-level frequency choice: { [productType]: 'subscription' | 'one_time' }
      groupPurchaseModeByType: {},

      // ── Swiper tracking ──────────────────────────────────────────────
      currentSwiperIndex: 0,
      stepTextTemplate: '',

      // ── Shared UI state ─────────────────────────────────────────────
      termsAccepted: false,
      termsAcceptedAt: null,
      termsModalOpen: false,
      addToCartLoading: false,
      popupOpen: false,
      popupVariant: null,
      popupOption1: null,
      popupSectionsCache: {},
      popupSectionsHtml: '',
      addonPopupOpen: false,
      addonPopupVariant: null,
      addonPopupSectionsCache: {},
      addonPopupSectionsHtml: '',
      pdpSwiperRootEl: null,

      // ── Init ────────────────────────────────────────────────────────
      init() {
        this.pdpSwiperRootEl =
          this.$el && this.$el.closest ? this.$el.closest('.pdp-swiper-ldff') : null

        const jsonEl = this.$el.querySelector('[data-pdp-variant-state]')
        if (!jsonEl) return

        let state = null
        try {
          state = JSON.parse(jsonEl.textContent || '{}')
        } catch (e) {
          state = null
        }
        if (!state) return

        // Populate variantsById
        ;(state.variants || []).forEach((v) => {
          this.variantsById[String(v.id)] = v
        })

        // Populate addonVariantsById
        this.addonVariantsById = {}
        ;(state.addonVariants || []).forEach((row) => {
          if (row && row.id != null) {
            this.addonVariantsById[String(row.id)] = row
          }
        })

        this.defaultByOption1 = { ...(state.defaults || {}) }
        this.addonProductTypeMap =
          typeof state.addonProductTypeMap === 'string' ? state.addonProductTypeMap : ''
        this.discountByProductTypeMap =
          typeof state.discountByProductTypeMap === 'string'
            ? state.discountByProductTypeMap
            : ''
        this.reviewImageMappings = Array.isArray(state.reviewImageMappings)
          ? state.reviewImageMappings
          : []
        this.productFeaturedImage = state.productFeaturedImage || ''

        this.productHandle = state.productHandle || ''

        this.bundleVariantId = state.bundleVariantId || ''
        this.bundleOnlyMode = !!state.bundleOnlyMode
        this.templateSuffix = state.templateSuffix || ''
        this.freePromo = state.freePromo !== false
        this.subscriptionOnly = state.subscriptionOnly !== false
        this.frequencyStep = !!state.frequencyStep
        this.frequencyHeadline =
          typeof state.frequencyHeadline === 'string' && state.frequencyHeadline.trim()
            ? state.frequencyHeadline.trim()
            : 'Select scent delivery frequency'
        this.subscriptionBestOfferLabel =
          typeof state.subscriptionBestOfferLabel === 'string'
            ? state.subscriptionBestOfferLabel.trim()
            : ''
        this.addonPurchaseModeById = {}
        this.groupPurchaseModeByType = {}
        this.bundleVariant = this.bundleVariantId
          ? (Object.values(this.variantsById).find((v) => v.option1 === this.bundleVariantId) || null)
          : null

        // Swatch data per option1 group
        this.swatchesByOption1 =
          state.swatchesByOption1 && typeof state.swatchesByOption1 === 'object'
            ? state.swatchesByOption1
            : {}

        // Ordered option1 keys (Liquid render order for bundle building)
        this.option1Order = Array.isArray(state.option1Order) ? state.option1Order : []

        // Initialize quantityByOption1: all option1 groups start at 0,
        // unless there is only a single option1 (diffuser type) group,
        // in which case it defaults to 1 so the lone type is pre-selected.
        const qtyInit = {}
        const option1Keys = Object.keys(this.defaultByOption1)
        const singleOption1Default = option1Keys.length === 1 ? 1 : 0
        option1Keys.forEach((key) => {
          qtyInit[key] = singleOption1Default
        })
        this.quantityByOption1 = qtyInit
        this.slotColorByOption1 = {}

        // Bundle-only mode: the bundle card is the only purchasable item on Step 1,
        // so pre-select 1 unit (and its default color per component type) instead of
        // landing on an empty page with nothing selected and NEXT disabled.
        if (this.bundleOnlyMode && this.bundleVariant) {
          this.quantityByOption1 = { ...this.quantityByOption1, __bundle__: 1 }
          const typeOrder = this.getBundleTypeOrder()
          const initialSlots = {}
          typeOrder.forEach((t) => {
            initialSlots[t.productType] = [t.swatches.length ? t.swatches[0].variantId : null]
          })
          this.bundleSlotsByType = initialSlots
        }

        // Step text template for addon slides ("Step {step_number}: ...")
        this.stepTextTemplate = typeof state.stepTextTemplate === 'string'
          ? state.stepTextTemplate
          : 'Step {step_number}: Choose your scent.'

        // Commitment term options (12/24/36 month), merchant-configured
        this.diffuserPromo = typeof state.diffuserPromo === 'string' ? state.diffuserPromo : ''
        this.diffuserTypeSlugByOption1 =
          state.diffuserTypeSlugByOption1 && typeof state.diffuserTypeSlugByOption1 === 'object'
            ? state.diffuserTypeSlugByOption1
            : {}
        this.commitmentTermOptions = Array.isArray(state.commitmentTermOptions)
          ? state.commitmentTermOptions
          : []
        const bestOffer = this.commitmentTermOptions.find((t) => t.bestOffer)
        const lastOption = this.commitmentTermOptions[this.commitmentTermOptions.length - 1]
        this.selectedCommitmentTerm = (bestOffer || lastOption || {}).months || null

        // Listen for slide changes dispatched by the external Swiper init
        const root = this.pdpSwiperRootEl
        if (root) {
          root.addEventListener('pdp-swiper-ldff:slide-change', (e) => {
            this.currentSwiperIndex = (e.detail && e.detail.activeIndex != null)
              ? e.detail.activeIndex
              : 0
          })
        }
      },

      // ── Quantity helpers ─────────────────────────────────────────────
      getQty(option1Key) {
        return Number(this.quantityByOption1[option1Key] || 0)
      },

      incrementQty(option1Key) {
        const current = this.getQty(option1Key)
        const weight = option1Key === '__bundle__' ? 3 : 1
        if (this.totalWeightedUnits() + weight > 5) return
        this.quantityByOption1 = { ...this.quantityByOption1, [option1Key]: current + 1 }
        if (option1Key === '__bundle__') {
          const typeOrder = this.getBundleTypeOrder()
          const newSlots = { ...this.bundleSlotsByType }
          typeOrder.forEach((t) => {
            const existing = [...(newSlots[t.productType] || [])]
            existing.push(t.swatches.length ? t.swatches[0].variantId : null)
            newSlots[t.productType] = existing
          })
          this.bundleSlotsByType = newSlots
        } else {
          const existing = [...(this.slotColorByOption1[option1Key] || [])]
          existing.push(this.firstSwatchVariantIdForOption1(option1Key))
          this.slotColorByOption1 = { ...this.slotColorByOption1, [option1Key]: existing }
        }
      },

      decrementQty(option1Key) {
        const current = this.getQty(option1Key)
        if (current <= 0) return
        this.quantityByOption1 = { ...this.quantityByOption1, [option1Key]: current - 1 }
        if (option1Key === '__bundle__') {
          const newSlots = { ...this.bundleSlotsByType }
          Object.keys(newSlots).forEach((pt) => {
            newSlots[pt] = newSlots[pt].slice(0, -1)
          })
          this.bundleSlotsByType = newSlots
        } else {
          const existing = [...(this.slotColorByOption1[option1Key] || [])]
          existing.pop()
          this.slotColorByOption1 = { ...this.slotColorByOption1, [option1Key]: existing }
        }
      },

      totalUnits() {
        return Object.values(this.quantityByOption1).reduce(
          (sum, q) => sum + (Number(q) || 0),
          0
        )
      },

      totalWeightedUnits() {
        const bundleQty = this.getQty('__bundle__')
        const regularQty = Object.entries(this.quantityByOption1)
          .filter(([key]) => key !== '__bundle__')
          .reduce((sum, [, q]) => sum + (Number(q) || 0), 0)
        return regularQty + bundleQty * 3
      },

      canAdvanceFromStep1() {
        if (this.totalUnits() === 0) return false
        if (!this.selectedCommitmentTerm) return false
        const bundleQty = this.getQty('__bundle__')
        if (bundleQty > 0) {
          const typeOrder = this.getBundleTypeOrder()
          for (let ti = 0; ti < typeOrder.length; ti++) {
            const slots = this.bundleSlotsByType[typeOrder[ti].productType] || []
            for (let i = 0; i < bundleQty; i++) {
              if (!slots[i]) return false
            }
          }
        }
        return true
      },

      // ── Swatch / slot helpers ────────────────────────────────────────
      getSwatchesForOption1(option1Key) {
        return this.swatchesByOption1[option1Key] || []
      },

      firstSwatchVariantIdForOption1(option1Key) {
        const swatches = this.getSwatchesForOption1(option1Key)
        if (swatches.length) return swatches[0].variantId
        // Fallback to the defaults map if no swatch data (single-option products)
        return this.defaultByOption1[option1Key] || null
      },

      getSlotVariantId(option1Key, slotIndex) {
        const slots = this.slotColorByOption1[option1Key] || []
        return slots[slotIndex] != null ? slots[slotIndex] : null
      },

      // ── Bundle slot helpers ──────────────────────────────────────────
      getBundleTypeOrder() {
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        const bundleOption1 = this.bundleVariant ? (this.bundleVariant.option1 || '') : ''
        return this.option1Order
          .filter((o1) => !bundleOption1 || o1 !== bundleOption1)
          .map((o1) => {
            for (let i = 0; i < rules.length; i++) {
              if (o1.indexOf(rules[i].match) !== -1) {
                const rule = rules[i]
                const compositeKey = rule.collectionFilter
                  ? rule.productType + '::' + rule.collectionFilter
                  : rule.productType
                return { option1: o1, productType: compositeKey, swatches: this.swatchesByOption1[o1] || [] }
              }
            }
            return null
          })
          .filter(Boolean)
      },

      getBundleUnitCount() {
        return this.getQty('__bundle__')
      },

      isBundleSlotSelected(productType, unitIdx, variantId) {
        const slots = this.bundleSlotsByType[productType] || []
        return slots[unitIdx] === variantId
      },

      setBundleSlotColor(productType, unitIdx, variantId) {
        const slots = [...(this.bundleSlotsByType[productType] || [])]
        slots[unitIdx] = variantId
        this.bundleSlotsByType = { ...this.bundleSlotsByType, [productType]: slots }
      },

      getBundleSlotColorName(productType, unitIdx) {
        const slots = this.bundleSlotsByType[productType] || []
        const variantId = slots[unitIdx]
        if (!variantId) return ''
        const v = this.variantsById[String(variantId)]
        return v ? (v.option2 || '') : ''
      },

      setSlotColor(option1Key, slotIndex, variantId) {
        const slots = [...(this.slotColorByOption1[option1Key] || [])]
        slots[slotIndex] = variantId
        this.slotColorByOption1 = { ...this.slotColorByOption1, [option1Key]: slots }
      },

      isSlotSwatchSelected(option1Key, slotIndex, variantId) {
        const current = this.getSlotVariantId(option1Key, slotIndex)
        return Number(current) === Number(variantId)
      },
      getSlotColorName(option1Key, slotIndex) {
        const variantId = this.getSlotVariantId(option1Key, slotIndex)
        const v = variantId ? this.variantsById[String(variantId)] : null
        return v ? (v.option2 || '') : ''
      },

      // ── Build flat bundle list ───────────────────────────────────────
      // Called when user clicks NEXT on Step 1.
      // Produces: [{ bundleId, variantId, option1, option2, productType }, ...]
      // opts.advance === false skips swiper navigation (used for direct ATC).
      buildBundles(opts) {
        const advance = !(opts && opts.advance === false)
        const order = this.option1Order.length
          ? this.option1Order
          : Object.keys(this.quantityByOption1)

        const bundles = []
        order.forEach((option1Key) => {
          const qty = this.getQty(option1Key)
          const slots = this.slotColorByOption1[option1Key] || []
          for (let i = 0; i < qty; i++) {
            const variantId =
              slots[i] != null
                ? slots[i]
                : this.firstSwatchVariantIdForOption1(option1Key)
            if (!variantId) continue
            const variant = this.getVariantById(variantId)
            if (!variant) continue
            const bundle = {
              bundleId: `_bundle_qty_${variantId}_s${i}_${Date.now()}_${Math.random()
                .toString(36)
                .slice(2, 7)}`,
              variantId: Number(variantId),
              option1: variant.option1 || option1Key,
              option2: variant.option2 || '',
            }
            bundle.productType = this.expectedAddonProductTypeForBundle(bundle)
            bundles.push(bundle)
          }
        })
        // Bundle card entries — one per type per unit
        const bundleQty = this.getQty('__bundle__')
        if (bundleQty > 0 && this.bundleVariant) {
          const typeOrder = this.getBundleTypeOrder()
          for (let unitIdx = 0; unitIdx < bundleQty; unitIdx++) {
            typeOrder.forEach((t) => {
              const slotVarId = (this.bundleSlotsByType[t.productType] || [])[unitIdx]
                || (t.swatches.length ? t.swatches[0].variantId : null)
              if (!slotVarId) return
              const variant = this.getVariantById(slotVarId)
              if (!variant) return
              const bEntry = {
                bundleId: `_bundle_qty_${slotVarId}_u${unitIdx}_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
                variantId: Number(slotVarId),
                option1: variant.option1 || t.option1,
                option2: variant.option2 || '',
                isBundle: true,
                bundleUnitIdx: unitIdx,
              }
              bEntry.productType = this.expectedAddonProductTypeForBundle(bEntry)
              bundles.push(bEntry)
            })
          }
        }

        this.bundles = bundles
        const newGroups = this.buildAddonTypeGroups(bundles)
        this.addonTypeGroups = newGroups

        // Preserve existing scent selections — clip to new limits, drop removed types
        const preserved = {}
        newGroups.forEach((group) => {
          const existing = this.addonQtyByType[group.productType] || {}
          const limit = group.count
          let total = 0
          const clipped = {}
          Object.entries(existing).forEach(([variantId, qty]) => {
            const q = Number(qty) || 0
            if (q <= 0) return
            const take = Math.min(q, limit - total)
            if (take > 0) { clipped[variantId] = take; total += take }
          })
          // Nothing selected yet: if exactly one in-stock oil is available for
          // this group, default it to 1 instead of leaving all oils at 0.
          if (total === 0 && limit > 0) {
            const availableRows = this.getAvailableAddonRowsForGroup(group)
            if (availableRows.length === 1) {
              clipped[String(availableRows[0].id)] = Math.min(1, limit)
            }
          }
          preserved[group.productType] = clipped
        })
        this.addonQtyByType = preserved

        if (!advance) return

        // After Alpine renders the new x-for slides, update Swiper and advance.
        this.$nextTick(() => {
          const root = this.pdpSwiperRootEl
          if (!root) return
          const rootEl = root.querySelector('.pdp-swiper__root')
          if (!rootEl || !rootEl.swiper) return
          rootEl.swiper.update()
          rootEl.swiper.slideTo(1, 700)
          if (typeof window !== 'undefined' && window.matchMedia &&
              window.matchMedia('(max-width: 989px)').matches) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }
        })
      },

      step1PrimaryClick() {
        if (!this.canAdvanceFromStep1() || this.addToCartLoading) return
        if (this.isPaidBestsellerDirectAtc()) {
          this.buildBundles({ advance: false })
          this.addReviewQtySetToCart()
          return
        }
        this.buildBundles()
      },

      // ── Variant lookup helpers ───────────────────────────────────────
      getVariantById(id) {
        if (!id) return null
        return this.variantsById[String(id)] || null
      },

      variantIsAvailable(v) {
        if (!v) return false
        return v.available !== false
      },

      // ── Image URL helper ─────────────────────────────────────────────
      imageUrlWithWidth(url, width) {
        const src = url != null ? String(url).trim() : ''
        const w = Number(width)
        if (!src) return ''
        if (!w || Number.isNaN(w) || w <= 0) return src
        if (src.includes(' width=')) return src
        if (/[?&]width=\d+/.test(src)) {
          return src.replace(/([?&]width=)\d+/, `$1${w}`)
        }
        const sep = src.includes('?') ? '&' : '?'
        return `${src}${sep}width=${w}`
      },

      // ── Card image helpers (used by aside snippet) ───────────────────
      getCardImageForOption1(option1Key) {
        // Returns the default variant's image for this option1 group
        const defaultId = this.defaultByOption1[option1Key]
        const v = this.getVariantById(defaultId)
        return v && v.image ? this.imageUrlWithWidth(v.image, 248) : ''
      },

      // ── Money formatters ─────────────────────────────────────────────
      formatPdpMoney(cents) {
        const n = Number(cents)
        if (cents == null || cents === '' || Number.isNaN(n)) return ''
        if (typeof window.formatMoney === 'function') {
          return window.formatMoney(n)
        }
        return String(n)
      },

      // ── Terms modal ──────────────────────────────────────────────────
      onTermsAcceptanceChange() {
        this.termsAcceptedAt = this.termsAccepted ? new Date().toISOString() : null
      },

      openTermsModal() {
        this.termsModalOpen = true
        document.body.style.overflow = 'hidden'
      },

      closeTermsModal() {
        this.termsModalOpen = false
        document.body.style.overflow = ''
      },

      // ── Addon product type resolution ────────────────────────────────
      isPaidBestsellerOption1(option1) {
        return String(option1 || '').toLowerCase().includes('bestseller')
      },

      // True when Step 1 selection is only paid bestseller set(s) (no free-promo units).
      isPaidBestsellerDirectAtc() {
        let hasBestseller = false
        let hasOther = false
        Object.entries(this.quantityByOption1 || {}).forEach(([key, qty]) => {
          if ((Number(qty) || 0) <= 0) return
          if (key === '__bundle__') {
            hasOther = true
            return
          }
          if (this.isPaidBestsellerOption1(key)) hasBestseller = true
          else hasOther = true
        })
        return hasBestseller && !hasOther
      },

      expectedAddonProductTypeForBundle(bundle) {
        if (!bundle || !bundle.option1) return null
        if (this.isPaidBestsellerOption1(bundle.option1)) return null
        const title = String(bundle.option1)
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        for (let i = 0; i < rules.length; i++) {
          if (title.indexOf(rules[i].match) !== -1) {
            const rule = rules[i]
            return rule.collectionFilter ? rule.productType + '::' + rule.collectionFilter : rule.productType
          }
        }
        return null
      },

      // ── Swiper navigation helpers ────────────────────────────────────
      slideTo(idx) {
        const root = this.pdpSwiperRootEl
        if (!root) return
        const rootEl = root.querySelector('.pdp-swiper__root')
        if (!rootEl || !rootEl.swiper) return
        rootEl.swiper.slideTo(idx, 700)
      },

      advanceAddonStep() {
        const root = this.pdpSwiperRootEl
        if (!root) return
        const rootEl = root.querySelector('.pdp-swiper__root')
        if (!rootEl || !rootEl.swiper) return
        rootEl.swiper.slideNext()
        if (typeof window !== 'undefined' && window.matchMedia &&
            window.matchMedia('(max-width: 989px)').matches) {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      },

      // ── Mobile CTA helpers ───────────────────────────────────────────
      mobileNextDisabled() {
        const reviewIdx = this.reviewSlideIndex()
        if (this.currentSwiperIndex === reviewIdx) {
          if (this.addToCartLoading) return true
          if (this.requiresFreePromoTerms() && !this.termsAccepted) return true
          return false
        }
        if (this.currentSwiperIndex === 0) {
          if (this.addToCartLoading) return true
          return !this.canAdvanceFromStep1()
        }
        if (this.isFrequencySlideIndex(this.currentSwiperIndex)) return false
        const groupIdx = this.scentGroupIndexFromSlide(this.currentSwiperIndex)
        const group = groupIdx != null ? this.addonTypeGroups[groupIdx] : null
        if (!group) return true
        return !this.canAdvanceFromTypeStep(group)
      },

      mobileNextClick() {
        const reviewIdx = this.reviewSlideIndex()
        if (this.currentSwiperIndex === reviewIdx) {
          this.addReviewQtySetToCart()
        } else if (this.currentSwiperIndex === 0) {
          this.step1PrimaryClick()
        } else {
          this.advanceAddonStep()
        }
      },

      frequencyStepEnabled() {
        return !!this.frequencyStep && !this.subscriptionOnly
      },

      // ── Commitment term (12/24/36 month) — now selected on Step 1 itself,
      // alongside the diffuser card. No dedicated slide/index of its own.
      setCommitmentTerm(months) {
        this.selectedCommitmentTerm = months
      },

      isCommitmentTermSelected(months) {
        return this.selectedCommitmentTerm === months
      },

      commitmentTermPriceDisplay(option) {
        return this.formatPdpMoney(Number(option.discountedPrice) || 0)
      },

      commitmentTermCompareDisplay(option) {
        return this.formatPdpMoney(Number(option.basePrice) || 0)
      },

      flowSlides() {
        const slides = []
        this.addonTypeGroups.forEach((group, groupIdx) => {
          if (this.frequencyStepEnabled()) {
            slides.push({
              kind: 'frequency',
              group,
              groupIdx,
              key: 'freq-' + group.productType,
            })
          }
          slides.push({
            kind: 'scent',
            group,
            groupIdx,
            key: 'scent-' + group.productType,
          })
        })
        return slides
      },

      scentSlideIndex(groupIdx) {
        const i = Number(groupIdx || 0)
        return this.frequencyStepEnabled() ? 1 + i * 2 + 1 : 1 + i
      },

      frequencySlideIndex(groupIdx) {
        return 1 + Number(groupIdx || 0) * 2
      },

      reviewSlideIndex() {
        const n = this.addonTypeGroups.length
        return this.frequencyStepEnabled() ? 1 + n * 2 : 1 + n
      },

      isFrequencySlideIndex(idx) {
        if (!this.frequencyStepEnabled()) return false
        const reviewIdx = this.reviewSlideIndex()
        if (idx < 1 || idx >= reviewIdx) return false
        return (idx - 1) % 2 === 0
      },

      scentGroupIndexFromSlide(idx) {
        if (idx < 1 || idx >= this.reviewSlideIndex()) return null
        if (!this.frequencyStepEnabled()) {
          return idx - 1 < this.addonTypeGroups.length ? idx - 1 : null
        }
        const mid = idx - 1
        if (mid % 2 !== 1) return null
        return (mid - 1) / 2
      },

      frequencyStepSubheadline(groupIdx) {
        return 'Step ' + (this.frequencySlideIndex(groupIdx) + 1) + ': Select delivery frequency'
      },

      selectedAddonIdsForGroup(group) {
        if (!group) return []
        const typeMap = this.addonQtyByType[group.productType] || {}
        return Object.keys(typeMap)
          .filter((id) => (Number(typeMap[id]) || 0) > 0)
          .map((id) => Number(id))
      },

      frequencyStepSampleVariantId(group) {
        // Frequency step precedes oil selection, so presume pricing/discount
        // based on the first available oil in the next (scent) step.
        const rows = this.getAddonRowsForGroup(group)
        if (rows.length) return Number(rows[0].id)
        const selected = this.selectedAddonIdsForGroup(group)
        return selected.length ? selected[0] : null
      },

      getGroupPurchaseMode(group) {
        if (!group) return 'subscription'
        const stored = this.groupPurchaseModeByType[group.productType]
        if (stored === 'one_time' || stored === 'subscription') return stored
        const ids = this.selectedAddonIdsForGroup(group)
        if (ids.length) return this.getAddonPurchaseMode(ids[0])
        return 'subscription'
      },

      setGroupPurchaseMode(group, mode) {
        if (!group || this.subscriptionOnly) return
        const next = mode === 'one_time' ? 'one_time' : 'subscription'
        this.groupPurchaseModeByType = {
          ...this.groupPurchaseModeByType,
          [group.productType]: next,
        }
        this.selectedAddonIdsForGroup(group).forEach((id) => this.setAddonPurchaseMode(id, next))
      },

      frequencyStepPricing(group, mode) {
        const id = this.frequencyStepSampleVariantId(group)
        const row = this.addonRowById(id)
        if (!row) return { price: 0, compareAtPrice: 0 }
        return this.normalizedPricing(row, mode === 'one_time' ? 'one_time' : 'subscription')
      },

      frequencyStepPriceDisplay(group, mode) {
        const p = this.frequencyStepPricing(group, mode)
        return this.formatPdpMoney(p.price)
      },

      frequencyStepCompareDisplay(group, mode) {
        const p = this.frequencyStepPricing(group, mode)
        if (!(Number(p.compareAtPrice) > Number(p.price))) return ''
        return this.formatPdpMoney(p.compareAtPrice)
      },

      frequencyStepHasCompare(group, mode) {
        const p = this.frequencyStepPricing(group, mode)
        return Number(p.compareAtPrice) > Number(p.price)
      },

      frequencyStepSavePercent(group) {
        const p = this.frequencyStepPricing(group, 'subscription')
        const compareAt = Number(p.compareAtPrice || 0)
        const price = Number(p.price || 0)
        if (!compareAt || compareAt <= 0 || compareAt <= price) return ''
        return String(Math.round(((compareAt - price) / compareAt) * 100))
      },

      // ── Addon type group builder ─────────────────────────────────────
      buildAddonTypeGroups(bundles) {
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        const seen = []
        const map = {}
        bundles.forEach((bundle) => {
          // Paid bestseller sets already include scents — no oil/frequency step.
          if (this.isPaidBestsellerOption1(bundle.option1)) return
          const compositeKey = bundle.productType || '__none__'
          if (!map[compositeKey]) {
            const o1 = bundle.option1 || ''
            let realProductType = compositeKey
            let collectionFilter = null
            for (let i = 0; i < rules.length; i++) {
              if (o1.indexOf(rules[i].match) !== -1) {
                realProductType = rules[i].productType
                collectionFilter = rules[i].collectionFilter || null
                break
              }
            }
            map[compositeKey] = { productType: compositeKey, realProductType, count: 0, bundles: [], collectionFilter }
            seen.push(compositeKey)
          }
          map[compositeKey].count++
          map[compositeKey].bundles.push(bundle)
        })
        return seen.map((key, idx) => ({
          ...map[key],
          label: 'Oils ' + (idx + 1),
        }))
      },

      // ── Addon step helpers ───────────────────────────────────────────
      getAvailableAddonRowsForGroup(group) {
        const productType = group ? (group.realProductType || group.productType) : null
        const collectionFilter = group ? (group.collectionFilter || null) : null
        const rows = Object.values(this.addonVariantsById).filter((row) => row && row.available !== false)
        return (!productType || productType === '__none__')
          ? rows
          : rows.filter((row) => {
              if (row.productType !== productType) return false
              if (collectionFilter && row.collectionName !== collectionFilter) return false
              return true
            })
      },

      getAddonRowsForGroup(group) {
        const qtyKey = group ? group.productType : null
        const filtered = this.getAvailableAddonRowsForGroup(group)
        const preview = filtered.slice(0, 5)
        const previewIds = {}
        preview.forEach((row) => {
          previewIds[String(row.id)] = true
        })
        const extras = []
        const typeMap = qtyKey ? (this.addonQtyByType[qtyKey] || {}) : {}
        Object.keys(typeMap).forEach((id) => {
          if ((Number(typeMap[id]) || 0) <= 0) return
          if (previewIds[String(id)]) return
          const row = this.addonRowById(id)
          if (row && row.available !== false) extras.push(row)
        })
        return preview.concat(extras)
      },

      getAddonQty(productType, variantId) {
        const typeMap = this.addonQtyByType[productType] || {}
        return typeMap[String(variantId)] || 0
      },

      incrementAddonQty(productType, variantId) {
        const limit = this.addonTypeLimit(productType)
        if (this.addonTypeTotal(productType) >= limit) return
        const typeMap = { ...(this.addonQtyByType[productType] || {}) }
        typeMap[String(variantId)] = (typeMap[String(variantId)] || 0) + 1
        this.addonQtyByType = { ...this.addonQtyByType, [productType]: typeMap }
        if (this.frequencyStepEnabled()) {
          const mode = this.groupPurchaseModeByType[productType] || 'subscription'
          this.setAddonPurchaseMode(variantId, mode)
        }
      },

      decrementAddonQty(productType, variantId) {
        const typeMap = { ...(this.addonQtyByType[productType] || {}) }
        const current = typeMap[String(variantId)] || 0
        if (current <= 0) return
        typeMap[String(variantId)] = current - 1
        this.addonQtyByType = { ...this.addonQtyByType, [productType]: typeMap }
      },

      addonTypeTotal(productType) {
        const typeMap = this.addonQtyByType[productType] || {}
        return Object.values(typeMap).reduce((sum, q) => sum + (Number(q) || 0), 0)
      },

      addonTypeLimit(productType) {
        const group = this.addonTypeGroups.find((g) => g.productType === productType)
        return group ? group.count : 0
      },

      canAdvanceFromTypeStep(group) {
        if (!group) return false
        return this.addonTypeTotal(group.productType) === this.addonTypeLimit(group.productType)
      },

      addonTypeSubheadline(group) {
        if (!group) return ''
        const n = group.count
        const unit = n === 1 ? 'Oil' : 'Oils'
        const option1s = [...new Set((group.bundles || []).map((b) => b.option1 || '').filter(Boolean))]
        const name = option1s.length > 1 ? 'Diffusers' : (option1s[0] || '')
        return `Choose at least <strong>${n} ${unit}</strong> for the ${name}`
      },

      // ── resolvedPairings: expand addonQtyByType into per-bundle pairs ─
      resolvedPairings() {
        const pairs = []
        const covered = {}
        this.addonTypeGroups.forEach((group) => {
          const typeMap = this.addonQtyByType[group.productType] || {}
          // Expand qty map into flat ordered list of addonVariantIds
          const scentList = []
          Object.entries(typeMap).forEach(([variantId, qty]) => {
            for (let i = 0; i < qty; i++) scentList.push(Number(variantId))
          })
          // Zip sequentially with bundles
          group.bundles.forEach((bundle, idx) => {
            covered[bundle.bundleId] = true
            pairs.push({ bundle, addonVariantId: scentList[idx] || null })
          })
        })
        // Paid bestseller (and any other non-grouped) bundles still need a review/ATC pairing
        ;(this.bundles || []).forEach((bundle) => {
          if (!bundle || covered[bundle.bundleId]) return
          pairs.push({ bundle, addonVariantId: null })
        })
        return pairs
      },

      getBundleDiffuserImage(bundle, width) {
        if (!bundle) return ''
        const variant = this.getVariantById(bundle.variantId)
        if (!variant || !variant.image) return ''
        return this.imageUrlWithWidth(variant.image, width || 2000)
      },

      formatStepText(stepNumber) {
        const tmpl = this.stepTextTemplate || 'Step {step_number}: Choose your scent.'
        return tmpl.replace('{step_number}', String(stepNumber))
      },

      // ── Addon pricing ────────────────────────────────────────────────
      mappedDiscountPercentForType(productType) {
        const pt = productType != null ? String(productType).trim() : ''
        if (!pt) return null
        const rules = parseDiscountByProductTypeRules(this.discountByProductTypeMap)
        for (let i = 0; i < rules.length; i++) {
          if (rules[i].productType === pt) return Number(rules[i].percent)
        }
        return null
      },

      selectedCommitmentTermPercent() {
        const opt = (this.commitmentTermOptions || []).find(
          (t) => Number(t.months) === Number(this.selectedCommitmentTerm)
        )
        return opt ? Number(opt.savePercent) : null
      },

      getAddonPurchaseMode(variantId) {
        if (this.subscriptionOnly) return 'subscription'
        const key = String(variantId)
        const mode = this.addonPurchaseModeById[key]
        return mode === 'one_time' ? 'one_time' : 'subscription'
      },

      setAddonPurchaseMode(variantId, mode) {
        if (this.subscriptionOnly) return
        const next = mode === 'one_time' ? 'one_time' : 'subscription'
        this.addonPurchaseModeById = {
          ...this.addonPurchaseModeById,
          [String(variantId)]: next,
        }
      },

      isAddonSubscription(variantId) {
        return this.getAddonPurchaseMode(variantId) === 'subscription'
      },

      normalizedPricing(v, mode) {
        if (!v) return { price: 0, compareAtPrice: 0 }
        const originalPrice = Number(v.price || 0)
        const originalCompare = Number(v.compareAtPrice || 0)
        const purchaseMode = mode || 'subscription'
        if (purchaseMode === 'one_time') {
          return { price: originalPrice, compareAtPrice: originalCompare }
        }
        const mappedPct = this.selectedCommitmentTermPercent()
        if (mappedPct == null) return { price: originalPrice, compareAtPrice: originalCompare }
        const hasOriginalCompare = originalCompare > originalPrice && originalCompare > 0
        if (hasOriginalCompare) {
          const currentPct = ((originalCompare - originalPrice) / originalCompare) * 100
          if (currentPct > mappedPct) return { price: originalPrice, compareAtPrice: originalCompare }
        }
        const base = hasOriginalCompare ? originalCompare : originalPrice
        if (base <= 0) return { price: originalPrice, compareAtPrice: originalCompare }
        const discounted = Math.max(0, Math.round((base * (100 - mappedPct)) / 100))
        if (discounted >= base) return { price: originalPrice, compareAtPrice: originalCompare }
        return { price: discounted, compareAtPrice: base }
      },

      addonRowById(variantId) {
        return this.addonVariantsById[String(variantId)] || null
      },

      normalizedAddonRowById(id) {
        const row = this.addonRowById(id)
        if (!row) return null
        return this.normalizedPricing(row, this.getAddonPurchaseMode(id))
      },

      addonHasCompare(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return false
        return Number(p.compareAtPrice) > Number(p.price)
      },

      addonDisplayCompare(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return ''
        return this.formatPdpMoney(p.compareAtPrice)
      },

      addonDisplayPrice(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return ''
        return this.formatPdpMoney(p.price)
      },

      addonSavePercent(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return ''
        const compareAt = Number(p.compareAtPrice || 0)
        const price = Number(p.price || 0)
        if (!compareAt || compareAt <= 0 || compareAt <= price) return ''
        return String(Math.round(((compareAt - price) / compareAt) * 100))
      },

      // ── Feature metadata (How it works / Subscription perks / Why Aroma360) ──
      getFeatureMetadata() {
        // Use the first option1 group with qty > 0; fallback to first variant overall
        const activeOption1 = this.option1Order.find(
          (key) => this.getQty(key) > 0
        )
        const variantId = activeOption1
          ? this.defaultByOption1[activeOption1]
          : Object.values(this.defaultByOption1)[0]
        const v = this.getVariantById(variantId)
        if (v && v.featureMetadata && v.featureMetadata.length) return v.featureMetadata
        // Fallback: any variant for the same option1 that has metadata
        const option1 = v ? v.option1 : null
        if (option1) {
          const match = Object.values(this.variantsById).find(
            (vv) => vv.option1 === option1 && vv.featureMetadata && vv.featureMetadata.length
          )
          if (match) return match.featureMetadata
        }
        return []
      },

      // ── Addon scent data ─────────────────────────────────────────────
      getAddonScentProfile(variantId) {
        const row = this.addonRowById(variantId)
        if (!row) return []
        return Array.isArray(row.scentProfile) ? row.scentProfile : []
      },

      getAddonScentMoods(variantId) {
        const row = this.addonRowById(variantId)
        if (!row) return []
        return Array.isArray(row.scentMoods) ? row.scentMoods : []
      },

      getAddonScentNotes(variantId) {
        const row = this.addonRowById(variantId)
        return row && row.scentNotes ? row.scentNotes : ''
      },

      // ── Review step helpers ──────────────────────────────────────────

      reviewAddonRowForBundle(bundle) {
        if (!bundle) return null
        const pair = this.resolvedPairings().find(
          (p) => p.bundle.bundleId === bundle.bundleId
        )
        if (!pair || !pair.addonVariantId) return null
        return this.addonRowById(pair.addonVariantId) || null
      },

      reviewMainVariant(bundle) {
        if (!bundle) return null
        return this.getVariantById(bundle.variantId)
      },

      reviewMainDisplayPrice(bundle) {
        const v = this.reviewMainVariant(bundle)
        if (!v) return ''
        const cents = this.isPaidBestsellerOption1(bundle && bundle.option1)
          ? Number(v.realPrice != null ? v.realPrice : v.price) || 0
          : Number(v.price != null ? v.price : v.realPrice) || 0
        return this.formatPdpMoney(cents)
      },

      reviewMainDisplayCompare(bundle) {
        const v = this.reviewMainVariant(bundle)
        if (!v) return ''
        const c = Number(v.compareAtPrice || 0)
        if (!c || c <= 0) return ''
        return this.formatPdpMoney(c)
      },

      reviewMainHasCompare(bundle) {
        const v = this.reviewMainVariant(bundle)
        if (!v) return false
        const price = this.isPaidBestsellerOption1(bundle && bundle.option1)
          ? Number(v.realPrice != null ? v.realPrice : v.price) || 0
          : Number(v.price != null ? v.price : v.realPrice) || 0
        const compare = Number(v.compareAtPrice || 0)
        return compare > price
      },

      reviewSumPriceCents() {
        return this.resolvedPairings().reduce((total, pair) => {
          let sum = total
          const isPaidSet = this.isPaidBestsellerOption1(pair.bundle && pair.bundle.option1)
          if (!this.freePromo || isPaidSet) {
            const main = this.getVariantById(pair.bundle.variantId)
            if (main) {
              sum += isPaidSet
                ? Number(main.realPrice != null ? main.realPrice : main.price) || 0
                : Number(main.price != null ? main.price : main.realPrice) || 0
            }
          }
          if (!pair.addonVariantId) return sum
          const row = this.normalizedAddonRowById(pair.addonVariantId)
          return sum + (row ? Number(row.price) || 0 : 0)
        }, 0)
      },

      reviewSumCompareAtCents() {
        return this.resolvedPairings().reduce((total, pair) => {
          let sum = total
          const isPaidSet = this.isPaidBestsellerOption1(pair.bundle && pair.bundle.option1)
          if (!this.freePromo || isPaidSet) {
            const main = this.getVariantById(pair.bundle.variantId)
            if (main) {
              const fallback = isPaidSet
                ? Number(main.realPrice != null ? main.realPrice : main.price) || 0
                : Number(main.price != null ? main.price : main.realPrice) || 0
              sum += Number(main.compareAtPrice) || fallback
            }
          }
          if (!pair.addonVariantId) return sum
          const row = this.normalizedAddonRowById(pair.addonVariantId)
          return sum + (row ? Number(row.compareAtPrice) || Number(row.price) || 0 : 0)
        }, 0)
      },

      reviewHasSubscription() {
        return this.resolvedPairings().some((pair) => {
          if (!pair.addonVariantId) return false
          return this.isAddonSubscription(pair.addonVariantId)
        })
      },

      // Step 1 bundle card stores qty under __bundle__; its option1 is bundleVariantId.
      selectedStep1OptionNames() {
        const names = []
        Object.entries(this.quantityByOption1 || {}).forEach(([key, qty]) => {
          if ((Number(qty) || 0) <= 0) return
          if (key === '__bundle__') {
            const bundleName = String(
              (this.bundleVariant && this.bundleVariant.option1) || this.bundleVariantId || ''
            ).trim()
            if (bundleName) names.push(bundleName)
            return
          }
          names.push(String(key).trim())
        })
        return names
      },

      reviewShippingNote() {
        const target = 'mini 2.0 + smart car diffuser + kube'
        const selected = this.selectedStep1OptionNames().some((name) => {
          return String(name || '')
            .replace(/\u2122/g, '')
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase() === target
        })
        const onDavinciTemplate = this.templateSuffix === 'davinci-2-0' || this.templateSuffix === 'large-diffuser-free-flow'
        return onDavinciTemplate || selected ? '+$9.95 Shipping' : '+$9.95 Shipping'
      },

      reviewSubscriptionSumPriceCents() {
        return this.resolvedPairings().reduce((total, pair) => {
          if (!pair.addonVariantId) return total
          if (!this.isAddonSubscription(pair.addonVariantId)) return total
          const row = this.normalizedAddonRowById(pair.addonVariantId)
          return total + (row ? Number(row.price) || 0 : 0)
        }, 0)
      },

      formatPdpMoneyOrFree(cents) {
        const n = Number(cents)
        if (!n || n <= 0) return 'FREE'
        return this.formatPdpMoney(n)
      },

      // ── Cart helpers (mirror existing section) ───────────────────────

      buildBundleId(mainVariantId, addonVariantId) {
        return `_bundle_${mainVariantId}_${addonVariantId}_plan_30_ts_${Date.now()}`
      },

      compareAtCentsString(variantRow) {
        if (!variantRow) return '0'
        const c = Number(variantRow.compareAtPrice || 0)
        if (!c || c <= 0) return '0'
        return String(Math.round(c))
      },

      compareDiscountPercentString(variantRow) {
        if (!variantRow) return '0'
        const cap = Number(variantRow.compareAtPrice || 0)
        const price = Number(variantRow.price || 0)
        if (!cap || cap <= 0 || cap <= price) return '0'
        const pct = Math.round(((cap - price) / cap) * 100)
        return String(Math.max(0, pct))
      },

      buildBundleLineProperties(variantRow, bundleId, tosAcceptedAt, applyFreePromo) {
        const props = {
          _bundle_id: bundleId,
          _bundle_identifier: 'true',
          _compare_at_price: this.compareAtCentsString(variantRow),
          _compare_at_price_discount: this.compareDiscountPercentString(variantRow),
        }
        if (applyFreePromo) {
          props._bundle_promo = 'free-large-diffuser-promo'
          props._free_diffuser_tos_aceptance =
            tosAcceptedAt != null && tosAcceptedAt !== '' ? String(tosAcceptedAt) : ''
        }
        return props
      },

      diffuserTypeSlug(option1) {
        return (option1 && this.diffuserTypeSlugByOption1[option1]) || ''
      },

      // Shared by both the diffuser line and its paired oil line — both need
      // _diffuser_promo / _promo_term so backend automation can see the promo
      // and term on every line in the bundle, not just the diffuser.
      buildPromoLineProperties(variantRow, bundleId, tosAcceptedAt, applyFreePromo, diffuserOption1) {
        const props = this.buildBundleLineProperties(variantRow, bundleId, tosAcceptedAt, applyFreePromo)
        props._diffuser_promo = this.diffuserPromo || ''
        const slug = this.diffuserTypeSlug(diffuserOption1)
        const term = this.selectedCommitmentTerm != null ? String(this.selectedCommitmentTerm) : ''
        props._promo_term = slug && term ? slug + '-term-' + term : ''
        return props
      },

      requiresFreePromoTerms() {
        if (!this.freePromo) return false
        const bundles = this.bundles || []
        if (!bundles.length) return true
        // Paid bestseller-only carts are not part of the free diffuser promo
        return bundles.some((b) => !this.isPaidBestsellerOption1(b.option1))
      },

      // ── Add to cart ──────────────────────────────────────────────────

      async addReviewQtySetToCart() {
        if (this.addToCartLoading) return
        if (this.requiresFreePromoTerms() && !this.termsAccepted) return
        this.addToCartLoading = true
        try {
          const applyFreePromo = this.requiresFreePromoTerms()
          const tosAt = applyFreePromo ? this.termsAcceptedAt : null
          const items = []

          for (const pair of this.resolvedPairings()) {
            const bundle = pair.bundle
            const mainVariant = this.getVariantById(bundle.variantId)
            if (!mainVariant) continue

            const isPaidSet = this.isPaidBestsellerOption1(bundle.option1)
            const lineFreePromo = applyFreePromo && !isPaidSet
            const mainForProps = isPaidSet
              ? { ...mainVariant, price: Number(mainVariant.realPrice != null ? mainVariant.realPrice : mainVariant.price) || 0 }
              : mainVariant

            const addonRow = pair.addonVariantId ? this.addonRowById(pair.addonVariantId) : null
            const addonEligible = addonRow && addonRow.available !== false
            const resolvedAddonId = addonEligible ? Number(pair.addonVariantId) : 0

            const bundleId = this.buildBundleId(Number(bundle.variantId), resolvedAddonId)

            // Diffuser line item
            items.push({
              id: Number(bundle.variantId),
              quantity: 1,
              properties: this.buildPromoLineProperties(mainForProps, bundleId, tosAt, lineFreePromo, bundle.option1),
            })

            // Scent line item
            if (addonEligible) {
              const addonLine = {
                id: resolvedAddonId,
                quantity: 1,
                properties: this.buildPromoLineProperties(addonRow, bundleId, tosAt, lineFreePromo, bundle.option1),
              }
              if (this.isAddonSubscription(resolvedAddonId)) {
                const sp = addonRow.sellingPlanId
                if (sp != null && sp !== '') {
                  addonLine.selling_plan = Number(sp)
                  addonLine.properties._notes = 'Initial Subscription Order'
                }
              }
              items.push(addonLine)
            }
          }

          if (!items.length) return

          const rootPath =
            typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/'

          const res = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items }),
          })
          const data = await res.json().catch(() => ({}))
          if (!res.ok || data.status === 422) {
            console.error('[pdp-swiper-ldff] cart/add error:', data)
            return
          }

          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'))
          document.dispatchEvent(new CustomEvent('eurus:cart:redirect'))
        } catch (err) {
          console.error('[pdp-swiper-ldff] addReviewQtySetToCart error:', err)
        } finally {
          this.addToCartLoading = false
        }
      },

      // ── Popup (Learn More) ──────────────────────────────────────────
      openVariantPopup(option1Key) {
        this.popupOption1 = option1Key
        const id = this.defaultByOption1[option1Key]
        const v = id ? this.variantsById[String(id)] : null
        if (!v) {
          const fallback = Object.values(this.variantsById).find((vv) => vv.option1 === option1Key)
          if (!fallback) return
          this.popupVariant = fallback
        } else {
          this.popupVariant = v
        }
        this.popupOpen = true
        this.popupSectionsHtml = ''
        this.$nextTick(() => {
          this.fetchPopupSections(this.popupLinkedProductHandle())
        })
      },
      closePopup() {
        this.popupOpen = false
        this.popupVariant = null
        this.popupOption1 = null
      },
      popupAccordionItems() {
        const option1 = this.popupOption1
        const all = Object.values(this.variantsById)
        const match = all.find((v) => v.option1 === option1 && v.accordionItems?.length)
        return match?.accordionItems || this.popupVariant?.accordionItems || []
      },
      popupLinkedProductHandle() {
        const items = this.popupAccordionItems()
        const item = items.find((i) => i.linkedProductHandle)
        return item?.linkedProductHandle || null
      },
      _initPopupSectionAnimations() {
        const container = this.$refs.popupSections
        if (!container) return
        const store = Alpine.store('xScrollPromotion')
        if (store) {
          const bannerEl = container.querySelector('.el_animate')?.closest('[class*="section-"]')
          if (bannerEl) { store.load(bannerEl); return }
        }
        container.querySelectorAll('.el_animate').forEach((el) => {
          el.classList.add('animate-scroll-banner')
        })
      },
      async fetchPopupSections(handle) {
        if (!handle) return
        if (this.popupSectionsCache[handle] !== undefined) {
          this.popupSectionsHtml = this.popupSectionsCache[handle]
          await this.$nextTick()
          this._initPopupSectionAnimations()
          return
        }
        const items = this.popupAccordionItems()
        const sourceItem = items.find((i) => i.linkedProductHandle === handle)
        let sectionIds = [sourceItem?.popupSection1, sourceItem?.popupSection2].filter(Boolean)
        if (sectionIds.length === 0) {
          const sectionMap = {
            'mini360-scent-diffuser': ['scrolling_banner_JGUym3', 'grid_blocks_mp494W'],
            'smart-car-diffuser': ['scrolling_banner_3aBXMF', 'image_with_text_LtBR7i']
          }
          sectionIds = sectionMap[handle] || []
        }
        const ratingId = 'pdp-popup-okendo-rating'
        try {
          const res = await fetch(`${window.location.origin}/products/${handle}`)
          const html = await res.text()
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          const ratingSection = doc.querySelector(`#shopify-section-${ratingId}`)
          if (ratingSection && this.popupVariant) {
            const tmp = document.createElement('div')
            tmp.innerHTML = ratingSection.outerHTML
            const el = tmp.querySelector('[data-popup-okendo-rating]')
            if (el) {
              try {
                const rd = JSON.parse(el.textContent)
                this.popupVariant = { ...this.popupVariant, reviewCount: rd.reviewCount, reviewRating: rd.reviewRating }
              } catch(e) {}
            }
          }
          let sectionHtml = ''
          sectionIds.forEach((sectionSuffix) => {
            const section = doc.querySelector(`[id*="${sectionSuffix}"]`)
            if (section) sectionHtml += section.outerHTML
          })
          this.popupSectionsCache[handle] = sectionHtml
          this.popupSectionsHtml = sectionHtml
          await this.$nextTick()
          this._initPopupSectionAnimations()
        } catch (e) {
          console.error('Error fetching popup sections:', e)
          this.popupSectionsCache[handle] = ''
          this.popupSectionsHtml = ''
        }
      },
      popupSelectSwatch(variantId) {
        const v = this.variantsById[String(variantId)]
        if (v) this.popupVariant = v
      },
      popupSwatches() {
        if (!this.popupOption1) return []
        const swatches = []
        const seen = {}
        Object.values(this.variantsById).forEach((v) => {
          if (v.option1 !== this.popupOption1) return
          if (!v.available) return
          if (!v.option2 || seen[v.option2]) return
          seen[v.option2] = true
          swatches.push({ id: v.id, label: v.option2, bg: v.swatchBg || '#e0e0e0' })
        })
        return swatches
      },
      isPopupSwatchActive(variantId) {
        return this.popupVariant && Number(this.popupVariant.id) === Number(variantId)
      },
      popupFeatures() {
        if (!this.popupVariant) return []
        return Array.isArray(this.popupVariant.allFeatures) ? this.popupVariant.allFeatures : []
      },
      popupTitle() {
        if (!this.popupVariant) return ''
        return this.popupVariant.option1 || this.popupVariant.title || ''
      },
      popupImage() {
        if (!this.popupVariant) return ''
        return this.popupVariant.image || ''
      },
      popupCompareAtPrice() {
        if (!this.popupVariant) return ''
        const c = Number(this.popupVariant.compareAtPrice || 0)
        const p = Number(this.popupVariant.realPrice || this.popupVariant.price || 0)
        if (c > p) return this.formatPdpMoney(c)
        return ''
      },
      popupShowsFreePrice() {
        if (!this.freePromo) return false
        const o1 =
          (this.popupVariant && this.popupVariant.option1) ||
          this.popupOption1 ||
          ''
        // Paid bestseller sets show catalog price in the learn-more popup
        if (this.isPaidBestsellerOption1(o1)) return false
        return true
      },
      popupCurrentPrice() {
        if (!this.popupVariant) return ''
        return this.formatPdpMoney(
          Number(this.popupVariant.realPrice != null ? this.popupVariant.realPrice : this.popupVariant.price) || 0
        )
      },
      richTextToHtml(json) {
        if (!json) return ''
        let tree
        try { tree = typeof json === 'string' ? JSON.parse(json) : json }
        catch (e) { return json }
        function walk(node) {
          if (!node) return ''
          if (node.type === 'text') {
            let t = (node.value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            if (node.bold)   t = '<strong>' + t + '</strong>'
            if (node.italic) t = '<em>' + t + '</em>'
            if (node.code)   t = '<code>' + t + '</code>'
            return t
          }
          const inner = (node.children || []).map(walk).join('')
          switch (node.type) {
            case 'root':      return inner
            case 'paragraph': return '<p>' + inner + '</p>'
            case 'heading':   return '<h' + node.level + '>' + inner + '</h' + node.level + '>'
            case 'list':      return node.listType === 'ordered' ? '<ol>' + inner + '</ol>' : '<ul>' + inner + '</ul>'
            case 'list-item': return '<li>' + inner + '</li>'
            case 'link':      return '<a href="' + (node.url || '') + '"' + (node.target ? ' target="' + node.target + '"' : '') + '>' + inner + '</a>'
            default:          return inner
          }
        }
        return walk(tree)
      },

      // ── Review image ────────────────────────────────────────────────
      reviewMappedImageUrl() {
        const bundles = this.bundles || []
        const option1 = bundles.length ? (bundles[0].option1 || '') : ''
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        let productType = null
        for (let i = 0; i < rules.length; i++) {
          if (option1.indexOf(rules[i].match) !== -1) { productType = rules[i].productType; break }
        }
        const mappings = Array.isArray(this.reviewImageMappings) ? this.reviewImageMappings : []
        for (let i = 0; i < mappings.length; i++) {
          const row = mappings[i] || {}
          const rowRules = parseQtyAddonProductTypeRules(row.map || '')
          for (let j = 0; j < rowRules.length; j++) {
            const matches = productType
              ? rowRules[j].productType === productType
              : option1.indexOf(rowRules[j].match) !== -1
            if (matches && row.imageUrl) return row.imageUrl
          }
        }
        // No merchant-configured mapping matched — fall back to the actual
        // selected diffuser variant's image (correct color) rather than a
        // single static product photo that ignores which color was chosen.
        if (bundles.length) {
          const dynamic = this.getBundleDiffuserImage(bundles[0], 2000)
          if (dynamic) return dynamic
        }
        return this.productFeaturedImage || ''
      },

      // ── Addon popup ──────────────────────────────────────────────────
      openAddonPopup(addonVariantId) {
        const v = this.addonRowById(addonVariantId)
        if (v) {
          this.addonPopupVariant = v
          this.addonPopupOpen = true
          this.addonPopupSectionsHtml = ''
          this.$nextTick(() => {
            this.fetchAddonPopupSections(v.handle)
          })
        }
      },
      closeAddonPopup() {
        this.addonPopupOpen = false
        this.addonPopupVariant = null
      },
      addonPopupTitle() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.cardTitle || ''
      },
      addonPopupImage() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.cardImage || ''
      },
      addonPopupPrice() {
        if (!this.addonPopupVariant) return ''
        return this.addonDisplayPrice(this.addonPopupVariant.id)
      },
      addonPopupCompareAtPrice() {
        if (!this.addonPopupVariant) return ''
        return this.addonDisplayCompare(this.addonPopupVariant.id)
      },
      addonPopupHasCompare() {
        if (!this.addonPopupVariant) return false
        return this.addonHasCompare(this.addonPopupVariant.id)
      },
      addonPopupSavePercent() {
        if (!this.addonPopupVariant) return ''
        const pct = this.addonSavePercent(this.addonPopupVariant.id)
        return pct ? pct + '%' : ''
      },
      addonPopupScentProfile() {
        if (!this.addonPopupVariant) return []
        return Array.isArray(this.addonPopupVariant.scentProfile) ? this.addonPopupVariant.scentProfile : []
      },
      addonPopupScentMoods() {
        if (!this.addonPopupVariant) return []
        return Array.isArray(this.addonPopupVariant.scentMoods) ? this.addonPopupVariant.scentMoods : []
      },
      addonPopupInspiredBy() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.inspiredBy || ''
      },
      addonPopupDescription() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.description || ''
      },
      _initAddonPopupSectionAnimations() {
        const container = this.$refs.addonPopupSections
        if (!container) return
        container.querySelectorAll('.el_animate').forEach(el => {
          el.classList.add('animate-scroll-banner')
        })
      },
      async fetchAddonPopupSections(handle) {
        if (!handle) return
        if (this.addonPopupSectionsCache[handle] !== undefined) {
          this.addonPopupSectionsHtml = this.addonPopupSectionsCache[handle]
          await this.$nextTick()
          this._initAddonPopupSectionAnimations()
          return
        }
        const sectionIds = ['scrolling_banner_3aBXMF', 'image_with_text_LtBR7i']
        try {
          const url = `${window.location.origin}/products/${handle}`
          const res = await fetch(url)
          const html = await res.text()
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          let sectionHtml = ''
          sectionIds.forEach(sectionSuffix => {
            const section = doc.querySelector(`[id*="${sectionSuffix}"]`)
            if (section) sectionHtml += section.outerHTML
          })
          this.addonPopupSectionsCache[handle] = sectionHtml
          this.addonPopupSectionsHtml = sectionHtml
          await this.$nextTick()
          this._initAddonPopupSectionAnimations()
        } catch (e) {
          this.addonPopupSectionsCache[handle] = ''
          this.addonPopupSectionsHtml = ''
        }
      },

    }))
  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-swiper-nba"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('pdpSwiperNbaState', () => ({
      // ── raw catalog data, parsed once from the JSON blob ──────────────
      data: null,
      teamList: [],
      diffuserOptions: [],
      featureMetadataSections: [],
      bundlePromo: 'free-diffuser-set',

      // ── selection state ────────────────────────────────────────────
      // Keyed directly by each diffuser option's real option1 value
      // (data.diffuserOptions[].key) — no fixed "diffuser1"/"diffuser2"
      // role names, so this generalizes to however many diffuser options
      // the product actually has.
      quantityByOption1: {},
      selectedTeam: null,
      currentStep: 0,
      termsAccepted: false,
      termsAcceptedAt: null,
      termsModalOpen: false,
      addToCartLoading: false,
      learnMoreOpen: false,
      learnMoreKey: null,

      init() {
        const jsonEl = this.$root.querySelector('[data-pdp-nba-state]')
        this.data = jsonEl ? JSON.parse(jsonEl.textContent) : null
        this.bundlePromo = (this.data && this.data.bundlePromo) || this.bundlePromo
        this.teamList = (this.data && this.data.teams) || []
        this.diffuserOptions = (this.data && this.data.diffuserOptions) || []
        this.featureMetadataSections = (this.data && this.data.featureMetadataSections) || []
        // Every discovered diffuser option starts at qty 0.
        // Bundle gets its own independent quantity key too — same object,
        // no special-casing, no cross-mutation with the diffuser options.
        const bundleKeyEntry = (this.data && this.data.bundle && this.data.bundle.key) ? [[this.data.bundle.key, 0]] : []
        this.quantityByOption1 = Object.fromEntries([...this.diffuserOptions.map((o) => [o.key, 0]), ...bundleKeyEntry])

        // Bridge the vendor Swiper instance's slideChange to Alpine state,
        // same pattern as pdp-swiper-quantity.liquid's slide-change event.
        this.$nextTick(() => {
          const rootEl = this.$root.querySelector('[data-pdp-nba-root]')
          if (!rootEl || typeof window.Swiper === 'undefined') return
          const swiper = new window.Swiper(rootEl, {
            slidesPerView: 1,
            allowTouchMove: false,
            simulateTouch: false,
            autoHeight: true,
            on: {
              slideChange: (sw) => { this.currentStep = sw.activeIndex },
            },
          })
          rootEl.swiper = swiper
        })
      },

      // ── step navigation ────────────────────────────────────────────
      slideTo(idx) {
        const rootEl = this.$root.querySelector('[data-pdp-nba-root]')
        if (rootEl && rootEl.swiper) rootEl.swiper.slideTo(idx, 700)
        this.currentStep = idx
      },
      goToStepIfValid(idx) {
        if (idx >= 1 && this.totalDiffuserQty() === 0) return
        if (idx >= 2 && !this.teamSelectionIsComplete()) return
        this.slideTo(idx)
      },

      // ── step 1: quantity ───────────────────────────────────────────
      getQty(key) { return Number(this.quantityByOption1[key] || 0) },
      // Same 5-unit hard cap as pdp-swiper-quantity.liquid's
      // totalWeightedUnits()/incrementQty() — a bundle unit weighs as much
      // as one of each real diffuser it expands into (there, a fixed 3;
      // here, diffuserOptions.length, since the set of diffuser options is
      // discovered dynamically rather than fixed).
      bundleWeight() {
        return Math.max(this.diffuserOptions.length, 1)
      },
      weightForKey(key) {
        return this.data && this.data.bundle && key === this.data.bundle.key ? this.bundleWeight() : 1
      },
      totalWeightedUnits() {
        const regular = this.diffuserOptions.reduce((sum, o) => sum + this.getQty(o.key), 0)
        return regular + this.bundleQty() * this.bundleWeight()
      },
      canIncrement(key) {
        return this.totalWeightedUnits() + this.weightForKey(key) <= 6
      },
      incrementQty(key) {
        if (!this.canIncrement(key)) return
        this.quantityByOption1 = { ...this.quantityByOption1, [key]: this.getQty(key) + 1 }
      },
      decrementQty(key) {
        const next = Math.max(0, this.getQty(key) - 1)
        this.quantityByOption1 = { ...this.quantityByOption1, [key]: next }
      },
      // Sum of every card's own quantity (diffuser options + bundle) — just
      // used to gate the step-1 "Next" button on "something is selected".
      totalDiffuserQty() {
        return Object.values(this.quantityByOption1).reduce((sum, n) => sum + Number(n || 0), 0)
      },
      bundleQty() {
        return this.data && this.data.bundle ? this.getQty(this.data.bundle.key) : 0
      },
      // The quantity that actually matters for a given diffuser option once
      // the Bundle placeholder is accounted for: its own directly-selected
      // quantity PLUS one per bundle unit — exactly the same "bundle
      // expands into one of each real diffuser at resolution time" concept
      // the original sections use (see plan: Bundle Construction). This is
      // the ONLY place bundle quantity and diffuser quantity interact —
      // the step-1 cards themselves stay fully independent (no
      // cross-mutation), per plan.
      effectiveQty(diffuserKey) {
        return this.getQty(diffuserKey) + this.bundleQty()
      },
      // Unified step-1 card list — the bundle figurehead first, then every
      // discovered diffuser option, so all cards render through one
      // identical template with identical (independent) qty behavior.
      cardList() {
        if (!this.data) return []
        return [this.data.bundle, ...this.diffuserOptions.map((o) => ({ ...o, name: o.key }))]
      },

      // ── team → variant resolution ──────────────────────────────────
      // Shared by every product role (diffuser 1, diffuser 2, each oil, the
      // gift, the gift fallback): match on option2 first (team is option2
      // on the main product's variants per confirmed store setup), fall
      // back to a `custom.team` variant metafield for a referenced addon/
      // gift product that doesn't use option2 for team.
      resolveTeamVariantFromList(list, team) {
        if (!list || !list.length || !team) return null
        const norm = (s) => String(s || '').trim().toLowerCase()
        let match = list.find((v) => norm(v.option2) === norm(team))
        if (!match) match = list.find((v) => norm(v.teamMeta) === norm(team))
        if (!match) return null
        return match.available !== false ? match : null
      },
      variantsForOption1(key) {
        if (!this.data || !key) return []
        return (this.data.productVariants || []).filter((v) => v.option1 === key)
      },
      resolveDiffuserVariant(key, team) {
        return this.resolveTeamVariantFromList(this.variantsForOption1(key), team)
      },
      // Oil no longer gets team-matched by scanning a pool of variants —
      // oil/car-oil products don't carry team on any option or metafield
      // (see pdp-swiper-nba-team-map.liquid), so it's looked up directly:
      // team → diffuser option1 key → an already-resolved variant row,
      // straight out of the hardcoded map baked into the JSON blob.
      resolveOilVariant(diffuserKey, team) {
        if (!this.data || !this.data.teamMap || !diffuserKey || !team) return null
        const teamEntry = this.data.teamMap[team]
        const variant = teamEntry && teamEntry.oils && teamEntry.oils[diffuserKey]
        return variant && variant.available !== false ? variant : null
      },
      // ── stock substitution: never block checkout over one out-of-stock item ──
      // One shared substitute per role (not per team) — if the team's own
      // item isn't available, fall back to data.substitutes.{diffusers,oils}
      // [key] (already resolved server-side, incl. the Mini Pro oil's exact
      // variant match). isFallback lets the UI/pricing know a substitution
      // happened, same shape resolveGiftVariant() already returns.
      resolveDiffuserVariantResolved(key, team) {
        const exact = this.resolveDiffuserVariant(key, team)
        if (exact) return { variant: exact, isFallback: false }
        const substitute = this.data && this.data.substitutes && this.data.substitutes.diffusers && this.data.substitutes.diffusers[key]
        if (substitute && substitute.available !== false) return { variant: substitute, isFallback: true }
        return { variant: null, isFallback: false }
      },
      resolveOilVariantResolved(key, team) {
        const exact = this.resolveOilVariant(key, team)
        if (exact) return { variant: exact, isFallback: false }
        const substitute = this.data && this.data.substitutes && this.data.substitutes.oils && this.data.substitutes.oils[key]
        if (substitute && substitute.available !== false) return { variant: substitute, isFallback: true }
        return { variant: null, isFallback: false }
      },
      selectTeam(team) { this.selectedTeam = team },
      // Complete once every selected diffuser's diffuser+oil AND the gift
      // resolve to SOMETHING (team item or substitute) — a stock gap alone
      // no longer blocks Next, only a gap with no substitute configured does.
      teamSelectionIsComplete() {
        if (!this.selectedTeam || !this.data) return false
        for (const opt of this.diffuserOptions) {
          if (this.effectiveQty(opt.key) <= 0) continue
          if (!this.resolveDiffuserVariantResolved(opt.key, this.selectedTeam).variant) return false
          if (!this.resolveOilVariantResolved(opt.key, this.selectedTeam).variant) return false
        }
        return !!this.resolveGiftVariant()
      },
      // True if any selected diffuser/oil, or the gift, is currently
      // running on its substitute rather than the team's own item — drives
      // the yellow "replaced with a substitute" banner on step 2.
      // Gift substitution is deliberately excluded — the user never had an
      // explicit expectation of getting a specific team candle, so a
      // fallback there isn't worth flagging the way a swapped diffuser/oil
      // is.
      hasSubstitutions() {
        if (!this.selectedTeam || !this.data) return false
        for (const opt of this.diffuserOptions) {
          if (this.effectiveQty(opt.key) <= 0) continue
          if (this.resolveDiffuserVariantResolved(opt.key, this.selectedTeam).isFallback) return true
          if (this.resolveOilVariantResolved(opt.key, this.selectedTeam).isFallback) return true
        }
        return false
      },
      // 'none' | 'ok' | 'substituted' | 'blocked' — single source of truth
      // for the step-2 pick banner's copy/color.
      bannerState() {
        if (!this.selectedTeam) return 'none'
        if (!this.teamSelectionIsComplete()) return 'blocked'
        return this.hasSubstitutions() ? 'substituted' : 'ok'
      },
      pickMessage() {
        const t = this.selectedTeam
        const parts = this.diffuserOptions
          .filter((o) => this.effectiveQty(o.key) > 0)
          .map((o) => `${t} ${o.key} Oil`)
        const oilsText = parts.join(' and ')
        return `${oilsText}${oilsText ? ' and ' : ''}${t} NBA Candle selected automatically.`
      },
      // Real team swatch (image or color) from the product's own option2
      // values — same source pdp-swiper-quantity.liquid's swatchesByOption1
      // uses for color. Falls back to a deterministic hashed color (with
      // initials shown as text) only for a team option value that has no
      // swatch configured in Shopify admin yet.
      teamSwatchStyle(team) {
        if (team.swatchBg) return `background: ${team.swatchBg}; background-size: cover; background-position: center;`
        let hash = 0
        for (let i = 0; i < team.name.length; i++) hash = team.name.charCodeAt(i) + ((hash << 5) - hash)
        const hue = Math.abs(hash) % 360
        return `background: hsl(${hue}, 42%, 32%);`
      },
      teamInitials(team) {
        return team.split(' ').map((w) => w[0]).join('').slice(-3).toUpperCase()
      },

      // ── free gift: exactly one per checkout, section-wide promo ─────
      // Same hardcoded-map lookup as oil — the candle is resolved directly
      // by team, not matched. Falls back to the single non-team product
      // configured as a section setting if no candle is mapped/available
      // for this team yet. Not tied to the Bundle option or diffuser
      // quantity — computed once per checkout.
      resolveGiftVariant() {
        if (!this.data || !this.selectedTeam) return null
        const teamEntry = this.data.teamMap && this.data.teamMap[this.selectedTeam]
        const candle = teamEntry && teamEntry.candle
        if (candle && candle.available !== false) return { variant: candle, isFallback: false }
        const fallback = this.data.giftFallback && this.data.giftFallback.variants && this.data.giftFallback.variants[0]
        if (fallback && fallback.available !== false) return { variant: fallback, isFallback: true }
        return null
      },

      // ── money formatting ──────────────────────────────────────────
      // variant.price/compareAtPrice render as raw CENTS when interpolated
      // directly in Liquid (not decimal dollars) — same as
      // pdp-swiper-quantity.liquid's formatPdpMoney(), use Shopify's global
      // cents-aware formatter rather than a hand-rolled toFixed(2).
      formatMoney(cents) {
        const n = Number(cents || 0)
        if (typeof window.formatMoney === 'function') return window.formatMoney(n)
        return '$' + (n / 100).toFixed(2)
      },
      dueTodayFormatted() {
        let total = 0
        this.diffuserOptions.forEach((o) => {
          const qty = this.effectiveQty(o.key)
          if (qty <= 0) return
          const oil = this.resolveOilVariantResolved(o.key, this.selectedTeam).variant
          if (oil) total += Number(oil.price || 0) * qty
        })
        return this.formatMoney(total)
      },

      // ── step 2: fine print ─────────────────────────────────────────
      // Static/always-on (not a section setting — every price in it is
      // still computed live). It used to return '' until a team was picked,
      // which meant this box only gained its content (and height) after
      // selection — collapsing/expanding the layout around the team grid
      // and clipping the bottom rows. It now always renders, using
      // per-diffuser quantities from step 1 (available before any team is
      // chosen), so the box's height is stable from the moment step 2
      // loads.
      //
      // Cancellation fee is a fixed, business-set amount per diffuser role
      // (NOT derived from compare-at price anymore — that produced
      // inconsistent numbers depending on which substitute/team resolved).
      // Mirrors the same array-position convention used elsewhere in this
      // file (reviewLines()'s `isCarDiffuser = idx === 1`): index 0 is
      // always the Mini Pro diffuser, index 1 the Smart Car diffuser.
      cancelFeeCentsForDiffuserIndex(idx) {
        const CANCEL_FEE_CENTS = [11567, 7576] // [Mini Pro, Smart Car] — dollars * 100
        return CANCEL_FEE_CENTS[idx] || 0
      },
      // Highest oil price found across every team's mapping for this
      // diffuser role — used only pre-team-selection so the price shown
      // is never an undersell of what a (possibly pricier) team's scent
      // will actually cost once picked.
      maxOilPriceForKey(key) {
        const teamMap = this.data && this.data.teamMap
        if (!teamMap) return 0
        let max = 0
        Object.keys(teamMap).forEach((team) => {
          const oil = teamMap[team].oils && teamMap[team].oils[key]
          const price = oil && Number(oil.price || 0)
          if (price > max) max = price
        })
        return max
      },
      step2Fineprint() {
        if (!this.data) return ''
        const sentences = this.diffuserOptions
          .map((o, idx) => {
            const qty = this.effectiveQty(o.key)
            if (qty <= 0) return null
            let monthlyUnitPrice = 0
            let oilName = "your team's scent"
            if (this.selectedTeam) {
              const oil = this.resolveOilVariantResolved(o.key, this.selectedTeam).variant
              if (!oil) return null
              monthlyUnitPrice = Number(oil.price || 0)
              oilName = oil.productTitle || oil.title || oilName
            } else {
              monthlyUnitPrice = this.maxOilPriceForKey(o.key)
            }
            const monthlyTotal = monthlyUnitPrice * qty
            const cancelFee = this.cancelFeeCentsForDiffuserIndex(idx) * qty
            return `Your ${o.key} is free with a 6-month ${oilName} subscription (${this.formatMoney(monthlyTotal)}/mo) — cancel early and pay ${this.formatMoney(cancelFee)}.`
          })
          .filter(Boolean)
        if (!sentences.length) return ''
        return `${sentences.join(' ')} 30-day risk-free returns.`
      },

      // ── step 3: review ────────────────────────────────────────────
      reviewLines() {
        if (!this.data || !this.selectedTeam) return []
        const lines = []
        this.diffuserOptions.forEach((o, idx) => {
          const qty = this.effectiveQty(o.key)
          if (qty <= 0) return
          // Card title stays the role name ("NBA Mini Pro Diffuser" / team
          // + " Oil") whether substituted or not — what actually changed is
          // called out as its own stacked line (substitutionNote) styled
          // like the small commitment/shipping text, not by swapping the
          // title itself. Named from the substitute product's own title,
          // EXCEPT the car diffuser (2nd discovered diffuser role), which
          // is described by its variant's option1 value instead — the
          // product title alone ("Smart Car Diffuser") doesn't distinguish
          // it, and the full variant title includes extra option segments
          // beyond just the option1 name.
          const dResolved = this.resolveDiffuserVariantResolved(o.key, this.selectedTeam)
          const d = dResolved.variant
          if (d) {
            const isCarDiffuser = idx === 1
            const subName = isCarDiffuser ? (d.option1 || d.title || d.productTitle) : (d.productTitle || d.title)
            lines.push({
              key: o.key,
              icon: '▮',
              image: d.image,
              name: o.key,
              desc: this.selectedTeam + ' · with 6-mo subscription',
              substitutionNote: dResolved.isFallback ? `Substituted with ${subName}` : '',
              qty,
              free: true,
              substituted: dResolved.isFallback,
            })
          }
          const oilResolved = this.resolveOilVariantResolved(o.key, this.selectedTeam)
          const oil = oilResolved.variant
          if (oil) {
            // Mini Pro oils are one standalone product per scent, so
            // productTitle already IS the scent name ("My Way"). Car oil is
            // one shared product across every scent — its productTitle is
            // just "Smart Car Diffuser Oil", so the actual scent lives in
            // the variant's option1 instead. Same role-based split as the
            // car diffuser's substitutionNote above.
            //
            // Unlike the diffuser, a substituted oil doesn't get a stacked
            // note — its scent name replaces the team name directly in the
            // title ("My Way Mini Pro Diffuser Oil" instead of "Atlanta
            // Hawks Mini Pro Diffuser Oil"), since "the oil" already means
            // "the scent" to begin with.
            const isCarOil = idx === 1
            const oilSubName = isCarOil ? (oil.option1 || oil.productTitle) : (oil.productTitle || oil.title)
            // Drop the "NBA" prefix from the role name here — it's the
            // official product name elsewhere (cards, etc.), but reads
            // redundant stacked right after a team/scent name in this title.
            const oilRoleName = o.key.replace(/^NBA\s+/, '')
            lines.push({
              key: o.key + '-oil',
              icon: '🧴',
              image: oil.image,
              name: (oilResolved.isFallback ? oilSubName : this.selectedTeam) + ' ' + oilRoleName + ' Oil',
              desc: 'Ships monthly · 6-month commitment',
              qty,
              free: false,
              priceFormatted: this.formatMoney(oil.price),
              substituted: oilResolved.isFallback,
            })
          }
        })
        const gift = this.resolveGiftVariant()
        if (gift) {
          lines.push({
            key: 'gift',
            image: gift.variant.image,
            icon: '🕯️',
            name: gift.isFallback ? this.data.giftFallback.name : (this.selectedTeam + ' NBA Candle'),
            desc: 'FREE GIFT with purchase — ships with your first order',
            // Deliberately never marked substituted — see hasSubstitutions().
            substituted: false,
            qty: 1,
            free: true,
          })
        }
        return lines
      },

      // ── terms ─────────────────────────────────────────────────────
      onTermsAcceptanceChange() {
        this.termsAcceptedAt = this.termsAccepted ? new Date().toISOString() : null
      },
      openTermsModal() { this.termsModalOpen = true; document.body.style.overflow = 'hidden' },
      closeTermsModal() { this.termsModalOpen = false; document.body.style.overflow = '' },

      // ── "Learn more" popup — step 1 diffuser cards only ──────────────
      // Purely informational (no variant selection/qty inside it, unlike
      // the originals' popup — this card already owns its own qty
      // stepper). Never opened for the bundle card (see markup x-show).
      openLearnMore(cardKey) {
        this.learnMoreKey = cardKey
        this.learnMoreOpen = true
        document.body.style.overflow = 'hidden'
      },
      closeLearnMore() {
        this.learnMoreOpen = false
        this.learnMoreKey = null
        document.body.style.overflow = ''
      },
      learnMoreCard() {
        if (!this.learnMoreKey) return null
        return this.diffuserOptions.find((o) => o.key === this.learnMoreKey) || null
      },
      // Ported from pdp-swiper-quantity.liquid's richTextToHtml — renders a
      // Shopify rich-text-field JSON tree (from variant_page_accordion) as
      // plain HTML for the accordion body.
      richTextToHtml(json) {
        if (!json) return ''
        let tree
        try { tree = typeof json === 'string' ? JSON.parse(json) : json }
        catch (e) { return json }
        function walk(node) {
          if (!node) return ''
          if (node.type === 'text') {
            let t = (node.value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            if (node.bold) t = '<strong>' + t + '</strong>'
            if (node.italic) t = '<em>' + t + '</em>'
            if (node.code) t = '<code>' + t + '</code>'
            return t
          }
          const inner = (node.children || []).map(walk).join('')
          switch (node.type) {
            case 'root': return inner
            case 'paragraph': return '<p>' + inner + '</p>'
            case 'heading': return '<h' + node.level + '>' + inner + '</h' + node.level + '>'
            case 'list': return node.listType === 'ordered' ? '<ol>' + inner + '</ol>' : '<ul>' + inner + '</ul>'
            case 'list-item': return '<li>' + inner + '</li>'
            case 'link': return '<a href="' + (node.url || '') + '"' + (node.target ? ' target="' + node.target + '"' : '') + '>' + inner + '</a>'
            default: return inner
          }
        }
        return walk(tree)
      },

      // ── bundle line-item property contract ───────────────────────
      // Copied verbatim from pdp-swiper-quantity.liquid's
      // buildBundleLineProperties() — the third-party discount app depends
      // on these exact keys (including the `_free_diffuser_tos_aceptance`
      // typo). Only `_bundle_promo`'s value changes, to a new NBA-specific
      // constant so the app can tell this campaign apart from the original.
      compareAtCentsString(variantRow) {
        const c = Number((variantRow && variantRow.compareAtPrice) || 0)
        if (!c || c <= 0) return '0'
        return String(Math.round(c))
      },
      compareDiscountPercentString(variantRow) {
        if (!variantRow) return '0'
        const cap = Number(variantRow.compareAtPrice || 0)
        const price = Number(variantRow.price || 0)
        if (!cap || cap <= 0 || cap <= price) return '0'
        return String(Math.max(0, Math.round(((cap - price) / cap) * 100)))
      },
      buildBundleLineProperties(variantRow, bundleId, tosAcceptedAt, extraProperties) {
        return {
          _bundle_promo: this.bundlePromo,
          _bundle_id: bundleId,
          _bundle_identifier: 'true',
          _compare_at_price: this.compareAtCentsString(variantRow),
          _compare_at_price_discount: this.compareDiscountPercentString(variantRow),
          _free_diffuser_tos_aceptance:
            tosAcceptedAt != null && tosAcceptedAt !== '' ? String(tosAcceptedAt) : '',
          ...extraProperties,
        }
      },
      buildBundleId(prefix) {
        return `_bundle_nba_${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`
      },

      // ── add to cart ───────────────────────────────────────────────
      // Checks the LIVE cart (not just this page load's local state) for a
      // line already carrying the gift's _promotional_source property —
      // catches the gift already having been added on a prior visit/click,
      // not just within the same session.
      async cartAlreadyHasGift() {
        try {
          const rootPath =
            typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/'
          const res = await fetch(`${rootPath}cart.js`)
          if (!res.ok) return false
          const cart = await res.json()
          return (cart.items || []).some((item) => item.properties && item.properties._promotional_source === 'nba-free-gift')
        } catch (err) {
          console.error('[pdp-swiper-nba] cartAlreadyHasGift error:', err)
          return false
        }
      },
      async addNbaSetToCart() {
        if (!this.termsAccepted || this.addToCartLoading || !this.selectedTeam) return
        this.addToCartLoading = true
        try {
          const tosAt = this.termsAcceptedAt
          const items = []

          const pushPairing = (key, qty) => {
            if (qty <= 0) return
            // Fallback-aware — if the team's own diffuser/oil is out of
            // stock, this adds the configured substitute instead of failing,
            // matching what step 2/3 already showed the user.
            const diffuserVariant = this.resolveDiffuserVariantResolved(key, this.selectedTeam).variant
            const oilVariant = this.resolveOilVariantResolved(key, this.selectedTeam).variant
            if (!diffuserVariant) return
            for (let i = 0; i < qty; i++) {
              const bundleId = this.buildBundleId(`${diffuserVariant.id}_u${i}`)
              items.push({
                id: Number(diffuserVariant.id),
                quantity: 1,
                properties: this.buildBundleLineProperties(diffuserVariant, bundleId, tosAt),
              })
              if (oilVariant) {
                const oilLine = {
                  id: Number(oilVariant.id),
                  quantity: 1,
                  properties: this.buildBundleLineProperties(oilVariant, bundleId, tosAt),
                }
                if (oilVariant.sellingPlanId) {
                  oilLine.selling_plan = Number(oilVariant.sellingPlanId)
                  oilLine.properties._notes = 'Initial Subscription Order'
                }
                items.push(oilLine)
              }
            }
          }
          // Iterates every discovered diffuser option, not fixed roles —
          // works regardless of how many diffuser options this product has.
          // effectiveQty(), not getQty() — a selected Bundle quantity is
          // never its own cart line; it's expanded into one of each real
          // diffuser here, on top of whatever was directly selected.
          this.diffuserOptions.forEach((o) => pushPairing(o.key, this.effectiveQty(o.key)))

          // Exactly one gift line, its own standalone bundleId — it is not
          // 1:1 paired with any single diffuser line (see plan: Bundle
          // Construction / Cart Payload). Only ever added once — if the
          // cart already has a line carrying the gift's _promotional_source
          // (from an earlier add), skip pushing another (no messaging for
          // this yet, just silently not duplicating it).
          const gift = this.resolveGiftVariant()
          const alreadyHasGift = await this.cartAlreadyHasGift()
          if (gift && !alreadyHasGift) {
            const giftBundleId = this.buildBundleId(`gift_${gift.variant.id}`)
            const giftProperties = this.buildBundleLineProperties(gift.variant, giftBundleId, tosAt, {
              _promotional_source: 'nba-free-gift',
            })
            // The gift must be recognized ONLY via _promotional_source, not
            // _bundle_promo — every line built through
            // buildBundleLineProperties() carries _bundle_promo ==
            // "free-diffuser-set" by default, which is the SAME identifier
            // the diffuser/oil discount matches on. Left in place, that
            // made the gift qualify for that discount too (free "twice
            // over" — once via each mechanism) instead of only through its
            // own dedicated promo-source rule. Strip it so this line only
            // ever qualifies through the gift-specific mechanism.
            delete giftProperties._bundle_promo
            items.push({
              id: Number(gift.variant.id),
              quantity: 1,
              properties: giftProperties,
            })
          }

          if (!items.length) return

          const rootPath =
            typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/'

          const res = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items }),
          })
          const resData = await res.json().catch(() => ({}))
          if (!res.ok || resData.status === 422) {
            console.error('[pdp-swiper-nba] cart/add error:', resData)
            return
          }

          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'))
          document.dispatchEvent(new CustomEvent('eurus:cart:redirect'))
        } catch (err) {
          console.error('[pdp-swiper-nba] addNbaSetToCart error:', err)
        } finally {
          this.addToCartLoading = false
        }
      },
    }))
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-swiper-quantity"] && !Shopify.designMode) return;
  try {
    

  // ── External Swiper initialiser ────────────────────────────────────────────
  // Runs at DOMContentLoaded — before Alpine's init() — so Swiper is always
  // created by this function. Slide changes are communicated to Alpine via a
  // custom event on the section root, which Alpine listens for in init().
  const initQtyPdpSwiper = (root) => {
    if (typeof window.Swiper === 'undefined') return

    // Media swipers (left column on slide 0 and review slide)
    root.querySelectorAll('.pdp-swiper__media-swiper').forEach((mediaEl) => {
      if (mediaEl.swiper) return
      new window.Swiper(mediaEl, {
        nested: true,
        slidesPerView: 1,
        speed: 650,
        breakpoints: { 990: { allowTouchMove: false, simulateTouch: false } },
      })
    })

    // Root Swiper — controls all step slides
    const rootEl = root.querySelector('.pdp-swiper__root')
    if (!rootEl || rootEl.swiper) return
    new window.Swiper(rootEl, {
      slidesPerView: 1,
      speed: 700,
      allowTouchMove: false,
      simulateTouch: false,
      autoHeight: true,
      on: {
        slideChange(sw) {
          root.dispatchEvent(
            new CustomEvent('pdp-swiper-qty:slide-change', {
              bubbles: false,
              detail: { activeIndex: sw.activeIndex },
            })
          )
        },
      },
    })
  }

  const _runQtyPdpSwiperInit = () => {
    document.querySelectorAll('.pdp-swiper-qty').forEach(initQtyPdpSwiper)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _runQtyPdpSwiperInit)
  } else {
    _runQtyPdpSwiperInit()
  }

  // ── Discount / product-type rule parsers ───────────────────────────────────

  const parseDiscountByProductTypeRules = (raw) => {
    if (!raw || typeof raw !== 'string') return []
    return raw
      .replace(/\r\n/g, '\n')
      .split(/[,\n]+/)
      .map((s) => s.trim())
      .filter(Boolean)
      .map((segment) => {
        const idx = segment.lastIndexOf('/')
        if (idx === -1) return null
        const productType = segment.slice(0, idx).trim()
        const percent = segment.slice(idx + 1).trim()
        if (!productType || !percent) return null
        return { productType, percent: Number(percent) }
      })
      .filter(Boolean)
  }

  const parseQtyAddonProductTypeRules = (raw) => {
    if (!raw || typeof raw !== 'string') return []
    return raw
      .replace(/\r\n/g, '\n')
      .split(/[,\n]+/)
      .map((s) => s.trim())
      .filter(Boolean)
      .map((segment) => {
        const parts = segment.split('|').map((p) => p.trim())
        const match = parts[0]
        const productType = parts[1] || ''
        const collectionFilter = parts[2] || null
        if (!match || !productType) return null
        return { match, productType, collectionFilter }
      })
      .filter(Boolean)
  }

  function readConvertBucketing() {
    var cd = (window.convert && window.convert.currentData) || {}
    var exps = cd.experiences || cd.experiments || {}
    var out = {}
    for (var id in exps) {
      if (!Object.prototype.hasOwnProperty.call(exps, id)) continue
      var e = exps[id]
      var varId = (e.variation && e.variation.id) || e.variation_id
      if (varId) out[String(id)] = String(varId)
    }
    return out
  }

  var QTY_AB_PROMO_EXPERIENCE_ID = '1004217324'
  var QTY_AB_PROMO_VARIATION_ID = '1004509821'
  var QTY_AB_PROMO_DAVINCI_VARIATION_ID = '1004509822'

  function readQtyAbPromoCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'))
    if (!match) return ''
    try {
      return decodeURIComponent(match[1]).trim()
    } catch (e) {
      return String(match[1] || '').trim()
    }
  }

  function matchesQtyAbPromoPair(experienceId, variationId) {
    var bucket = readConvertBucketing()
    if (bucket[experienceId] === variationId) return true
    return readQtyAbPromoCookie('convert_e') === experienceId
      && readQtyAbPromoCookie('convert_v') === variationId
  }

  function isQtyAbPromoExperience() {
    return matchesQtyAbPromoPair(QTY_AB_PROMO_EXPERIENCE_ID, QTY_AB_PROMO_VARIATION_ID)
  }

  function isQtyAbPromoDavinciOnly() {
    return matchesQtyAbPromoPair(QTY_AB_PROMO_EXPERIENCE_ID, QTY_AB_PROMO_DAVINCI_VARIATION_ID)
  }

  function replaceQtyAbPromoText(value) {
    return String(value || '')
      .replace(/(^|[^\d])6-month\b/gi, function (_match, prefix) {
        return prefix + '12-month'
      })
      .replace(/(^|[^\d])6 months\b/gi, function (_match, prefix) {
        return prefix + '12 months'
      })
  }

  var QTY_AB_PROMO_HERO_IMAGE = 'https://cdn.shopify.com/s/files/1/0517/2402/6050/files/Premium_Aroma360_Diffuser_Display.png?v=1793293484'

  function matchQtyAbPromoCase(sample, replacement) {
    if (sample === sample.toUpperCase()) return replacement.toUpperCase()
    if (sample.charAt(0) === sample.charAt(0).toUpperCase()) {
      return replacement.charAt(0).toUpperCase() + replacement.slice(1)
    }
    return replacement
  }

  function replaceQtyAbPromoTermsCounts(value) {
    return String(value || '')
      .replace(/\bseven\b/gi, function (match) {
        return matchQtyAbPromoCase(match, 'thirteen')
      })
      .replace(/\bsix\b/gi, function (match) {
        return matchQtyAbPromoCase(match, 'twelve')
      })
      .replace(/(^|[^\d])7(?!\d)/g, function (_match, prefix) {
        return prefix + '13'
      })
      .replace(/(^|[^\d])6(?!\d)/g, function (_match, prefix) {
        return prefix + '12'
      })
  }

  function applyQtyAbPromoTermsCounts(root) {
    if (!root) return
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement
        if (!parent) return NodeFilter.FILTER_REJECT
        var tag = parent.tagName
        if (tag === 'SCRIPT' || tag === 'STYLE') return NodeFilter.FILTER_REJECT
        return NodeFilter.FILTER_ACCEPT
      },
    })
    var nodes = []
    while (walker.nextNode()) nodes.push(walker.currentNode)
    nodes.forEach(function (node) {
      var next = replaceQtyAbPromoTermsCounts(node.nodeValue)
      if (next !== node.nodeValue) node.nodeValue = next
    })
  }

  function applyQtyAbPromoTextTo(root) {
    if (!root) return false
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement
        if (!parent) return NodeFilter.FILTER_REJECT
        var tag = parent.tagName
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA') return NodeFilter.FILTER_REJECT
        return NodeFilter.FILTER_ACCEPT
      },
    })
    var nodes = []
    while (walker.nextNode()) nodes.push(walker.currentNode)
    nodes.forEach(function (node) {
      var next = replaceQtyAbPromoText(node.nodeValue)
      if (next !== node.nodeValue) node.nodeValue = next
    })
    return true
  }

  function applyQtyAbPromoCopy(root) {
    if (!isQtyAbPromoExperience()) return false
    return applyQtyAbPromoTextTo(root)
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('pdpSwiperQuantityState', () => ({

      // ── Variant data ────────────────────────────────────────────────
      productHandle: '',
      variantsById: {},
      addonVariantsById: {},
      defaultByOption1: {},
      addonProductTypeMap: '',
      discountByProductTypeMap: '',
      reviewImageMappings: [],
      productFeaturedImage: '',
      bundleVariantId: '',
      bundleOnlyMode: false,
      templateSuffix: '',
      freePromo: true,
      paidStandaloneOption1: '',
      subscriptionOnly: true,
      frequencyStep: false,
      frequencyHeadline: 'Select scent delivery frequency',
      subscriptionBestOfferLabel: '',
      bundleVariant: null,
      bundleSlotsByType: {},

      // ── Step 1 quantity state ────────────────────────────────────────
      // { [option1Key]: 0..3 }
      quantityByOption1: {},

      // ── Step 1 slot color state ──────────────────────────────────────
      // { [option1Key]: [variantId, variantId, ...] }  length === qty
      slotColorByOption1: {},

      // ── Swatch data (baked from Liquid) ──────────────────────────────
      // { [option1Key]: [{ variantId, option2, swatchBg }, ...] }
      swatchesByOption1: {},

      // Ordered list of option1 keys (Liquid render order)
      option1Order: [],
      // Step 1 option1 groups rendered with display:none (hide_variant on every variant)
      hiddenOption1Keys: {},
      abPromoActive: false,
      abPromoDavinciOnly: false,

      // ── Bundle list (built on NEXT from Step 1) ──────────────────────
      bundles: [],

      // ── Addon type groups (derived from bundles, drives addon slides) ─
      // [{ productType, count, bundles[], label }]
      addonTypeGroups: [],

      // ── Scent qty per type: { [productType]: { [addonVariantId]: qty } }
      addonQtyByType: {},

      // ── Purchase mode per addon: { [addonVariantId]: 'subscription' | 'one_time' }
      addonPurchaseModeById: {},
      // ── Group-level frequency choice: { [productType]: 'subscription' | 'one_time' }
      groupPurchaseModeByType: {},

      // ── Swiper tracking ──────────────────────────────────────────────
      currentSwiperIndex: 0,
      stepTextTemplate: '',

      // ── Shared UI state ─────────────────────────────────────────────
      termsAccepted: false,
      termsAcceptedAt: null,
      termsModalOpen: false,
      addToCartLoading: false,
      popupOpen: false,
      popupVariant: null,
      popupOption1: null,
      popupSectionsCache: {},
      popupSectionsHtml: '',
      addonPopupOpen: false,
      addonPopupVariant: null,
      addonPopupSectionsCache: {},
      addonPopupSectionsHtml: '',
      allScentsModalOpen: false,
      allScentsSearch: '',
      allScentsProfileOpen: true,
      allScentsMoodOpen: true,
      allScentsCollectionsOpen: false,
      allScentsDrawerOpen: false,
      selectedScentProfileFilters: [],
      selectedScentMoodFilters: [],
      selectedCollectionFilters: [],
      _allScentsProductType: null,
      _allScentsCollectionFilter: null,
      pdpSwiperRootEl: null,

      // ── Init ────────────────────────────────────────────────────────
      init() {
        this.pdpSwiperRootEl =
          this.$el && this.$el.closest ? this.$el.closest('.pdp-swiper-qty') : null

        const jsonEl = this.$el.querySelector('[data-pdp-variant-state]')
        if (!jsonEl) return

        let state = null
        try {
          state = JSON.parse(jsonEl.textContent || '{}')
        } catch (e) {
          state = null
        }
        if (!state) return

        // Populate variantsById
        ;(state.variants || []).forEach((v) => {
          this.variantsById[String(v.id)] = v
        })

        // Populate addonVariantsById
        this.addonVariantsById = {}
        ;(state.addonVariants || []).forEach((row) => {
          if (row && row.id != null) {
            this.addonVariantsById[String(row.id)] = row
          }
        })

        this.defaultByOption1 = { ...(state.defaults || {}) }
        this.addonProductTypeMap =
          typeof state.addonProductTypeMap === 'string' ? state.addonProductTypeMap : ''
        this.discountByProductTypeMap =
          typeof state.discountByProductTypeMap === 'string'
            ? state.discountByProductTypeMap
            : ''
        this.reviewImageMappings = Array.isArray(state.reviewImageMappings)
          ? state.reviewImageMappings
          : []
        this.productFeaturedImage = state.productFeaturedImage || ''

        this.productHandle = state.productHandle || ''

        this.bundleVariantId = state.bundleVariantId || ''
        this.bundleOnlyMode = !!state.bundleOnlyMode
        this.templateSuffix = state.templateSuffix || ''
        this.freePromo = state.freePromo !== false
        this.paidStandaloneOption1 = String(state.paidStandaloneOption1 || '').trim().toLowerCase()
        this.subscriptionOnly = state.subscriptionOnly !== false
        this.frequencyStep = !!state.frequencyStep
        this.frequencyHeadline =
          typeof state.frequencyHeadline === 'string' && state.frequencyHeadline.trim()
            ? state.frequencyHeadline.trim()
            : 'Select scent delivery frequency'
        this.subscriptionBestOfferLabel =
          typeof state.subscriptionBestOfferLabel === 'string'
            ? state.subscriptionBestOfferLabel.trim()
            : ''
        this.addonPurchaseModeById = {}
        this.groupPurchaseModeByType = {}
        this.bundleVariant = this.bundleVariantId
          ? (Object.values(this.variantsById).find((v) => v.option1 === this.bundleVariantId) || null)
          : null

        // Swatch data per option1 group
        this.swatchesByOption1 =
          state.swatchesByOption1 && typeof state.swatchesByOption1 === 'object'
            ? state.swatchesByOption1
            : {}

        // Ordered option1 keys (Liquid render order for bundle building)
        this.option1Order = Array.isArray(state.option1Order) ? state.option1Order : []
        this.hiddenOption1Keys = {}
        ;(Array.isArray(state.hiddenOption1) ? state.hiddenOption1 : []).forEach((key) => {
          this.hiddenOption1Keys[key] = true
        })

        // Initialize quantityByOption1: all option1 groups start at 0
        const qtyInit = {}
        Object.keys(this.defaultByOption1).forEach((key) => {
          qtyInit[key] = 0
        })
        this.quantityByOption1 = qtyInit
        this.slotColorByOption1 = {}

        // Bundle-only mode: the bundle card is the only purchasable item on Step 1,
        // so pre-select 1 unit (and its default color per component type) instead of
        // landing on an empty page with nothing selected and NEXT disabled.
        if (this.bundleOnlyMode && this.bundleVariant) {
          this.quantityByOption1 = { ...this.quantityByOption1, __bundle__: 1 }
          const typeOrder = this.getBundleTypeOrder()
          const initialSlots = {}
          typeOrder.forEach((t) => {
            initialSlots[t.productType] = [t.swatches.length ? t.swatches[0].variantId : null]
          })
          this.bundleSlotsByType = initialSlots
        }

        // Step text template for addon slides ("Step {step_number}: ...")
        this.stepTextTemplate = typeof state.stepTextTemplate === 'string'
          ? state.stepTextTemplate
          : 'Step {step_number}: Choose your scent.'

        // Listen for slide changes dispatched by the external Swiper init
        const root = this.pdpSwiperRootEl
        if (root) {
          root.addEventListener('pdp-swiper-qty:slide-change', (e) => {
            this.currentSwiperIndex = (e.detail && e.detail.activeIndex != null)
              ? e.detail.activeIndex
              : 0
          })
        }

        this.watchAbPromo()
      },

      // ── Quantity helpers ─────────────────────────────────────────────
      getQty(option1Key) {
        return Number(this.quantityByOption1[option1Key] || 0)
      },

      incrementQty(option1Key) {
        const current = this.getQty(option1Key)
        const weight = option1Key === '__bundle__' ? 3 : 1
        if (this.totalWeightedUnits() + weight > 6) return
        this.quantityByOption1 = { ...this.quantityByOption1, [option1Key]: current + 1 }
        if (option1Key === '__bundle__') {
          const typeOrder = this.getBundleTypeOrder()
          const newSlots = { ...this.bundleSlotsByType }
          typeOrder.forEach((t) => {
            const existing = [...(newSlots[t.productType] || [])]
            existing.push(t.swatches.length ? t.swatches[0].variantId : null)
            newSlots[t.productType] = existing
          })
          this.bundleSlotsByType = newSlots
        } else {
          const existing = [...(this.slotColorByOption1[option1Key] || [])]
          existing.push(this.firstSwatchVariantIdForOption1(option1Key))
          this.slotColorByOption1 = { ...this.slotColorByOption1, [option1Key]: existing }
        }
      },

      decrementQty(option1Key) {
        const current = this.getQty(option1Key)
        if (current <= 0) return
        this.quantityByOption1 = { ...this.quantityByOption1, [option1Key]: current - 1 }
        if (option1Key === '__bundle__') {
          const newSlots = { ...this.bundleSlotsByType }
          Object.keys(newSlots).forEach((pt) => {
            newSlots[pt] = newSlots[pt].slice(0, -1)
          })
          this.bundleSlotsByType = newSlots
        } else {
          const existing = [...(this.slotColorByOption1[option1Key] || [])]
          existing.pop()
          this.slotColorByOption1 = { ...this.slotColorByOption1, [option1Key]: existing }
        }
      },

      totalUnits() {
        return Object.values(this.quantityByOption1).reduce(
          (sum, q) => sum + (Number(q) || 0),
          0
        )
      },

      totalWeightedUnits() {
        const bundleQty = this.getQty('__bundle__')
        const regularQty = Object.entries(this.quantityByOption1)
          .filter(([key]) => key !== '__bundle__')
          .reduce((sum, [, q]) => sum + (Number(q) || 0), 0)
        return regularQty + bundleQty * 3
      },

      canAdvanceFromStep1() {
        if (this.totalUnits() === 0) return false
        const bundleQty = this.getQty('__bundle__')
        if (bundleQty > 0) {
          const typeOrder = this.getBundleTypeOrder()
          for (let ti = 0; ti < typeOrder.length; ti++) {
            const slots = this.bundleSlotsByType[typeOrder[ti].productType] || []
            for (let i = 0; i < bundleQty; i++) {
              if (!slots[i]) return false
            }
          }
        }
        return true
      },

      // ── Swatch / slot helpers ────────────────────────────────────────
      getSwatchesForOption1(option1Key) {
        return this.swatchesByOption1[option1Key] || []
      },

      firstSwatchVariantIdForOption1(option1Key) {
        const swatches = this.getSwatchesForOption1(option1Key)
        if (swatches.length) return swatches[0].variantId
        // Fallback to the defaults map if no swatch data (single-option products)
        return this.defaultByOption1[option1Key] || null
      },

      getSlotVariantId(option1Key, slotIndex) {
        const slots = this.slotColorByOption1[option1Key] || []
        return slots[slotIndex] != null ? slots[slotIndex] : null
      },

      // ── Bundle slot helpers ──────────────────────────────────────────
      getBundleTypeOrder() {
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        const bundleOption1 = this.bundleVariant ? (this.bundleVariant.option1 || '') : ''
        return this.option1Order
          .filter((o1) => !this.hiddenOption1Keys[o1])
          .filter((o1) => !bundleOption1 || o1 !== bundleOption1)
          .map((o1) => {
            for (let i = 0; i < rules.length; i++) {
              if (o1.indexOf(rules[i].match) !== -1) {
                const rule = rules[i]
                const compositeKey = rule.collectionFilter
                  ? rule.productType + '::' + rule.collectionFilter
                  : rule.productType
                return { option1: o1, productType: compositeKey, swatches: this.swatchesByOption1[o1] || [] }
              }
            }
            return null
          })
          .filter(Boolean)
      },

      getBundleUnitCount() {
        return this.getQty('__bundle__')
      },

      isBundleSlotSelected(productType, unitIdx, variantId) {
        const slots = this.bundleSlotsByType[productType] || []
        return slots[unitIdx] === variantId
      },

      setBundleSlotColor(productType, unitIdx, variantId) {
        const slots = [...(this.bundleSlotsByType[productType] || [])]
        slots[unitIdx] = variantId
        this.bundleSlotsByType = { ...this.bundleSlotsByType, [productType]: slots }
      },

      getBundleSlotColorName(productType, unitIdx) {
        const slots = this.bundleSlotsByType[productType] || []
        const variantId = slots[unitIdx]
        if (!variantId) return ''
        const v = this.variantsById[String(variantId)]
        return v ? (v.option2 || '') : ''
      },

      setSlotColor(option1Key, slotIndex, variantId) {
        const slots = [...(this.slotColorByOption1[option1Key] || [])]
        slots[slotIndex] = variantId
        this.slotColorByOption1 = { ...this.slotColorByOption1, [option1Key]: slots }
      },

      isSlotSwatchSelected(option1Key, slotIndex, variantId) {
        const current = this.getSlotVariantId(option1Key, slotIndex)
        return Number(current) === Number(variantId)
      },
      getSlotColorName(option1Key, slotIndex) {
        const variantId = this.getSlotVariantId(option1Key, slotIndex)
        const v = variantId ? this.variantsById[String(variantId)] : null
        return v ? (v.option2 || '') : ''
      },

      // ── Build flat bundle list ───────────────────────────────────────
      // Called when user clicks NEXT on Step 1.
      // Produces: [{ bundleId, variantId, option1, option2, productType }, ...]
      // opts.advance === false skips swiper navigation (used for direct ATC).
      buildBundles(opts) {
        const advance = !(opts && opts.advance === false)
        const order = this.option1Order.length
          ? this.option1Order
          : Object.keys(this.quantityByOption1)

        const bundles = []
        order.forEach((option1Key) => {
          const qty = this.getQty(option1Key)
          const slots = this.slotColorByOption1[option1Key] || []
          for (let i = 0; i < qty; i++) {
            const variantId =
              slots[i] != null
                ? slots[i]
                : this.firstSwatchVariantIdForOption1(option1Key)
            if (!variantId) continue
            const variant = this.getVariantById(variantId)
            if (!variant) continue
            const bundle = {
              bundleId: `_bundle_qty_${variantId}_s${i}_${Date.now()}_${Math.random()
                .toString(36)
                .slice(2, 7)}`,
              variantId: Number(variantId),
              option1: variant.option1 || option1Key,
              option2: variant.option2 || '',
            }
            bundle.productType = this.expectedAddonProductTypeForBundle(bundle)
            bundles.push(bundle)
          }
        })
        // Bundle card entries — one per type per unit
        const bundleQty = this.getQty('__bundle__')
        if (bundleQty > 0 && this.bundleVariant) {
          const typeOrder = this.getBundleTypeOrder()
          for (let unitIdx = 0; unitIdx < bundleQty; unitIdx++) {
            typeOrder.forEach((t) => {
              const slotVarId = (this.bundleSlotsByType[t.productType] || [])[unitIdx]
                || (t.swatches.length ? t.swatches[0].variantId : null)
              if (!slotVarId) return
              const variant = this.getVariantById(slotVarId)
              if (!variant) return
              const bEntry = {
                bundleId: `_bundle_qty_${slotVarId}_u${unitIdx}_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
                variantId: Number(slotVarId),
                option1: variant.option1 || t.option1,
                option2: variant.option2 || '',
                isBundle: true,
                bundleUnitIdx: unitIdx,
              }
              bEntry.productType = this.expectedAddonProductTypeForBundle(bEntry)
              bundles.push(bEntry)
            })
          }
        }

        this.bundles = bundles
        const newGroups = this.buildAddonTypeGroups(bundles)
        this.addonTypeGroups = newGroups

        // Preserve existing scent selections — clip to new limits, drop removed types
        const preserved = {}
        newGroups.forEach((group) => {
          const existing = this.addonQtyByType[group.productType] || {}
          const limit = group.count
          let total = 0
          const clipped = {}
          Object.entries(existing).forEach(([variantId, qty]) => {
            const q = Number(qty) || 0
            if (q <= 0) return
            const take = Math.min(q, limit - total)
            if (take > 0) { clipped[variantId] = take; total += take }
          })
          preserved[group.productType] = clipped
        })
        this.addonQtyByType = preserved

        if (!advance) return

        // After Alpine renders the new x-for slides, update Swiper and advance.
        this.$nextTick(() => {
          const root = this.pdpSwiperRootEl
          if (!root) return
          const rootEl = root.querySelector('.pdp-swiper__root')
          if (!rootEl || !rootEl.swiper) return
          rootEl.swiper.update()
          rootEl.swiper.slideTo(1, 700)
          if (typeof window !== 'undefined' && window.matchMedia &&
              window.matchMedia('(max-width: 989px)').matches) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }
        })
      },

      step1PrimaryClick() {
        if (!this.canAdvanceFromStep1() || this.addToCartLoading) return
        if (this.isPaidBestsellerDirectAtc()) {
          this.buildBundles({ advance: false })
          this.addReviewQtySetToCart()
          return
        }
        this.buildBundles()
      },

      // ── Variant lookup helpers ───────────────────────────────────────
      getVariantById(id) {
        if (!id) return null
        return this.variantsById[String(id)] || null
      },

      variantIsAvailable(v) {
        if (!v) return false
        return v.available !== false
      },

      // ── Image URL helper ─────────────────────────────────────────────
      imageUrlWithWidth(url, width) {
        const src = url != null ? String(url).trim() : ''
        const w = Number(width)
        if (!src) return ''
        if (!w || Number.isNaN(w) || w <= 0) return src
        if (src.includes(' width=')) return src
        if (/[?&]width=\d+/.test(src)) {
          return src.replace(/([?&]width=)\d+/, `$1${w}`)
        }
        const sep = src.includes('?') ? '&' : '?'
        return `${src}${sep}width=${w}`
      },

      // ── Card image helpers (used by aside snippet) ───────────────────
      getCardImageForOption1(option1Key) {
        // Returns the default variant's image for this option1 group
        const defaultId = this.defaultByOption1[option1Key]
        const v = this.getVariantById(defaultId)
        return v && v.image ? this.imageUrlWithWidth(v.image, 248) : ''
      },

      // ── Money formatters ─────────────────────────────────────────────
      formatPdpMoney(cents) {
        const n = Number(cents)
        if (cents == null || cents === '' || Number.isNaN(n)) return ''
        if (typeof window.formatMoney === 'function') {
          return window.formatMoney(n)
        }
        return String(n)
      },

      // ── Terms modal ──────────────────────────────────────────────────
      onTermsAcceptanceChange() {
        this.termsAcceptedAt = this.termsAccepted ? new Date().toISOString() : null
      },

      openTermsModal() {
        this.termsModalOpen = true
        document.body.style.overflow = 'hidden'
        this.$nextTick(() => this.applyAbPromoCopy())
      },

      isDavinci360OptionName(option1) {
        return String(option1 || '').replace(/\s+/g, '').toLowerCase() === 'davinci360'
      },

      abPromoShowsOption(option1) {
        if (!this.abPromoActive && !this.abPromoDavinciOnly) return false
        return this.isDavinci360OptionName(option1)
      },

      isSmartCarDiffuserOption(option1) {
        const name = String(option1 || '')
          .replace(/\u2122/g, '')
          .replace(/[™®]/g, '')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase()
        return name === 'smart car diffuser'
      },

      applyAbPromoStep1Layout() {
        if (!this.abPromoActive) return
        const root = this.pdpSwiperRootEl
        if (!root) return
        const row = root.querySelector('.pdp-swiper__variants-row:not(.pdp-swiper__variants-row--review)')
        const cards = row
          ? Array.from(row.querySelectorAll(':scope > article.pdp-swiper__variant-card'))
          : []
        const davinci = cards.find((el) => this.isDavinci360OptionName(el.dataset.option1))
        if (davinci && row.firstElementChild !== davinci) {
          row.insertBefore(davinci, row.firstElementChild)
        }
        cards.forEach((el) => {
          if (!this.isSmartCarDiffuserOption(el.dataset.option1)) return
          el.style.display = 'none'
        })
        const davinciKey = (this.option1Order || []).find((key) => this.isDavinci360OptionName(key))
        if (davinciKey) {
          this.option1Order = [
            davinciKey,
            ...this.option1Order.filter((key) => key !== davinciKey),
          ]
        }
        const qtyNext = { ...(this.quantityByOption1 || {}) }
        let qtyChanged = false
        Object.keys(qtyNext).forEach((key) => {
          if (!this.isSmartCarDiffuserOption(key) || (Number(qtyNext[key]) || 0) <= 0) return
          qtyNext[key] = 0
          qtyChanged = true
        })
        if (qtyChanged) {
          this.quantityByOption1 = qtyNext
          const slotsNext = { ...(this.slotColorByOption1 || {}) }
          Object.keys(slotsNext).forEach((key) => {
            if (this.isSmartCarDiffuserOption(key)) slotsNext[key] = []
          })
          this.slotColorByOption1 = slotsNext
        }
        const media = root.querySelector('.pdp-swiper__media-swiper')
        const hero = media && media.querySelector('.swiper-slide img')
        if (hero && hero.getAttribute('src') !== QTY_AB_PROMO_HERO_IMAGE) {
          hero.src = QTY_AB_PROMO_HERO_IMAGE
          hero.removeAttribute('srcset')
          hero.removeAttribute('sizes')
        }
        document.querySelectorAll('.pdp-swiper__terms-modal[data-pdp-qty-ab-copy] .pdp-swiper__terms-body').forEach((body) => {
          applyQtyAbPromoTermsCounts(body)
        })
      },

      applyDavinciOnlyPromoCopy() {
        if (!this.abPromoDavinciOnly || !this.pdpSwiperRootEl) return
        this.pdpSwiperRootEl.querySelectorAll('article.pdp-swiper__variant-card').forEach((card) => {
          if (!this.isDavinci360OptionName(card.dataset.option1)) return
          applyQtyAbPromoTextTo(card)
        })
      },

      applyAbPromoCopy() {
        if (isQtyAbPromoExperience()) this.abPromoActive = true
        if (isQtyAbPromoDavinciOnly()) this.abPromoDavinciOnly = true
        this.applyAbPromoStep1Layout()
        this.applyDavinciOnlyPromoCopy()
        const roots = []
        if (this.pdpSwiperRootEl) roots.push(this.pdpSwiperRootEl)
        document.querySelectorAll('[data-pdp-qty-ab-copy]').forEach((el) => {
          if (roots.some((root) => root === el || root.contains(el))) return
          roots.push(el)
        })
        let applied = false
        roots.forEach((root) => {
          if (applyQtyAbPromoCopy(root)) applied = true
        })
        return this.abPromoActive || this.abPromoDavinciOnly || applied
      },

      watchAbPromo() {
        const tick = () => this.applyAbPromoCopy()
        if (tick()) return
        let tries = 0
        const timer = window.setInterval(() => {
          tries += 1
          if (tick() || tries >= 40) window.clearInterval(timer)
        }, 250)
        const queue = (window._conv_q = window._conv_q || [])
        queue.push({
          what: 'addListener',
          params: {
            event: 'snippet.experiences_evaluated',
            handler: () => tick(),
          },
        })
      },

      closeTermsModal() {
        this.termsModalOpen = false
        document.body.style.overflow = ''
      },

      // ── Addon product type resolution ────────────────────────────────
      isPaidBestsellerOption1(option1) {
        return String(option1 || '').toLowerCase().includes('bestseller')
      },

      // Paid when a bestseller set, or when the diffuser is bought on its own (not via the bundle card)
      // and its option1 matches "Paid standalone option1 name". Bundle units stay free.
      isPaidDiffuser(bundle) {
        if (!bundle) return false
        if (this.isPaidBestsellerOption1(bundle.option1)) return true
        return this.isPaidStandaloneOption1(bundle.option1) && !bundle.isBundle
      },

      isPaidStandaloneOption1(option1) {
        const target = this.paidStandaloneOption1
        return !!target && String(option1 || '').trim().toLowerCase() === target
      },

      // True when Step 1 selection is only paid bestseller set(s) (no free-promo units).
      isPaidBestsellerDirectAtc() {
        let hasBestseller = false
        let hasOther = false
        Object.entries(this.quantityByOption1 || {}).forEach(([key, qty]) => {
          if ((Number(qty) || 0) <= 0) return
          if (key === '__bundle__') {
            hasOther = true
            return
          }
          if (this.isPaidBestsellerOption1(key)) hasBestseller = true
          else hasOther = true
        })
        return hasBestseller && !hasOther
      },

      expectedAddonProductTypeForBundle(bundle) {
        if (!bundle || !bundle.option1) return null
        if (this.isPaidBestsellerOption1(bundle.option1)) return null
        const title = String(bundle.option1)
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        for (let i = 0; i < rules.length; i++) {
          if (title.indexOf(rules[i].match) !== -1) {
            const rule = rules[i]
            return rule.collectionFilter ? rule.productType + '::' + rule.collectionFilter : rule.productType
          }
        }
        return null
      },

      // ── Swiper navigation helpers ────────────────────────────────────
      slideTo(idx) {
        const root = this.pdpSwiperRootEl
        if (!root) return
        const rootEl = root.querySelector('.pdp-swiper__root')
        if (!rootEl || !rootEl.swiper) return
        rootEl.swiper.slideTo(idx, 700)
      },

      advanceAddonStep() {
        const root = this.pdpSwiperRootEl
        if (!root) return
        const rootEl = root.querySelector('.pdp-swiper__root')
        if (!rootEl || !rootEl.swiper) return
        rootEl.swiper.slideNext()
        if (typeof window !== 'undefined' && window.matchMedia &&
            window.matchMedia('(max-width: 989px)').matches) {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      },

      // ── Mobile CTA helpers ───────────────────────────────────────────
      mobileNextDisabled() {
        const reviewIdx = this.reviewSlideIndex()
        if (this.currentSwiperIndex === reviewIdx) {
          if (this.addToCartLoading) return true
          if (this.requiresFreePromoTerms() && !this.termsAccepted) return true
          return false
        }
        if (this.currentSwiperIndex === 0) {
          if (this.addToCartLoading) return true
          return !this.canAdvanceFromStep1()
        }
        if (this.isFrequencySlideIndex(this.currentSwiperIndex)) return false
        const groupIdx = this.scentGroupIndexFromSlide(this.currentSwiperIndex)
        const group = groupIdx != null ? this.addonTypeGroups[groupIdx] : null
        if (!group) return true
        return !this.canAdvanceFromTypeStep(group)
      },

      mobileNextClick() {
        const reviewIdx = this.reviewSlideIndex()
        if (this.currentSwiperIndex === reviewIdx) {
          this.addReviewQtySetToCart()
        } else if (this.currentSwiperIndex === 0) {
          this.step1PrimaryClick()
        } else {
          this.advanceAddonStep()
        }
      },

      frequencyStepEnabled() {
        return !!this.frequencyStep && !this.subscriptionOnly
      },

      flowSlides() {
        const slides = []
        this.addonTypeGroups.forEach((group, groupIdx) => {
          if (this.frequencyStepEnabled()) {
            slides.push({
              kind: 'frequency',
              group,
              groupIdx,
              key: 'freq-' + group.productType,
            })
          }
          slides.push({
            kind: 'scent',
            group,
            groupIdx,
            key: 'scent-' + group.productType,
          })
        })
        return slides
      },

      scentSlideIndex(groupIdx) {
        const i = Number(groupIdx || 0)
        return this.frequencyStepEnabled() ? 1 + i * 2 + 1 : 1 + i
      },

      frequencySlideIndex(groupIdx) {
        return 1 + Number(groupIdx || 0) * 2
      },

      reviewSlideIndex() {
        const n = this.addonTypeGroups.length
        return this.frequencyStepEnabled() ? 1 + n * 2 : 1 + n
      },

      isFrequencySlideIndex(idx) {
        if (!this.frequencyStepEnabled()) return false
        const reviewIdx = this.reviewSlideIndex()
        if (idx < 1 || idx >= reviewIdx) return false
        return (idx - 1) % 2 === 0
      },

      scentGroupIndexFromSlide(idx) {
        if (idx < 1 || idx >= this.reviewSlideIndex()) return null
        if (!this.frequencyStepEnabled()) {
          return idx - 1 < this.addonTypeGroups.length ? idx - 1 : null
        }
        const mid = idx - 1
        if (mid % 2 !== 1) return null
        return (mid - 1) / 2
      },

      frequencyStepSubheadline(groupIdx) {
        return 'Step ' + (this.frequencySlideIndex(groupIdx) + 1) + ': Select delivery frequency'
      },

      selectedAddonIdsForGroup(group) {
        if (!group) return []
        const typeMap = this.addonQtyByType[group.productType] || {}
        return Object.keys(typeMap)
          .filter((id) => (Number(typeMap[id]) || 0) > 0)
          .map((id) => Number(id))
      },

      frequencyStepSampleVariantId(group) {
        // Frequency step precedes oil selection, so presume pricing/discount
        // based on the first available oil in the next (scent) step.
        const rows = this.getAddonRowsForGroup(group)
        if (rows.length) return Number(rows[0].id)
        const selected = this.selectedAddonIdsForGroup(group)
        return selected.length ? selected[0] : null
      },

      getGroupPurchaseMode(group) {
        if (!group) return 'subscription'
        const stored = this.groupPurchaseModeByType[group.productType]
        if (stored === 'one_time' || stored === 'subscription') return stored
        const ids = this.selectedAddonIdsForGroup(group)
        if (ids.length) return this.getAddonPurchaseMode(ids[0])
        return 'subscription'
      },

      setGroupPurchaseMode(group, mode) {
        if (!group || this.subscriptionOnly) return
        const next = mode === 'one_time' ? 'one_time' : 'subscription'
        this.groupPurchaseModeByType = {
          ...this.groupPurchaseModeByType,
          [group.productType]: next,
        }
        this.selectedAddonIdsForGroup(group).forEach((id) => this.setAddonPurchaseMode(id, next))
      },

      frequencyStepPricing(group, mode) {
        const id = this.frequencyStepSampleVariantId(group)
        const row = this.addonRowById(id)
        if (!row) return { price: 0, compareAtPrice: 0 }
        return this.normalizedPricing(row, mode === 'one_time' ? 'one_time' : 'subscription')
      },

      frequencyStepPriceDisplay(group, mode) {
        const p = this.frequencyStepPricing(group, mode)
        return this.formatPdpMoney(p.price)
      },

      frequencyStepCompareDisplay(group, mode) {
        const p = this.frequencyStepPricing(group, mode)
        if (!(Number(p.compareAtPrice) > Number(p.price))) return ''
        return this.formatPdpMoney(p.compareAtPrice)
      },

      frequencyStepHasCompare(group, mode) {
        const p = this.frequencyStepPricing(group, mode)
        return Number(p.compareAtPrice) > Number(p.price)
      },

      frequencyStepSavePercent(group) {
        const p = this.frequencyStepPricing(group, 'subscription')
        const compareAt = Number(p.compareAtPrice || 0)
        const price = Number(p.price || 0)
        if (!compareAt || compareAt <= 0 || compareAt <= price) return ''
        return String(Math.round(((compareAt - price) / compareAt) * 100))
      },

      // ── Addon type group builder ─────────────────────────────────────
      buildAddonTypeGroups(bundles) {
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        const seen = []
        const map = {}
        bundles.forEach((bundle) => {
          // Paid bestseller sets already include scents — no oil/frequency step.
          if (this.isPaidBestsellerOption1(bundle.option1)) return
          const compositeKey = bundle.productType || '__none__'
          if (!map[compositeKey]) {
            const o1 = bundle.option1 || ''
            let realProductType = compositeKey
            let collectionFilter = null
            for (let i = 0; i < rules.length; i++) {
              if (o1.indexOf(rules[i].match) !== -1) {
                realProductType = rules[i].productType
                collectionFilter = rules[i].collectionFilter || null
                break
              }
            }
            map[compositeKey] = { productType: compositeKey, realProductType, count: 0, bundles: [], collectionFilter }
            seen.push(compositeKey)
          }
          map[compositeKey].count++
          map[compositeKey].bundles.push(bundle)
        })
        return seen.map((key, idx) => ({
          ...map[key],
          label: 'Oils ' + (idx + 1),
        }))
      },

      // ── Addon step helpers ───────────────────────────────────────────
      getAddonRowsForGroup(group) {
        const productType = group ? (group.realProductType || group.productType) : null
        const collectionFilter = group ? (group.collectionFilter || null) : null
        const qtyKey = group ? group.productType : null
        const rows = Object.values(this.addonVariantsById).filter((row) => row && row.available !== false)
        const filtered = (!productType || productType === '__none__')
          ? rows
          : rows.filter((row) => {
              if (row.productType !== productType) return false
              if (collectionFilter && row.collectionName !== collectionFilter) return false
              return true
            })
        const preview = filtered.slice(0, 5)
        const previewIds = {}
        preview.forEach((row) => {
          previewIds[String(row.id)] = true
        })
        const extras = []
        const typeMap = qtyKey ? (this.addonQtyByType[qtyKey] || {}) : {}
        Object.keys(typeMap).forEach((id) => {
          if ((Number(typeMap[id]) || 0) <= 0) return
          if (previewIds[String(id)]) return
          const row = this.addonRowById(id)
          if (row && row.available !== false) extras.push(row)
        })
        return preview.concat(extras)
      },

      getAddonQty(productType, variantId) {
        const typeMap = this.addonQtyByType[productType] || {}
        return typeMap[String(variantId)] || 0
      },

      incrementAddonQty(productType, variantId) {
        const limit = this.addonTypeLimit(productType)
        if (this.addonTypeTotal(productType) >= limit) return
        const typeMap = { ...(this.addonQtyByType[productType] || {}) }
        typeMap[String(variantId)] = (typeMap[String(variantId)] || 0) + 1
        this.addonQtyByType = { ...this.addonQtyByType, [productType]: typeMap }
        if (this.frequencyStepEnabled()) {
          const mode = this.groupPurchaseModeByType[productType] || 'subscription'
          this.setAddonPurchaseMode(variantId, mode)
        }
      },

      decrementAddonQty(productType, variantId) {
        const typeMap = { ...(this.addonQtyByType[productType] || {}) }
        const current = typeMap[String(variantId)] || 0
        if (current <= 0) return
        typeMap[String(variantId)] = current - 1
        this.addonQtyByType = { ...this.addonQtyByType, [productType]: typeMap }
      },

      addonTypeTotal(productType) {
        const typeMap = this.addonQtyByType[productType] || {}
        return Object.values(typeMap).reduce((sum, q) => sum + (Number(q) || 0), 0)
      },

      addonTypeLimit(productType) {
        const group = this.addonTypeGroups.find((g) => g.productType === productType)
        return group ? group.count : 0
      },

      canAdvanceFromTypeStep(group) {
        if (!group) return false
        return this.addonTypeTotal(group.productType) === this.addonTypeLimit(group.productType)
      },

      addonTypeSubheadline(group) {
        if (!group) return ''
        const n = group.count
        const unit = n === 1 ? 'Oil' : 'Oils'
        const name = group.bundles[0] ? (group.bundles[0].option1 || '') : ''
        return `Choose at least <strong>${n} ${unit}</strong> for the ${name}`
      },

      // ── resolvedPairings: expand addonQtyByType into per-bundle pairs ─
      resolvedPairings() {
        const pairs = []
        const covered = {}
        this.addonTypeGroups.forEach((group) => {
          const typeMap = this.addonQtyByType[group.productType] || {}
          // Expand qty map into flat ordered list of addonVariantIds
          const scentList = []
          Object.entries(typeMap).forEach(([variantId, qty]) => {
            for (let i = 0; i < qty; i++) scentList.push(Number(variantId))
          })
          // Zip sequentially with bundles
          group.bundles.forEach((bundle, idx) => {
            covered[bundle.bundleId] = true
            pairs.push({ bundle, addonVariantId: scentList[idx] || null })
          })
        })
        // Paid bestseller (and any other non-grouped) bundles still need a review/ATC pairing
        ;(this.bundles || []).forEach((bundle) => {
          if (!bundle || covered[bundle.bundleId]) return
          pairs.push({ bundle, addonVariantId: null })
        })
        return pairs
      },

      getBundleDiffuserImage(bundle, width) {
        if (!bundle) return ''
        const variant = this.getVariantById(bundle.variantId)
        if (!variant || !variant.image) return ''
        return this.imageUrlWithWidth(variant.image, width || 2000)
      },

      formatStepText(stepNumber) {
        const tmpl = this.stepTextTemplate || 'Step {step_number}: Choose your scent.'
        return tmpl.replace('{step_number}', String(stepNumber))
      },

      // ── Addon pricing ────────────────────────────────────────────────
      mappedDiscountPercentForType(productType) {
        const pt = productType != null ? String(productType).trim() : ''
        if (!pt) return null
        const rules = parseDiscountByProductTypeRules(this.discountByProductTypeMap)
        for (let i = 0; i < rules.length; i++) {
          if (rules[i].productType === pt) return Number(rules[i].percent)
        }
        return null
      },

      davinci360Selected() {
        return Object.entries(this.quantityByOption1 || {}).some(([key, qty]) => {
          if ((Number(qty) || 0) <= 0) return false
          if (key === '__bundle__') {
            const bundleName = (this.bundleVariant && this.bundleVariant.option1) || this.bundleVariantId || ''
            return this.isDavinci360OptionName(bundleName)
          }
          return this.isDavinci360OptionName(key)
        })
      },

      // Oil|30 stays in place for other diffusers. Davinci360 oils use 20 when this
      // Convert variation is active and that diffuser is selected on step 1.
      davinciAbOilDiscountPercent(row) {
        if (!row || !this.davinci360Selected()) return null
        if (!(this.abPromoActive || isQtyAbPromoExperience())) return null
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        const rule = rules.find((r) => this.isDavinci360OptionName(r.match))
        if (!rule || rule.productType !== 'Oil') return null
        const productType = row.productType != null ? String(row.productType).trim() : ''
        if (productType !== 'Oil') return null
        if (rule.collectionFilter) {
          const collectionName = row.collectionName != null ? String(row.collectionName).trim() : ''
          if (collectionName !== rule.collectionFilter) return null
        }
        return 20
      },

      getAddonPurchaseMode(variantId) {
        if (this.subscriptionOnly) return 'subscription'
        const key = String(variantId)
        const mode = this.addonPurchaseModeById[key]
        return mode === 'one_time' ? 'one_time' : 'subscription'
      },

      setAddonPurchaseMode(variantId, mode) {
        if (this.subscriptionOnly) return
        const next = mode === 'one_time' ? 'one_time' : 'subscription'
        this.addonPurchaseModeById = {
          ...this.addonPurchaseModeById,
          [String(variantId)]: next,
        }
      },

      isAddonSubscription(variantId) {
        return this.getAddonPurchaseMode(variantId) === 'subscription'
      },

      normalizedPricing(v, mode) {
        if (!v) return { price: 0, compareAtPrice: 0 }
        const originalPrice = Number(v.price || 0)
        const originalCompare = Number(v.compareAtPrice || 0)
        const purchaseMode = mode || 'subscription'
        if (purchaseMode === 'one_time') {
          return { price: originalPrice, compareAtPrice: originalCompare }
        }
        const davinciPct = this.davinciAbOilDiscountPercent(v)
        const mappedPct = davinciPct != null
          ? davinciPct
          : this.mappedDiscountPercentForType(v.productType)
        if (mappedPct == null) return { price: originalPrice, compareAtPrice: originalCompare }
        const hasOriginalCompare = originalCompare > originalPrice && originalCompare > 0
        if (hasOriginalCompare && davinciPct == null) {
          const currentPct = ((originalCompare - originalPrice) / originalCompare) * 100
          if (currentPct > mappedPct) return { price: originalPrice, compareAtPrice: originalCompare }
        }
        const base = hasOriginalCompare ? originalCompare : originalPrice
        if (base <= 0) return { price: originalPrice, compareAtPrice: originalCompare }
        const discounted = Math.max(0, Math.round((base * (100 - mappedPct)) / 100))
        if (discounted >= base) return { price: originalPrice, compareAtPrice: originalCompare }
        return { price: discounted, compareAtPrice: base }
      },

      addonRowById(variantId) {
        return this.addonVariantsById[String(variantId)] || null
      },

      normalizedAddonRowById(id) {
        const row = this.addonRowById(id)
        if (!row) return null
        return this.normalizedPricing(row, this.getAddonPurchaseMode(id))
      },

      addonHasCompare(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return false
        return Number(p.compareAtPrice) > Number(p.price)
      },

      addonDisplayCompare(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return ''
        return this.formatPdpMoney(p.compareAtPrice)
      },

      addonDisplayPrice(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return ''
        return this.formatPdpMoney(p.price)
      },

      addonSavePercent(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return ''
        const compareAt = Number(p.compareAtPrice || 0)
        const price = Number(p.price || 0)
        if (!compareAt || compareAt <= 0 || compareAt <= price) return ''
        return String(Math.round(((compareAt - price) / compareAt) * 100))
      },

      // ── Feature metadata (How it works / Subscription perks / Why Aroma360) ──
      featureMetadataForDisplay(meta, option1) {
        const davinciCopy = this.abPromoDavinciOnly && this.isDavinci360OptionName(option1)
        if ((!this.abPromoActive && !davinciCopy) || !Array.isArray(meta)) return meta || []
        return meta.map((section) => ({
          ...section,
          features: (section.features || []).map((fm) => ({
            ...fm,
            headline: replaceQtyAbPromoText(fm.headline),
            description: replaceQtyAbPromoText(fm.description),
          })),
        }))
      },

      getFeatureMetadata() {
        // Use the first option1 group with qty > 0; fallback to first variant overall
        const activeOption1 = this.option1Order.find(
          (key) => this.getQty(key) > 0 && !this.hiddenOption1Keys[key]
        ) || this.option1Order.find((key) => this.getQty(key) > 0)
        const visibleDefaultKey = Object.keys(this.defaultByOption1).find(
          (key) => !this.hiddenOption1Keys[key]
        )
        const variantId = activeOption1
          ? this.defaultByOption1[activeOption1]
          : this.defaultByOption1[visibleDefaultKey] || Object.values(this.defaultByOption1)[0]
        const v = this.getVariantById(variantId)
        if (v && v.featureMetadata && v.featureMetadata.length) {
          return this.featureMetadataForDisplay(v.featureMetadata, v.option1)
        }
        // Fallback: any variant for the same option1 that has metadata
        const option1 = v ? v.option1 : null
        if (option1) {
          const match = Object.values(this.variantsById).find(
            (vv) => vv.option1 === option1 && vv.featureMetadata && vv.featureMetadata.length
          )
          if (match) return this.featureMetadataForDisplay(match.featureMetadata, option1)
        }
        return []
      },

      reviewMainFeatureText(bundle) {
        const v = this.reviewMainVariant(bundle)
        const text = v && v.featureText ? v.featureText : ''
        if (!text) return ''
        const davinciCopy = this.abPromoDavinciOnly && this.isDavinci360OptionName(bundle && bundle.option1)
        if (this.abPromoActive || davinciCopy) return replaceQtyAbPromoText(text)
        return text
      },

      // ── Addon scent data ─────────────────────────────────────────────
      getAddonScentProfile(variantId) {
        const row = this.addonRowById(variantId)
        if (!row) return []
        return Array.isArray(row.scentProfile) ? row.scentProfile : []
      },

      getAddonScentMoods(variantId) {
        const row = this.addonRowById(variantId)
        if (!row) return []
        return Array.isArray(row.scentMoods) ? row.scentMoods : []
      },

      getAddonScentNotes(variantId) {
        const row = this.addonRowById(variantId)
        return row && row.scentNotes ? row.scentNotes : ''
      },

      // ── Review step helpers ──────────────────────────────────────────

      reviewAddonRowForBundle(bundle) {
        if (!bundle) return null
        const pair = this.resolvedPairings().find(
          (p) => p.bundle.bundleId === bundle.bundleId
        )
        if (!pair || !pair.addonVariantId) return null
        return this.addonRowById(pair.addonVariantId) || null
      },

      reviewMainVariant(bundle) {
        if (!bundle) return null
        return this.getVariantById(bundle.variantId)
      },

      reviewMainDisplayPrice(bundle) {
        const v = this.reviewMainVariant(bundle)
        if (!v) return ''
        const cents = this.isPaidDiffuser(bundle)
          ? Number(v.realPrice != null ? v.realPrice : v.price) || 0
          : Number(v.price != null ? v.price : v.realPrice) || 0
        return this.formatPdpMoney(cents)
      },

      reviewMainDisplayCompare(bundle) {
        const v = this.reviewMainVariant(bundle)
        if (!v) return ''
        const c = Number(v.compareAtPrice || 0)
        if (!c || c <= 0) return ''
        return this.formatPdpMoney(c)
      },

      reviewMainHasCompare(bundle) {
        const v = this.reviewMainVariant(bundle)
        if (!v) return false
        const price = this.isPaidDiffuser(bundle)
          ? Number(v.realPrice != null ? v.realPrice : v.price) || 0
          : Number(v.price != null ? v.price : v.realPrice) || 0
        const compare = Number(v.compareAtPrice || 0)
        return compare > price
      },

      reviewSumPriceCents() {
        return this.resolvedPairings().reduce((total, pair) => {
          let sum = total
          const isPaidSet = this.isPaidDiffuser(pair.bundle)
          if (!this.freePromo || isPaidSet) {
            const main = this.getVariantById(pair.bundle.variantId)
            if (main) {
              sum += isPaidSet
                ? Number(main.realPrice != null ? main.realPrice : main.price) || 0
                : Number(main.price != null ? main.price : main.realPrice) || 0
            }
          }
          if (!pair.addonVariantId) return sum
          const row = this.normalizedAddonRowById(pair.addonVariantId)
          return sum + (row ? Number(row.price) || 0 : 0)
        }, 0)
      },

      reviewSumCompareAtCents() {
        return this.resolvedPairings().reduce((total, pair) => {
          let sum = total
          const isPaidSet = this.isPaidDiffuser(pair.bundle)
          if (!this.freePromo || isPaidSet) {
            const main = this.getVariantById(pair.bundle.variantId)
            if (main) {
              const fallback = isPaidSet
                ? Number(main.realPrice != null ? main.realPrice : main.price) || 0
                : Number(main.price != null ? main.price : main.realPrice) || 0
              sum += Number(main.compareAtPrice) || fallback
            }
          }
          if (!pair.addonVariantId) return sum
          const row = this.normalizedAddonRowById(pair.addonVariantId)
          return sum + (row ? Number(row.compareAtPrice) || Number(row.price) || 0 : 0)
        }, 0)
      },

      reviewHasSubscription() {
        return this.resolvedPairings().some((pair) => {
          if (!pair.addonVariantId) return false
          return this.isAddonSubscription(pair.addonVariantId)
        })
      },

      // Step 1 bundle card stores qty under __bundle__; its option1 is bundleVariantId.
      selectedStep1OptionNames() {
        const names = []
        Object.entries(this.quantityByOption1 || {}).forEach(([key, qty]) => {
          if ((Number(qty) || 0) <= 0) return
          if (key === '__bundle__') {
            const bundleName = String(
              (this.bundleVariant && this.bundleVariant.option1) || this.bundleVariantId || ''
            ).trim()
            if (bundleName) names.push(bundleName)
            return
          }
          names.push(String(key).trim())
        })
        return names
      },

      reviewShippingNote() {
        const target = 'mini 2.0 + smart car diffuser + kube'
        const selected = this.selectedStep1OptionNames().some((name) => {
          return String(name || '')
            .replace(/\u2122/g, '')
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase() === target
        })
        const onDavinciTemplate = this.templateSuffix === 'davinci-2-0'
        return onDavinciTemplate || selected ? '+$9.95 Shipping' : '+$9.95 Shipping'
      },

      reviewSubscriptionSumPriceCents() {
        return this.resolvedPairings().reduce((total, pair) => {
          if (!pair.addonVariantId) return total
          if (!this.isAddonSubscription(pair.addonVariantId)) return total
          const row = this.normalizedAddonRowById(pair.addonVariantId)
          return total + (row ? Number(row.price) || 0 : 0)
        }, 0)
      },

      formatPdpMoneyOrFree(cents) {
        const n = Number(cents)
        if (!n || n <= 0) return 'FREE'
        return this.formatPdpMoney(n)
      },

      // ── Cart helpers (mirror existing section) ───────────────────────

      buildBundleId(mainVariantId, addonVariantId) {
        return `_bundle_${mainVariantId}_${addonVariantId}_plan_30_ts_${Date.now()}`
      },

      compareAtCentsString(variantRow) {
        if (!variantRow) return '0'
        const c = Number(variantRow.compareAtPrice || 0)
        if (!c || c <= 0) return '0'
        return String(Math.round(c))
      },

      compareDiscountPercentString(variantRow) {
        if (!variantRow) return '0'
        const cap = Number(variantRow.compareAtPrice || 0)
        const price = Number(variantRow.price || 0)
        if (!cap || cap <= 0 || cap <= price) return '0'
        const pct = Math.round(((cap - price) / cap) * 100)
        return String(Math.max(0, pct))
      },

      buildBundleLineProperties(variantRow, bundleId, tosAcceptedAt, applyFreePromo) {
        const props = {
          _bundle_id: bundleId,
          _bundle_identifier: 'true',
          _compare_at_price: this.compareAtCentsString(variantRow),
          _compare_at_price_discount: this.compareDiscountPercentString(variantRow),
        }
        if (applyFreePromo) {
          props._bundle_promo = 'free-diffuser-set'
          props._free_diffuser_tos_aceptance =
            tosAcceptedAt != null && tosAcceptedAt !== '' ? String(tosAcceptedAt) : ''
        }
        return props
      },

      requiresFreePromoTerms() {
        if (!this.freePromo) return false
        const bundles = this.bundles || []
        if (!bundles.length) return true
        // Paid bestseller-only carts are not part of the free diffuser promo
        return bundles.some((b) => !this.isPaidBestsellerOption1(b.option1))
      },

      // ── Add to cart ──────────────────────────────────────────────────

      async addReviewQtySetToCart() {
        if (this.addToCartLoading) return
        if (this.requiresFreePromoTerms() && !this.termsAccepted) return
        this.addToCartLoading = true
        try {
          const applyFreePromo = this.requiresFreePromoTerms()
          const tosAt = applyFreePromo ? this.termsAcceptedAt : null
          const items = []

          for (const pair of this.resolvedPairings()) {
            const bundle = pair.bundle
            const mainVariant = this.getVariantById(bundle.variantId)
            if (!mainVariant) continue

            const isPaidSet = this.isPaidDiffuser(bundle)
            // Paid standalone diffusers keep the promo properties (the discount app reads them;
            // the per-variant discount amount decides whether the line is actually free).
            const lineFreePromo = applyFreePromo && !this.isPaidBestsellerOption1(bundle.option1)
            const mainForProps = isPaidSet
              ? { ...mainVariant, price: Number(mainVariant.realPrice != null ? mainVariant.realPrice : mainVariant.price) || 0 }
              : mainVariant

            const addonRow = pair.addonVariantId ? this.addonRowById(pair.addonVariantId) : null
            const addonEligible = addonRow && addonRow.available !== false
            const resolvedAddonId = addonEligible ? Number(pair.addonVariantId) : 0

            const bundleId = this.buildBundleId(Number(bundle.variantId), resolvedAddonId)
            const stampDavinciPromo = isQtyAbPromoDavinciOnly() && this.isDavinci360OptionName(bundle.option1)
            const promoProps = stampDavinciPromo ? { _is_ab_promo: 'true' } : {}

            // Diffuser line item
            items.push({
              id: Number(bundle.variantId),
              quantity: 1,
              properties: {
                ...this.buildBundleLineProperties(mainForProps, bundleId, tosAt, lineFreePromo),
                ...promoProps,
                // Standalone paid diffuser: the discount Function skips lines with this property
                // even though the variant carries the 100% metafield discount.
                ...(this.isPaidStandaloneOption1(bundle.option1) && !bundle.isBundle
                  ? { _discount_exclusion: 'true' }
                  : {}),
              },
            })

            // Scent line item
            if (addonEligible) {
              const addonLine = {
                id: resolvedAddonId,
                quantity: 1,
                properties: {
                  ...this.buildBundleLineProperties(addonRow, bundleId, tosAt, lineFreePromo),
                  ...promoProps,
                },
              }
              if (this.isAddonSubscription(resolvedAddonId)) {
                const sp = addonRow.sellingPlanId
                if (sp != null && sp !== '') {
                  addonLine.selling_plan = Number(sp)
                  addonLine.properties._notes = 'Initial Subscription Order'
                }
              }
              items.push(addonLine)
            }
          }

          if (!items.length) return

          if (isQtyAbPromoExperience()) {
            items.forEach((item) => {
              item.properties = { ...(item.properties || {}), _is_ab_promo: 'true' }
            })
          }

          const rootPath =
            typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/'

          const res = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items }),
          })
          const data = await res.json().catch(() => ({}))
          if (!res.ok || data.status === 422) {
            console.error('[pdp-swiper-qty] cart/add error:', data)
            return
          }

          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'))
          document.dispatchEvent(new CustomEvent('eurus:cart:redirect'))
        } catch (err) {
          console.error('[pdp-swiper-qty] addReviewQtySetToCart error:', err)
        } finally {
          this.addToCartLoading = false
        }
      },

      // ── Popup (Learn More) ──────────────────────────────────────────
      openVariantPopup(option1Key) {
        this.popupOption1 = option1Key
        const id = this.defaultByOption1[option1Key]
        const v = id ? this.variantsById[String(id)] : null
        if (!v) {
          const fallback = Object.values(this.variantsById).find((vv) => vv.option1 === option1Key)
          if (!fallback) return
          this.popupVariant = fallback
        } else {
          this.popupVariant = v
        }
        this.popupOpen = true
        this.popupSectionsHtml = ''
        this.$nextTick(() => {
          this.fetchPopupSections(this.popupLinkedProductHandle())
        })
      },
      closePopup() {
        this.popupOpen = false
        this.popupVariant = null
        this.popupOption1 = null
      },
      popupAccordionItems() {
        const option1 = this.popupOption1
        const all = Object.values(this.variantsById)
        const match = all.find((v) => v.option1 === option1 && v.accordionItems?.length)
        return match?.accordionItems || this.popupVariant?.accordionItems || []
      },
      popupLinkedProductHandle() {
        const items = this.popupAccordionItems()
        const item = items.find((i) => i.linkedProductHandle)
        return item?.linkedProductHandle || null
      },
      _initPopupSectionAnimations() {
        const container = this.$refs.popupSections
        if (!container) return
        const store = Alpine.store('xScrollPromotion')
        if (store) {
          const bannerEl = container.querySelector('.el_animate')?.closest('[class*="section-"]')
          if (bannerEl) { store.load(bannerEl); return }
        }
        container.querySelectorAll('.el_animate').forEach((el) => {
          el.classList.add('animate-scroll-banner')
        })
      },
      async fetchPopupSections(handle) {
        if (!handle) return
        if (this.popupSectionsCache[handle] !== undefined) {
          this.popupSectionsHtml = this.popupSectionsCache[handle]
          await this.$nextTick()
          this._initPopupSectionAnimations()
          return
        }
        const items = this.popupAccordionItems()
        const sourceItem = items.find((i) => i.linkedProductHandle === handle)
        let sectionIds = [sourceItem?.popupSection1, sourceItem?.popupSection2].filter(Boolean)
        if (sectionIds.length === 0) {
          const sectionMap = {
            'mini360-scent-diffuser': ['scrolling_banner_JGUym3', 'grid_blocks_mp494W'],
            'smart-car-diffuser': ['scrolling_banner_3aBXMF', 'image_with_text_LtBR7i']
          }
          sectionIds = sectionMap[handle] || []
        }
        const ratingId = 'pdp-popup-okendo-rating'
        try {
          const res = await fetch(`${window.location.origin}/products/${handle}`)
          const html = await res.text()
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          const ratingSection = doc.querySelector(`#shopify-section-${ratingId}`)
          if (ratingSection && this.popupVariant) {
            const tmp = document.createElement('div')
            tmp.innerHTML = ratingSection.outerHTML
            const el = tmp.querySelector('[data-popup-okendo-rating]')
            if (el) {
              try {
                const rd = JSON.parse(el.textContent)
                this.popupVariant = { ...this.popupVariant, reviewCount: rd.reviewCount, reviewRating: rd.reviewRating }
              } catch(e) {}
            }
          }
          let sectionHtml = ''
          sectionIds.forEach((sectionSuffix) => {
            const section = doc.querySelector(`[id*="${sectionSuffix}"]`)
            if (section) sectionHtml += section.outerHTML
          })
          this.popupSectionsCache[handle] = sectionHtml
          this.popupSectionsHtml = sectionHtml
          await this.$nextTick()
          this._initPopupSectionAnimations()
        } catch (e) {
          console.error('Error fetching popup sections:', e)
          this.popupSectionsCache[handle] = ''
          this.popupSectionsHtml = ''
        }
      },
      popupSelectSwatch(variantId) {
        const v = this.variantsById[String(variantId)]
        if (v) this.popupVariant = v
      },
      popupSwatches() {
        if (!this.popupOption1) return []
        const swatches = []
        const seen = {}
        Object.values(this.variantsById).forEach((v) => {
          if (v.option1 !== this.popupOption1) return
          if (!v.available) return
          if (!v.option2 || seen[v.option2]) return
          seen[v.option2] = true
          swatches.push({ id: v.id, label: v.option2, bg: v.swatchBg || '#e0e0e0' })
        })
        return swatches
      },
      isPopupSwatchActive(variantId) {
        return this.popupVariant && Number(this.popupVariant.id) === Number(variantId)
      },
      popupFeatures() {
        if (!this.popupVariant) return []
        return Array.isArray(this.popupVariant.allFeatures) ? this.popupVariant.allFeatures : []
      },
      popupTitle() {
        if (!this.popupVariant) return ''
        return this.popupVariant.option1 || this.popupVariant.title || ''
      },
      popupImage() {
        if (!this.popupVariant) return ''
        return this.popupVariant.image || ''
      },
      popupCompareAtPrice() {
        if (!this.popupVariant) return ''
        const c = Number(this.popupVariant.compareAtPrice || 0)
        const p = Number(this.popupVariant.realPrice || this.popupVariant.price || 0)
        if (c > p) return this.formatPdpMoney(c)
        return ''
      },
      popupShowsFreePrice() {
        if (!this.freePromo) return false
        const o1 =
          (this.popupVariant && this.popupVariant.option1) ||
          this.popupOption1 ||
          ''
        // Paid bestseller sets show catalog price in the learn-more popup
        if (this.isPaidBestsellerOption1(o1)) return false
        if (this.isPaidStandaloneOption1(o1)) return false
        return true
      },
      popupCurrentPrice() {
        if (!this.popupVariant) return ''
        return this.formatPdpMoney(
          Number(this.popupVariant.realPrice != null ? this.popupVariant.realPrice : this.popupVariant.price) || 0
        )
      },
      richTextToHtml(json) {
        if (!json) return ''
        let tree
        try { tree = typeof json === 'string' ? JSON.parse(json) : json }
        catch (e) { return json }
        function walk(node) {
          if (!node) return ''
          if (node.type === 'text') {
            let t = (node.value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            if (node.bold)   t = '<strong>' + t + '</strong>'
            if (node.italic) t = '<em>' + t + '</em>'
            if (node.code)   t = '<code>' + t + '</code>'
            return t
          }
          const inner = (node.children || []).map(walk).join('')
          switch (node.type) {
            case 'root':      return inner
            case 'paragraph': return '<p>' + inner + '</p>'
            case 'heading':   return '<h' + node.level + '>' + inner + '</h' + node.level + '>'
            case 'list':      return node.listType === 'ordered' ? '<ol>' + inner + '</ol>' : '<ul>' + inner + '</ul>'
            case 'list-item': return '<li>' + inner + '</li>'
            case 'link':      return '<a href="' + (node.url || '') + '"' + (node.target ? ' target="' + node.target + '"' : '') + '>' + inner + '</a>'
            default:          return inner
          }
        }
        return walk(tree)
      },

      // ── Review image ────────────────────────────────────────────────
      reviewMappedImageUrl() {
        const bundles = this.bundles || []
        const option1 = bundles.length ? (bundles[0].option1 || '') : ''
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        let productType = null
        for (let i = 0; i < rules.length; i++) {
          if (option1.indexOf(rules[i].match) !== -1) { productType = rules[i].productType; break }
        }
        const mappings = Array.isArray(this.reviewImageMappings) ? this.reviewImageMappings : []
        for (let i = 0; i < mappings.length; i++) {
          const row = mappings[i] || {}
          const rowRules = parseQtyAddonProductTypeRules(row.map || '')
          for (let j = 0; j < rowRules.length; j++) {
            const matches = productType
              ? rowRules[j].productType === productType
              : option1.indexOf(rowRules[j].match) !== -1
            if (matches && row.imageUrl) return row.imageUrl
          }
        }
        return this.productFeaturedImage || ''
      },

      // ── All-Scents modal ─────────────────────────────────────────────
      currentAddonProductType() {
        return this._allScentsProductType || null
      },
      openAllScentsModal(productType, collectionFilter) {
        this._allScentsProductType = productType || null
        this._allScentsCollectionFilter = collectionFilter || null
        this.allScentsModalOpen = true
        this.allScentsDrawerOpen = false
        document.body.style.overflow = 'hidden'
      },
      closeAllScentsModal() {
        this.allScentsModalOpen = false
        this.allScentsDrawerOpen = false
        document.body.style.overflow = ''
      },
      openAllScentsDrawer() {
        this.allScentsDrawerOpen = true
      },
      closeAllScentsDrawer() {
        this.allScentsDrawerOpen = false
      },
      addonRowById(variantId) {
        return this.addonVariantsById[String(variantId)] || null
      },
      allScentsCardImage(variantId) {
        const row = this.addonRowById(variantId)
        if (!row || !row.cardImage) return ''
        const desktop = typeof window !== 'undefined' && window.matchMedia
          ? window.matchMedia('(min-width: 990px)').matches
          : false
        return this.imageUrlWithWidth(row.cardImage, desktop ? 512 : 248)
      },
      normalizeFilterText(value) {
        if (value == null) return ''
        return String(value).trim().toLowerCase()
      },
      isAddonVariantVisible(addonVariantId) {
        const row = this.addonVariantsById[String(addonVariantId)]
        if (!row) return false
        if (row.available === false) return false
        const sp = row.sellingPlanId
        if (sp == null || sp === '' || Number(sp) <= 0) return false
        const compositeKey = this._allScentsProductType
        if (!compositeKey) return true
        const group = this.addonTypeGroups.find((g) => g.productType === compositeKey)
        const realPt = group ? (group.realProductType || group.productType) : compositeKey
        const rowPt = row.productType != null ? String(row.productType).trim() : ''
        if (rowPt !== realPt) return false
        const cf = this._allScentsCollectionFilter
        if (cf) {
          const rowCn = row.collectionName != null ? String(row.collectionName).trim() : ''
          if (rowCn !== cf) return false
        }
        return true
      },
      availableScentProfiles() {
        const out = []
        const seen = {}
        const ids = Object.keys(this.addonVariantsById)
        for (let i = 0; i < ids.length; i++) {
          const id = Number(ids[i])
          if (!this.isAddonVariantVisible(id)) continue
          const list = this.getAddonScentProfile(id)
          for (let j = 0; j < list.length; j++) {
            const sp = list[j] || {}
            const rawName = sp.name != null ? String(sp.name).trim() : ''
            if (!rawName) continue
            const key = this.normalizeFilterText(rawName)
            if (seen[key]) continue
            seen[key] = true
            out.push({ name: rawName, color: sp.color || '' })
          }
        }
        return out
      },
      availableScentMoods() {
        const out = []
        const seen = {}
        const ids = Object.keys(this.addonVariantsById)
        for (let i = 0; i < ids.length; i++) {
          const id = Number(ids[i])
          if (!this.isAddonVariantVisible(id)) continue
          const list = this.getAddonScentMoods(id)
          for (let j = 0; j < list.length; j++) {
            const sm = list[j] || {}
            const rawName = sm.name != null ? String(sm.name).trim() : ''
            if (!rawName) continue
            const key = this.normalizeFilterText(rawName)
            if (seen[key]) continue
            seen[key] = true
            out.push({ name: rawName, image: sm.image || '' })
          }
        }
        return out
      },
      availableCollections() {
        const out = []
        const seen = {}
        const ids = Object.keys(this.addonVariantsById)
        for (let i = 0; i < ids.length; i++) {
          const id = Number(ids[i])
          if (!this.isAddonVariantVisible(id)) continue
          const row = this.addonVariantsById[String(id)]
          const rawName = row && row.collectionName != null ? String(row.collectionName).trim() : ''
          if (!rawName) continue
          const key = this.normalizeFilterText(rawName)
          if (seen[key]) continue
          seen[key] = true
          out.push({ name: rawName })
        }
        return out
      },
      isProfileFilterSelected(name) {
        return this.selectedScentProfileFilters.includes(this.normalizeFilterText(name))
      },
      isMoodFilterSelected(name) {
        return this.selectedScentMoodFilters.includes(this.normalizeFilterText(name))
      },
      isCollectionFilterSelected(name) {
        return this.selectedCollectionFilters.includes(this.normalizeFilterText(name))
      },
      toggleProfileFilter(name) {
        const key = this.normalizeFilterText(name)
        if (!key) return
        if (this.selectedScentProfileFilters.includes(key)) {
          this.selectedScentProfileFilters = this.selectedScentProfileFilters.filter((x) => x !== key)
        } else {
          this.selectedScentProfileFilters = [...this.selectedScentProfileFilters, key]
        }
      },
      toggleMoodFilter(name) {
        const key = this.normalizeFilterText(name)
        if (!key) return
        if (this.selectedScentMoodFilters.includes(key)) {
          this.selectedScentMoodFilters = this.selectedScentMoodFilters.filter((x) => x !== key)
        } else {
          this.selectedScentMoodFilters = [...this.selectedScentMoodFilters, key]
        }
      },
      toggleCollectionFilter(name) {
        const key = this.normalizeFilterText(name)
        if (!key) return
        if (this.selectedCollectionFilters.includes(key)) {
          this.selectedCollectionFilters = this.selectedCollectionFilters.filter((x) => x !== key)
        } else {
          this.selectedCollectionFilters = [...this.selectedCollectionFilters, key]
        }
      },
      addonMatchesSearch(row) {
        const q = this.normalizeFilterText(this.allScentsSearch)
        if (!q) return true
        const title = row && row.cardTitle ? this.normalizeFilterText(row.cardTitle) : ''
        const inspiredBy = row && row.inspiredBy ? this.normalizeFilterText(row.inspiredBy) : ''
        return title.includes(q) || inspiredBy.includes(q)
      },
      addonMatchesProfileFilters(variantId) {
        if (!this.selectedScentProfileFilters.length) return false
        const names = this.getAddonScentProfile(variantId).map((sp) => this.normalizeFilterText(sp && sp.name))
        return this.selectedScentProfileFilters.some((s) => names.includes(s))
      },
      addonMatchesMoodFilters(variantId) {
        if (!this.selectedScentMoodFilters.length) return false
        const names = this.getAddonScentMoods(variantId).map((sm) => this.normalizeFilterText(sm && sm.name))
        return this.selectedScentMoodFilters.some((s) => names.includes(s))
      },
      addonMatchesCollectionFilters(variantId) {
        if (!this.selectedCollectionFilters.length) return false
        const row = this.addonRowById(variantId)
        const name = this.normalizeFilterText(row && row.collectionName)
        if (!name) return false
        return this.selectedCollectionFilters.includes(name)
      },
      addonMatchesSelectedFilters(variantId) {
        const hasProfile = this.selectedScentProfileFilters.length > 0
        const hasMood = this.selectedScentMoodFilters.length > 0
        const hasCol = this.selectedCollectionFilters.length > 0
        if (!hasProfile && !hasMood && !hasCol) return true
        return (
          this.addonMatchesProfileFilters(variantId) ||
          this.addonMatchesMoodFilters(variantId) ||
          this.addonMatchesCollectionFilters(variantId)
        )
      },
      filteredAddonVariantIds() {
        const ids = Object.keys(this.addonVariantsById)
        const out = []
        for (let i = 0; i < ids.length; i++) {
          const id = Number(ids[i])
          if (!this.isAddonVariantVisible(id)) continue
          const row = this.addonRowById(id)
          if (!row) continue
          if (!this.addonMatchesSearch(row)) continue
          if (!this.addonMatchesSelectedFilters(id)) continue
          out.push(id)
        }
        return out
      },
      allScentsSubheadline() {
        const pt = this._allScentsProductType
        const group = pt ? this.addonTypeGroups.find((g) => g.productType === pt) : null
        return this.addonTypeSubheadline(group)
      },
      selectAddonFromAllScents() {
        this.closeAllScentsModal()
        this.$nextTick(() => {
          this.advanceAddonStep()
        })
      },

      // ── Addon popup ──────────────────────────────────────────────────
      openAddonPopup(addonVariantId) {
        const v = this.addonRowById(addonVariantId)
        if (v) {
          this.addonPopupVariant = v
          this.addonPopupOpen = true
          this.addonPopupSectionsHtml = ''
          this.$nextTick(() => {
            this.fetchAddonPopupSections(v.handle)
          })
        }
      },
      closeAddonPopup() {
        this.addonPopupOpen = false
        this.addonPopupVariant = null
      },
      addonPopupTitle() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.cardTitle || ''
      },
      addonPopupImage() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.cardImage || ''
      },
      addonPopupPrice() {
        if (!this.addonPopupVariant) return ''
        return this.addonDisplayPrice(this.addonPopupVariant.id)
      },
      addonPopupCompareAtPrice() {
        if (!this.addonPopupVariant) return ''
        return this.addonDisplayCompare(this.addonPopupVariant.id)
      },
      addonPopupHasCompare() {
        if (!this.addonPopupVariant) return false
        return this.addonHasCompare(this.addonPopupVariant.id)
      },
      addonPopupSavePercent() {
        if (!this.addonPopupVariant) return ''
        const pct = this.addonSavePercent(this.addonPopupVariant.id)
        return pct ? pct + '%' : ''
      },
      addonPopupScentProfile() {
        if (!this.addonPopupVariant) return []
        return Array.isArray(this.addonPopupVariant.scentProfile) ? this.addonPopupVariant.scentProfile : []
      },
      addonPopupScentMoods() {
        if (!this.addonPopupVariant) return []
        return Array.isArray(this.addonPopupVariant.scentMoods) ? this.addonPopupVariant.scentMoods : []
      },
      addonPopupInspiredBy() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.inspiredBy || ''
      },
      addonPopupDescription() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.description || ''
      },
      _initAddonPopupSectionAnimations() {
        const container = this.$refs.addonPopupSections
        if (!container) return
        container.querySelectorAll('.el_animate').forEach(el => {
          el.classList.add('animate-scroll-banner')
        })
      },
      async fetchAddonPopupSections(handle) {
        if (!handle) return
        if (this.addonPopupSectionsCache[handle] !== undefined) {
          this.addonPopupSectionsHtml = this.addonPopupSectionsCache[handle]
          await this.$nextTick()
          this._initAddonPopupSectionAnimations()
          return
        }
        const sectionIds = ['scrolling_banner_3aBXMF', 'image_with_text_LtBR7i']
        try {
          const url = `${window.location.origin}/products/${handle}`
          const res = await fetch(url)
          const html = await res.text()
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          let sectionHtml = ''
          sectionIds.forEach(sectionSuffix => {
            const section = doc.querySelector(`[id*="${sectionSuffix}"]`)
            if (section) sectionHtml += section.outerHTML
          })
          this.addonPopupSectionsCache[handle] = sectionHtml
          this.addonPopupSectionsHtml = sectionHtml
          await this.$nextTick()
          this._initAddonPopupSectionAnimations()
        } catch (e) {
          this.addonPopupSectionsCache[handle] = ''
          this.addonPopupSectionsHtml = ''
        }
      },

    }))
  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-swiper-squeeze"] && !Shopify.designMode) return;
  try {
    

  // ── Swiper init + step breadcrumb sync — mirrors pdp-swiper.liquid's plain
  //    (non-Alpine) event wiring for `.pdp-swiper__next-slide` / `[data-pdp-step]`,
  //    since step navigation here is just "advance to next slide", not driven by
  //    dynamic per-group slide counts like pdp-swiper-quantity.liquid. ──────────
  const syncSqueezeStepState = (swiper) => {
    const root = swiper.el.closest('.pdp-swiper-squeeze')
    if (!root) return
    const active = swiper.activeIndex
    root.setAttribute('data-active-step', String(active))
    root.querySelectorAll('[data-pdp-step]').forEach((btn) => {
      const idx = Number(btn.getAttribute('data-pdp-step'))
      btn.classList.toggle('is-active', idx === active)
      // "Done" (design's `.st.done`) — steps already passed, distinct from
      // the current one, so the header breadcrumb can show completed steps
      // filled in rather than just "current" vs "not yet reached".
      btn.classList.toggle('is-done', idx < active)
    })
    // Also push into Alpine's own reactive state, not just the DOM
    // attribute — isStep1()/isReviewStep() read `activeStepIndex` (a real
    // tracked property) so their x-show bindings actually re-run when the
    // slide changes. Slide navigation here happens via plain
    // swiper.slideTo()/slideNext() calls from outside Alpine's reactivity
    // system, so nothing would otherwise tell those bindings to re-evaluate
    // — reading only the DOM attribute silently never updates after mount.
    if (window.Alpine && typeof window.Alpine.$data === 'function') {
      const data = window.Alpine.$data(root)
      if (data) data.activeStepIndex = active
    }
  }

  const bindSqueezeStepClicks = (swiper) => {
    const root = swiper.el.closest('.pdp-swiper-squeeze')
    if (!root) return
    root.querySelectorAll('[data-pdp-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const idx = Number(btn.getAttribute('data-pdp-step'))
        if (Number.isNaN(idx)) return
        // Same gate as Step 2's "Continue · Review My Set" button
        // (`x-bind:disabled="!allUnitsPicked()"`) — the breadcrumb can jump
        // straight to any step, bypassing that button entirely, so Review
        // needs its own check here or a shopper could reach it with units
        // still missing a scent. Visually unchanged (still looks/feels like
        // a normal clickable breadcrumb step) — it just quietly no-ops
        // instead of navigating when the gate isn't satisfied.
        if (idx === 2 && window.Alpine && typeof window.Alpine.$data === 'function') {
          const data = window.Alpine.$data(root)
          if (data && typeof data.allUnitsPicked === 'function' && !data.allUnitsPicked()) return
        }
        swiper.slideTo(idx)
        // Same reasoning as the Continue button's scroll (see the
        // `.pdp-swiper__next-slide` click handler below) — jumping via the
        // header breadcrumb can land on a step while the page is scrolled
        // deep into a long previous step, so reset to the top here too.
        window.scrollTo({ top: 0, behavior: 'smooth' })
      })
    })
  }

  // ── Sticky media column offset — kept in sync with the theme's actual
  //    fixed header height (`.header-group-container`), rather than a fixed
  //    number baked in at render time. The header's height isn't constant
  //    across breakpoints (the nav/logo/icons reflow at different sizes,
  //    and things like an announcement bar can add/remove height), so a
  //    single hardcoded offset that looked right on one screen size would
  //    under/over-shoot on another — either leaving the image stuck partly
  //    behind the header, or with an oversized gap above it. Recomputed on
  //    resize so it stays correct through breakpoint changes and things
  //    like orientation switches, not just once at page load.
  //
  //    Below the mobile breakpoint the CSS media query below drops
  //    `position: sticky` back to `static` entirely, so there's nothing to
  //    keep in sync there — skip the (unused) measurement work on mobile
  //    rather than doing it on every resize for no visible effect.
  const SQUEEZE_MOBILE_BREAKPOINT = '(max-width: 900px)'
  const SQUEEZE_STICKY_BREATHING_ROOM = 12

  const updateSqueezeStickyOffset = (root) => {
    if (window.matchMedia(SQUEEZE_MOBILE_BREAKPOINT).matches) return
    // This section's own sticky header (`.pdp-swiper-squeeze__hd`) stands in
    // for the theme's global header on this template (which is hidden here
    // — see the `template.suffix` gate in layout/theme.liquid), so it's the
    // one actually occupying the top of the viewport now. Fall back to the
    // theme header for robustness in case this section is ever reused
    // somewhere that still renders it.
    const header = root.querySelector('.pdp-swiper-squeeze__hd') || document.querySelector('.header-group-container')
    const headerHeight = header ? header.getBoundingClientRect().height : 0
    root.style.setProperty('--pdp-desktop-offset', `${Math.round(headerHeight + SQUEEZE_STICKY_BREATHING_ROOM)}px`)
  }

  const bindSqueezeStickyOffsetResize = (root) => {
    let raf = null
    const onResize = () => {
      if (raf) return
      raf = window.requestAnimationFrame(() => {
        raf = null
        updateSqueezeStickyOffset(root)
      })
    }
    window.addEventListener('resize', onResize)
    window.addEventListener('orientationchange', onResize)
  }

  const initSqueezePdpSwiper = (root) => {
    if (typeof window.Swiper === 'undefined') return

    updateSqueezeStickyOffset(root)
    bindSqueezeStickyOffsetResize(root)

    // Nested media swipers (product image carousel) — same pattern as
    // pdp-swiper.liquid / pdp-swiper-quantity.liquid.
    root.querySelectorAll('.pdp-swiper__media-swiper').forEach((mediaEl) => {
      if (mediaEl.swiper) return
      new window.Swiper(mediaEl, {
        nested: true,
        slidesPerView: 1,
        speed: 650,
        breakpoints: { 990: { allowTouchMove: false, simulateTouch: false } },
      })
    })

    const rootEl = root.querySelector('.pdp-swiper__root')
    if (!rootEl || rootEl.swiper) return
    const rootSwiper = new window.Swiper(rootEl, {
      slidesPerView: 1,
      speed: 300,
      // Small real gap between slides — Swiper factors this into its own
      // slide-width/translate math (unlike a CSS margin/padding bolted on
      // after the fact), so adjacent slides no longer sit perfectly
      // edge-to-edge. That edge-to-edge seam was what read as a stray
      // hairline (and, at times, a peek of the next slide's button) along
      // Step 1's right edge — not an unrelated overlap/z-index bug.
      spaceBetween: 3,
      allowTouchMove: false,
      simulateTouch: false,
      // Was desktop-disabled (`breakpoints: { 990: { autoHeight: false } }`)
      // — with it off, Swiper doesn't size the wrapper to the ACTIVE slide,
      // so all 3 slides (laid out in one row) just make the wrapper as tall
      // as the tallest one, regardless of which is actually showing. Bundle
      // mode's Step 2 (3 "choose for each" units, each with its own scent
      // grid) is by far the tallest, so Step 1/3 inherited that height and
      // sat inside a mostly-empty box. Enabling it everywhere makes Swiper
      // measure/set the height to only the current slide (re-measured on
      // slideChange, and kept in sync the rest of the time by the
      // MutationObserver below) — the same mechanism already relied on for
      // mobile, just no longer switched off above 990px.
      autoHeight: true,
      resistanceRatio: 0.5,
      longSwipesRatio: 0.2,
      on: {
        init(sw) {
          syncSqueezeStepState(sw)
          bindSqueezeStepClicks(sw)
        },
        slideChange(sw) {
          syncSqueezeStepState(sw)
        },
      },
    })

    root.querySelectorAll('.pdp-swiper__next-slide').forEach((btn) => {
      btn.addEventListener('click', () => {
        rootSwiper.slideNext()
        // Used to be mobile-only (`max-width: 989px`) — but Step 2 can get
        // just as tall on desktop (e.g. several "choose for each" units
        // stacked up), so clicking Continue there left the page scrolled
        // deep into the middle of Step 3 instead of showing it from the
        // top. Scrolling unconditionally fixes that on every viewport.
        window.scrollTo({ top: 0, behavior: 'smooth' })
      })
    })

    // With `autoHeight: true` (above), Swiper only measures a slide's
    // height once — at init and on slideChange. Everything in these slides
    // is otherwise driven by Alpine (qty going from 1→2 adds a whole extra
    // "choose for each" unit, toggling same/each swaps entire blocks in
    // place, etc.), so the actual
    // content height keeps changing WITHOUT a slideChange ever firing.
    // Swiper never finds out, so it keeps the stale (shorter) height, and
    // — since `.pdp-swiper__root` clips overflow — the new content got cut
    // off instead of the bar/slide growing to fit it. Watching the active
    // slide's subtree and re-running updateAutoHeight() on any mutation
    // keeps Swiper's measurement honest as Alpine's own DOM changes happen.
    const swiperWrapperEl = rootEl.querySelector('.swiper-wrapper')
    if (swiperWrapperEl && typeof window.MutationObserver !== 'undefined') {
      let autoHeightRaf = null
      const scheduleAutoHeightUpdate = () => {
        if (!rootSwiper.params.autoHeight || autoHeightRaf) return
        autoHeightRaf = window.requestAnimationFrame(() => {
          autoHeightRaf = null
          rootSwiper.updateAutoHeight()
        })
      }
      new window.MutationObserver(scheduleAutoHeightUpdate).observe(swiperWrapperEl, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class'],
      })
    }
  }

  const _runSqueezePdpSwiperInit = () => {
    document.querySelectorAll('.pdp-swiper-squeeze').forEach(initSqueezePdpSwiper)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _runSqueezePdpSwiperInit)
  } else {
    _runSqueezePdpSwiperInit()
  }

  // ── Addon filter rule parser: "Match|ProductType" or
  //    "Match|ProductType|CollectionName". The optional third segment lets
  //    two devices that map to the SAME productType (e.g. Mini360 and Kube
  //    are both "Oil") still get their own distinct scent list, filtered to
  //    the add-on group whose name matches CollectionName exactly (see
  //    "collectionName" in the addonVariants hydration below). Without it,
  //    productType alone can't tell Mini360's oils apart from Kube's. ─────
  const parseSqueezeAddonProductTypeRules = (raw) => {
    if (!raw || typeof raw !== 'string') return []
    return raw
      .replace(/\r\n/g, '\n')
      .split(/[,\n]+/)
      .map((s) => s.trim())
      .filter(Boolean)
      .map((segment) => {
        const parts = segment.split('|').map((p) => p.trim())
        const match = parts[0]
        const productType = parts[1] || ''
        const collectionFilter = parts[2] || null
        if (!match || !productType) return null
        return { match, productType, collectionFilter }
      })
      .filter(Boolean)
  }

  // Bundle "same scent for all" — normalizes an addon's cardTitle into a
  // key that matches across devices despite the kind of drift that shows up
  // between otherwise-identical scent names on different product types:
  // stray/missing trademark symbols ("Dream On™" vs "Dream On"), casing,
  // and a dropped leading article ("The Sweetest Taboo™" vs "Sweetest
  // Taboo™"). Confirmed against the real catalog this resolves every
  // currently-shared scent with no manual mapping required.
  const normalizeSqueezeScentKey = (title) => {
    if (!title) return ''
    return String(title)
      .replace(/[™®©]/g, '')
      .toLowerCase()
      .replace(/^the\s+/, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
  }

  // Left-column media swiper's slides are keyed by `data-variant-ids`
  // (pdp-swiper-media-col.liquid, one entry per distinct custom.secondary_image)
  // — same pattern as pdp-swiper.liquid's syncMediaSwipersToVariant(), but
  // pdp-swiper-squeeze never actually called anything like it, so the media
  // column just sat on whichever slide the nested Swiper happened to init on
  // (slide 0 — the first variant with a distinct secondary_image, not any
  // deliberate default) and never moved after that. Called explicitly from
  // selectVariant()/setActiveCard()/changeColor() — i.e. only on real user
  // selections, not from init() — so the section-setting hero slide (slide
  // 0, see pdp-swiper-media-col.liquid's `default_hero_image` param) is what
  // shows until the customer actually picks something.
  const squeezeSyncMediaSwipersToVariant = (root, variantId) => {
    if (!root || !variantId) return
    const variantIdString = String(variantId)
    root.querySelectorAll('.pdp-swiper__media-swiper').forEach((mediaEl) => {
      const mediaSwiper = mediaEl.swiper
      if (!mediaSwiper) return
      const targetIndex = mediaSwiper.slides.findIndex((slide) => {
        const csv = slide.getAttribute('data-variant-ids') || ''
        if (!csv) return false
        return csv.split(',').map((id) => id.trim()).includes(variantIdString)
      })
      if (targetIndex >= 0 && targetIndex !== mediaSwiper.activeIndex) {
        mediaSwiper.slideTo(targetIndex)
      }
    })
  }

  const parseSqueezeDiscountByProductTypeRules = (raw) => {
    if (!raw || typeof raw !== 'string') return []
    return raw
      .replace(/\r\n/g, '\n')
      .split(/[,\n]+/)
      .map((s) => s.trim())
      .filter(Boolean)
      .map((segment) => {
        const idx = segment.lastIndexOf('/')
        if (idx === -1) return null
        const productType = segment.slice(0, idx).trim()
        const percent = segment.slice(idx + 1).trim()
        if (!productType || !percent) return null
        return { productType, percent: Number(percent) }
      })
      .filter(Boolean)
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('pdpSwiperSqueezeState', () => ({

      variantsById: {},
      addonVariantsById: {},
      // { [scentKey]: { [deviceOption1]: variantId } } — built once in init()
      // by buildScentKeyDeviceVariantMap(). See resolveBundleSameScentAddonId().
      scentKeyDeviceVariantMap: {},
      // Set of scentKeys that every device in bundleDeviceOption1s actually
      // stocks — built once in init() by buildSharedScentKeys(). Used to
      // sort allVisibleAddonRows() so the 6-row cap always lands on the
      // scents shared across every device, not just whatever happens to
      // sort first/be entered first in the (currently un-curatable)
      // add-on-products metafield. See allVisibleAddonRows() for why.
      sharedScentKeys: {},
      defaultByOption1: {},
      addonProductTypeMap: '',
      discountByProductTypeMap: '',
      activeVariantId: null,
      selectedAddonVariantId: null,
      termsAccepted: false,
      termsAcceptedAt: null,
      termsModalOpen: false,
      addToCartLoading: false,
      pdpSwiperRootEl: null,

      // ── Step 2 scent grid is hard-capped at 6 — no "show more" at all
      //    (see ADDON_DISPLAY_LIMIT / allVisibleAddonRows()'s shared-scent
      //    sort below for how those 6 are chosen). Merchant can't currently
      //    edit the add-on-products metafield to trim each device's catalog
      //    down to just the shared oils, so this sorts+caps in JS instead —
      //    see the big comment on allVisibleAddonRows(). ──────────────────

      // ── Step 1 selection: single-select card (like pdp-swiper.liquid) +
      //    ONE quantity stepper living in the "Your Selection" confirmation
      //    box (design's `.sumbox`) — not per-card. Increasing qty just adds
      //    more of the same selected device+color as separate bundles.
      qty: 1,
      // Flat list built by buildBundles() on Continue: [{ bundleId, variantId, option1, option2 }]
      bundles: [],
      // { [option1Key]: [{ variantId, option2, swatchBg }, ...] } — used to let the
      // customer change their diffuser's color from Step 2 as well as Step 1.
      swatchesByOption1: {},

      // ── Step 2 same/each toggle (design's `.seg`) — only meaningful when
      //    qty > 1. `sameScent` true = one shared color + one shared scent
      //    for every unit (activeVariantId/selectedAddonVariantId, as before).
      //    false = per-unit arrays below, one entry per unit index. ─────────
      sameScent: true,
      perUnitColorVariantId: [],
      perUnitAddonVariantId: [],
      // "Same scent for all" still shares one fragrance across every unit,
      // but the customer can optionally give each individual diffuser its
      // own color via the "Change" link next to the shared color row — this
      // just toggles that per-unit color picker's visibility; the actual
      // per-unit values still live in perUnitColorVariantId above (reused
      // from "choose for each" rather than a separate array), see
      // togglePerUnitColors().
      perUnitColorsExpanded: false,

      // ── "Whole Home + Car Set" bundle card — selecting it adds one of each
      //    device in `bundleDeviceOption1s` instead of the bundle's own
      //    (usually unavailable) SKU. See the hydration comment in the JSON
      //    block above for why this needs its own state instead of just
      //    being `activeVariantId` pointed at the bundle's variant. ────────
      isBundleMode: false,
      bundleOption1Value: '',
      bundleDeviceOption1s: [],

      // ── Review step "Complete your set" (design's `.ups`/addExtra()/
      //    rmExtra()) — retroactively offers whichever real devices the
      //    customer's current selection DOESN'T already cover, one last
      //    time before Add to Cart. Ordered list of device option1 values
      //    added this way; each becomes its own extra unit appended after
      //    the base units in unitIndexes(). Deliberately keyed off what's
      //    actually in the data model (haveDeviceOption1s()) rather than
      //    "did they pick the bundle card" — bundle mode already has every
      //    device in bundleDeviceOption1s as a base unit, so
      //    completeSetCandidates() naturally comes back empty there with
      //    no special-casing needed. ─────────────────────────────────────
      extraDeviceOption1s: [],

      // ── Step 1 skeleton loader — true once every image inside the
      //    data-pdp-step1-media split (media column + all card thumbnails)
      //    has finished loading, not just once Alpine's own JSON hydration
      //    is done. Alpine init() is effectively instant (the variant JSON
      //    is inline), so gating on that alone still let the real card grid
      //    render with un-loaded <img> tags — visible as a "flash of missing
      //    image" that was worse than a plain skeleton because different
      //    variant images arrived at different times (e.g. the bundle card's
      //    image, already cached, would show while its siblings were still
      //    broken-image icons). ────────────────────────────────────────────
      step1Ready: false,

      // Mirrors the swiper's activeIndex (0/1/2) into real Alpine reactive
      // state — see the comment in syncSqueezeStepState() (plain-JS swiper
      // callback below) for why isStep1()/isReviewStep() need this instead
      // of reading the data-active-step DOM attribute directly.
      activeStepIndex: 0,

      preloadStep1Media() {
        // Two scopes, now that the media column is a sibling of the swiper
        // rather than nested inside Step 1's slide — the media images and
        // Step 1's card thumbnails — instead of one wrapper containing both.
        const mediaScope = this.pdpSwiperRootEl ? this.pdpSwiperRootEl.querySelector('[data-pdp-step1-media]') : null
        const cardsScope = this.pdpSwiperRootEl ? this.pdpSwiperRootEl.querySelector('[data-pdp-step1-cards]') : null
        const imgs = [
          ...(mediaScope ? Array.from(mediaScope.querySelectorAll('img')) : []),
          ...(cardsScope ? Array.from(cardsScope.querySelectorAll('img')) : []),
        ]
        if (!imgs.length) { this.step1Ready = true; return }

        let remaining = imgs.length
        let settled = false
        const finish = () => {
          if (settled) return
          settled = true
          this.step1Ready = true
        }
        const onOne = () => {
          remaining -= 1
          if (remaining <= 0) finish()
        }
        imgs.forEach((img) => {
          if (img.complete) { onOne(); return }
          img.addEventListener('load', onOne, { once: true })
          // A broken/404 image shouldn't hang the skeleton forever — count
          // it as "settled" too so the rest of the (working) content shows.
          img.addEventListener('error', onOne, { once: true })
        })
        // Safety fallback: if something never fires load/error (flaky CDN,
        // a browser quirk), don't leave the customer stuck on a skeleton.
        setTimeout(finish, 4000)
      },

      init() {
        this.pdpSwiperRootEl = this.$el && this.$el.closest ? this.$el.closest('.pdp-swiper-squeeze') : null
        const jsonEl = this.$el.querySelector('[data-pdp-variant-state]')
        if (!jsonEl) return
        let state = null
        try {
          state = JSON.parse(jsonEl.textContent || '{}')
        } catch (e) {
          state = null
        }
        if (!state) return

        ;(state.variants || []).forEach((v) => { this.variantsById[String(v.id)] = v })
        this.addonVariantsById = {}
        ;(state.addonVariants || []).forEach((row) => {
          if (row && row.id != null) this.addonVariantsById[String(row.id)] = row
        })

        this.addonProductTypeMap = typeof state.addonProductTypeMap === 'string' ? state.addonProductTypeMap : ''
        this.discountByProductTypeMap = typeof state.discountByProductTypeMap === 'string' ? state.discountByProductTypeMap : ''
        this.defaultByOption1 = { ...(state.defaults || {}) }
        this.swatchesByOption1 = state.swatchesByOption1 && typeof state.swatchesByOption1 === 'object' ? state.swatchesByOption1 : {}
        this.bundleOption1Value = typeof state.bundleOption1Value === 'string' ? state.bundleOption1Value : ''
        this.bundleDeviceOption1s = Array.isArray(state.bundleDeviceOption1s) ? state.bundleDeviceOption1s : []
        // Built once here (addonVariantsById/bundleDeviceOption1s/addonProductTypeMap
        // are all static after init — nothing that changes it at runtime), and used by
        // resolveBundleSameScentAddonId() to look up each bundle device's own matching
        // variant for whichever scent the customer picked from the shared grid.
        this.scentKeyDeviceVariantMap = this.buildScentKeyDeviceVariantMap()
        this.sharedScentKeys = this.buildSharedScentKeys()

        let mainId = state.initialSelectedVariantId || null
        if (!this.variantIsAvailable(this.getVariantById(mainId))) mainId = null
        if (mainId == null) {
          const defIds = Object.values(this.defaultByOption1)
          for (let i = 0; i < defIds.length; i++) {
            if (this.variantIsAvailable(this.getVariantById(defIds[i]))) { mainId = defIds[i]; break }
          }
        }
        if (mainId == null) mainId = this.firstAvailableVariantIdGlobally()
        this.activeVariantId = mainId

        this.selectedAddonVariantId = this.firstVisibleAddonVariantId()

        // Wait one tick so Alpine's own x-bind:src/x-for directives have
        // actually written the <img> tags into the DOM before we go collect
        // and watch them — querying img elements during init() itself would
        // run before that first render pass.
        this.$nextTick(() => this.preloadStep1Media())
      },

      // ── Variant lookup / selection ───────────────────────────────────────
      getVariantById(id) { return id ? (this.variantsById[String(id)] || null) : null },
      variantIsAvailable(v) { return !!v && v.available !== false },

      firstAvailableVariantIdGlobally() {
        const list = Object.values(this.variantsById)
        for (let i = 0; i < list.length; i++) { if (this.variantIsAvailable(list[i])) return list[i].id }
        return null
      },

      firstAvailableVariantIdForOptionKey(optionKey) {
        const key = optionKey != null ? String(optionKey) : ''
        const list = Object.values(this.variantsById)
        for (let i = 0; i < list.length; i++) {
          const v = list[i]
          if (!this.variantIsAvailable(v)) continue
          if (String(v.option1) === key || String(v.title) === key) return v.id
        }
        return null
      },

      selectVariant(option1Key, variantId) {
        const next = this.getVariantById(variantId)
        if (!this.variantIsAvailable(next)) return
        this.isBundleMode = false
        this.activeVariantId = variantId
        this.qty = 1
        this.resetUnitScentState()
        this.pruneAddonSelection()
        squeezeSyncMediaSwipersToVariant(this.pdpSwiperRootEl, variantId)
      },

      setActiveCard(option1Key) {
        let id = this.defaultByOption1[option1Key]
        if (id != null && !this.variantIsAvailable(this.getVariantById(id))) {
          id = this.firstAvailableVariantIdForOptionKey(option1Key)
        }
        if (id != null) {
          this.isBundleMode = false
          this.activeVariantId = id
          this.qty = 1
          this.resetUnitScentState()
          this.pruneAddonSelection()
          squeezeSyncMediaSwipersToVariant(this.pdpSwiperRootEl, id)
        }
      },

      // Selecting the bundle card doesn't point activeVariantId at the
      // bundle's own (usually unavailable) SKU — it adds one of each device
      // in bundleDeviceOption1s instead, so every unit-scoped helper below
      // (unitDeviceOption1, getUnitColorVariantId, etc.) branches on
      // isBundleMode rather than reading a single activeVariantId.
      selectBundle() {
        if (!this.bundleDeviceOption1s.length) return
        this.isBundleMode = true
        this.activeVariantId = null
        this.selectedAddonVariantId = null
        this.qty = 1
        this.perUnitColorVariantId = []
        this.perUnitAddonVariantId = []
        this.extraDeviceOption1s = []
        // "Same scent for all" is now the starting toggle position — see
        // setSameScent()'s bundle branch for what that actually means here:
        // one shared fragrance (best-effort filtered against the set's
        // first device — see sameScentOption1Override()), but colors stay
        // per-unit and default open (each device has its own color options,
        // there's no single shared swatch row to collapse into). The
        // customer can still switch to "Choose for each" for a fully
        // per-unit fragrance too.
        this.perUnitColorsExpanded = true
        this.sameScent = true
        // activeVariantId is deliberately null in bundle mode (see the
        // comment above this method), so selectVariant()/setActiveCard()'s
        // usual media-sync call never fires for it — the media column just
        // silently stayed on whatever it last showed. The bundle marker IS
        // still a real product variant with its own custom.secondary_image
        // (pdp-swiper-media-col.liquid's slide loop iterates ALL
        // product.variants, availability aside, so its slide already
        // exists), so sync to it directly via bundleVariantId() rather than
        // activeVariantId.
        squeezeSyncMediaSwipersToVariant(this.pdpSwiperRootEl, this.bundleVariantId())
      },

      // The bundle marker's own variant id — looked up by option1 rather
      // than stored directly, since nothing else needed it before this.
      bundleVariantId() {
        if (!this.bundleOption1Value) return null
        const v = Object.values(this.variantsById).find((row) => row && row.option1 === this.bundleOption1Value)
        return v ? v.id : null
      },

      isCardActive(option1Key) {
        if (this.isBundleMode) return option1Key === this.bundleOption1Value
        const active = this.getVariantById(this.activeVariantId)
        return active ? active.option1 === option1Key : false
      },

      isSwatchSelected(option1Key, variantId) {
        return Number(this.activeVariantId) === Number(variantId)
      },

      getCardImage(option1Key) {
        const v = this.getVariantById(this.activeVariantId)
        if (!v || v.option1 !== option1Key) return ''
        return v.image ? this.imageUrlWithWidth(v.image, 248) : ''
      },

      // Reactive color name shown next to a card's swatches (design's
      // `.avl em`) — same "is this card the active one" check as
      // getCardImage() above, so the label always names whichever color is
      // actually showing in the thumbnail. `fallback` is the Liquid-rendered
      // default variant's color name, used before/unless this card is active.
      getCardColorLabel(option1Key, fallback) {
        const v = this.getVariantById(this.activeVariantId)
        if (v && v.option1 === option1Key) return v.option2 || fallback || ''
        return fallback || ''
      },

      // ── Color swatches for the currently-selected device (Step 2 "change
      //    color" row) — same underlying variant swap as selectVariant(), but
      //    doesn't reset qty since the customer already confirmed it on Step 1. ──
      getSwatchesForOption1(option1Key) { return this.swatchesByOption1[option1Key] || [] },

      changeColor(variantId) {
        const next = this.getVariantById(variantId)
        if (!this.variantIsAvailable(next)) return
        this.activeVariantId = variantId
        squeezeSyncMediaSwipersToVariant(this.pdpSwiperRootEl, variantId)
      },

      // "Same scent for all" → "Change" link (next to the shared color row)
      // — reveals a per-unit swatch picker so each diffuser can get its own
      // color while still sharing one fragrance. Reuses getUnitColorVariantId()/
      // setUnitColorVariantId() from "choose for each": since perUnitColorVariantId
      // starts empty, those already fall back to activeVariantId per unit until
      // the customer actually overrides one, so nothing extra is needed to seed
      // the expanded view.
      togglePerUnitColors() {
        if (this.perUnitColorsExpanded) {
          // Collapsing back to "one color for all" — discard any per-unit
          // overrides so every unit reverts to the shared activeVariantId,
          // keeping what's displayed in sync with what reviewBundles()/the
          // cart will actually submit.
          this.perUnitColorVariantId = []
        }
        this.perUnitColorsExpanded = !this.perUnitColorsExpanded
      },

      // ── Step 2 same/each toggle — lets the customer pick one shared
      //    color+scent for every unit, or a distinct color+scent per unit.
      //    Bundle mode now offers this too (it didn't before — each device
      //    in the set needs its own compatible scent, so "same" is a known
      //    imperfect fit there; see sameScentOption1Override() and
      //    setSameScent()'s bundle branch), so this only needs to check
      //    whether there's more than one physical unit at all — which
      //    unitIndexes() already computes correctly for both bundle
      //    ("qty" sets × devices-per-set) and plain multi-qty. ────────────
      showScentToggle() { return this.unitIndexes().length > 1 },

      // Count of "base" units — bundle mode: qty sets × devices-per-set;
      // non-bundle: qty copies of the one selected device. Extra units from
      // "Complete your set" (extraDeviceOption1s) are appended after these,
      // so this is also the offset where extra-unit indexes start.
      baseUnitCount() {
        return this.isBundleMode ? this.qty * this.bundleDeviceOption1s.length : this.qty
      },

      // Bundle mode: qty "sets", each set = one of every device in
      // bundleDeviceOption1s. Non-bundle mode: qty copies of the one
      // selected device. Either way, one extra unit per entry in
      // extraDeviceOption1s is appended at the end.
      unitIndexes() {
        const n = this.baseUnitCount() + this.extraDeviceOption1s.length
        return Array.from({ length: n }, (_, i) => i)
      },

      isExtraUnit(idx) { return idx >= this.baseUnitCount() },
      extraUnitIndex(idx) { return idx - this.baseUnitCount() },

      // Which device (option1) a given unit index represents — every base
      // unit in non-bundle mode is the single selected device; in bundle
      // mode base units cycle through bundleDeviceOption1s, one set at a
      // time; anything past baseUnitCount() is a "Complete your set" extra.
      unitDeviceOption1(idx) {
        const base = this.baseUnitCount()
        if (idx >= base) return this.extraDeviceOption1s[idx - base] || ''
        if (this.isBundleMode) {
          const n = this.bundleDeviceOption1s.length
          return n ? this.bundleDeviceOption1s[idx % n] : ''
        }
        const v = this.getVariantById(this.activeVariantId)
        return v ? (v.option1 || '') : ''
      },

      // Stable per-unit identity for Alpine's x-for :key. Using the raw
      // index alone (what every x-for in this section keyed off before)
      // breaks the moment an extra is removed from the middle of the
      // list: removeExtraDevice() splices extraDeviceOption1s, so every
      // LATER extra shifts down one index — meaning index N now refers
      // to a different device than it did last render. Alpine's keyed
      // diffing matches by key first, so it reuses the existing DOM
      // node/scope that used to sit at that index for the new device
      // instead of unmounting it, and the card just silently relabels in
      // place. Visually indistinguishable from "the wrong device got
      // removed" — which is exactly the bug this fixes. Extras are keyed
      // by their own device identity (unique — addExtraDevice() already
      // dedupes), so removing one never reassigns another extra's node.
      // Base units have no such reordering (nothing ever splices them),
      // so plain position is still safe/stable for them.
      unitKey(idx) {
        return this.isExtraUnit(idx) ? 'x-' + this.unitDeviceOption1(idx) : 'b-' + idx
      },

      // Non-bundle: "#2", "#3", ... Bundle: "— Set #2" once qty > 1 (the
      // device name itself already distinguishes units within one set).
      // Extra units get no suffix — the device name alone is enough, same
      // as the design's addExtra() rows (unitLbl: '').
      unitLabelSuffix(idx) {
        if (this.isExtraUnit(idx)) return ''
        if (this.isBundleMode) {
          const n = this.bundleDeviceOption1s.length || 1
          const setIdx = Math.floor(idx / n) + 1
          return this.qty > 1 ? ' — Set #' + setIdx : ''
        }
        return ' #' + (idx + 1)
      },

      // ── "Complete your set" — retroactively offer whichever real devices
      //    aren't already represented by the current selection. ───────────
      haveDeviceOption1s() {
        if (this.isBundleMode) return this.bundleDeviceOption1s.slice()
        const v = this.getVariantById(this.activeVariantId)
        const have = v && v.option1 ? [v.option1] : []
        return have.concat(this.extraDeviceOption1s)
      },
      completeSetCandidates() {
        const have = new Set(this.haveDeviceOption1s())
        return this.bundleDeviceOption1s.filter((o1) => !have.has(o1))
      },
      // Representative price/image for a candidate device's card — mirrors
      // Step 1's own card data (first available variant for that option1).
      completeSetRowInfo(deviceOption1) {
        const variantId = this.firstAvailableVariantIdForOptionKey(deviceOption1)
        const v = this.getVariantById(variantId)
        const addonRows = this.allVisibleAddonRows(deviceOption1)
        let fromPrice = null
        addonRows.forEach((row) => {
          const p = this.normalizedPricing(row).price
          if (fromPrice == null || p < fromPrice) fromPrice = p
        })
        return {
          option1: deviceOption1,
          image: v && v.image ? this.imageUrlWithWidth(v.image, 248) : '',
          featureText: v ? v.featureText : '',
          compareAt: v ? Number(v.compareAtPrice || v.price || 0) : 0,
          fromPriceCents: fromPrice,
        }
      },
      // Adds one extra unit for this device — defaults to its own first
      // available color, and (via resolveBundleSameScentAddonId(), which is
      // device-agnostic) whichever scent is currently selected, mapped to
      // this device's own matching variant. Matches the design's addExtra():
      // "we'll start it on {scent} in Black, swap anytime."
      addExtraDevice(deviceOption1) {
        if (!deviceOption1 || this.haveDeviceOption1s().includes(deviceOption1)) return
        this.extraDeviceOption1s = [...this.extraDeviceOption1s, deviceOption1]
        // An extra is, by definition, a different device than the base
        // selection — same as bundle mode, there's no longer a single
        // shared swatch row that means anything, so force the per-unit
        // color picker open (see the same reasoning in selectBundle()).
        // Without this, going back to Step 2 after adding one from the
        // review step still showed only the original device's single
        // swatch row, as if the extra didn't exist.
        this.perUnitColorsExpanded = true
      },
      removeExtraDevice(k) {
        // Absolute unit index of the extra being removed — perUnitColorVariantId/
        // perUnitAddonVariantId are keyed by this same absolute index (unitKey()'s
        // stable-by-device key only fixed the *rendering* identity mismatch; these
        // separate pieces of state still address by raw position). Splicing
        // extraDeviceOption1s alone left them pinned to their old positions, so
        // once a color/scent had actually been overridden on a later extra,
        // removing an earlier one shifted that extra down to a new absolute index
        // while its override stayed behind at the old one — silently reapplying to
        // whichever unit now sits there instead. Every later extra's override has
        // to shift down by one right along with it.
        const absIdx = this.baseUnitCount() + k
        const arr = this.extraDeviceOption1s.slice()
        arr.splice(k, 1)
        this.extraDeviceOption1s = arr

        if (absIdx < this.perUnitColorVariantId.length) {
          const colors = this.perUnitColorVariantId.slice()
          colors.splice(absIdx, 1)
          this.perUnitColorVariantId = colors
        }
        if (absIdx < this.perUnitAddonVariantId.length) {
          const addons = this.perUnitAddonVariantId.slice()
          addons.splice(absIdx, 1)
          this.perUnitAddonVariantId = addons
        }
      },

      setSameScent(same) {
        if (this.sameScent === same) return
        if (!same) {
          // Switching to "choose for each": seed every unit from the
          // currently shared picks so nothing starts blank. Reading color
          // through getUnitColorVariantId(i) — rather than a single
          // `this.activeVariantId` — matters for bundle mode: activeVariantId
          // is always null there (see selectBundle()), but that getter
          // already knows to fall back to each unit's own device default
          // instead of copying a null into every slot.
          const addon = this.selectedAddonVariantId
          this.perUnitColorVariantId = this.unitIndexes().map((i) => this.getUnitColorVariantId(i))
          this.perUnitAddonVariantId = this.unitIndexes().map(() => addon)
          this.perUnitColorsExpanded = false
        } else if (this.isBundleMode) {
          // Bundle units are different devices with different color options
          // — there's no single shared swatch row to collapse into the way
          // a repeated single device has (see the "Change" link's own doc
          // comment), so per-unit colors stay in place and the picker just
          // defaults open, with no way to collapse it back to one shared
          // color (the "Change"/"Use one color for all" control only
          // renders when `getVariantById(activeVariantId)` resolves, and
          // activeVariantId is never set in bundle mode). Only the
          // fragrance/oil actually becomes shared here.
          if (this.perUnitAddonVariantId[0] != null) this.selectedAddonVariantId = this.perUnitAddonVariantId[0]
          this.perUnitColorsExpanded = true
        } else {
          // Collapsing back to "same for all": unit #1's picks become the
          // shared pick (matches the concept's setSame(true) behavior).
          if (this.perUnitColorVariantId[0] != null) this.activeVariantId = this.perUnitColorVariantId[0]
          if (this.perUnitAddonVariantId[0] != null) this.selectedAddonVariantId = this.perUnitAddonVariantId[0]
          this.perUnitColorVariantId = []
          this.perUnitAddonVariantId = []
          this.perUnitColorsExpanded = false
        }
        this.sameScent = same
      },

      getUnitColorVariantId(idx) {
        const id = this.perUnitColorVariantId[idx]
        if (id != null) return id
        // Bundle mode has no single shared color to fall back to, and an
        // extra unit ("Complete your set") is a different device than
        // activeVariantId entirely — both default to that device's own
        // first available color instead.
        if (this.isBundleMode || this.isExtraUnit(idx)) return this.firstAvailableVariantIdForOptionKey(this.unitDeviceOption1(idx))
        return this.activeVariantId
      },
      setUnitColorVariantId(idx, variantId) {
        const next = this.getVariantById(variantId)
        if (!this.variantIsAvailable(next)) return
        const arr = this.perUnitColorVariantId.slice()
        arr[idx] = variantId
        this.perUnitColorVariantId = arr
      },

      getUnitAddonVariantId(idx) {
        const id = this.perUnitAddonVariantId[idx]
        if (id != null) return id
        // An extra unit ("Complete your set") has never been through the
        // scent grid — even in "choose for each" mode it needs a sane
        // default rather than sitting unpicked, so it defaults the same
        // way "same scent for all" resolves any unit's addon: whichever
        // scent is currently selected, mapped to this device's own variant.
        if (this.isExtraUnit(idx)) return this.resolveBundleSameScentAddonId(idx)
        return null
      },
      setUnitAddonVariantId(idx, variantId) {
        if (!this.isAddonVariantVisible(variantId, this.unitDeviceOption1(idx))) return
        const arr = this.perUnitAddonVariantId.slice()
        arr[idx] = variantId
        this.perUnitAddonVariantId = arr
      },
      isUnitAddonSelected(idx, variantId) {
        return Number(this.getUnitAddonVariantId(idx)) === Number(variantId)
      },

      allUnitsPicked() {
        if (this.sameScent) return this.selectedAddonVariantId != null
        return this.unitIndexes().every((i) => this.getUnitAddonVariantId(i) != null)
      },

      // ── Quantity — single stepper in the confirmation box ────────────────
      // Capped by total physical diffusers, not by "sets": a normal device is
      // 1 diffuser per set (cap of 6 sets), the bundle is
      // bundleDeviceOption1s.length diffusers per set (currently 3, so only
      // 2 sets fit under the same 6-diffuser cap — adding a 3rd set would be
      // 9 diffusers, over the limit). Scales automatically if the bundle's
      // device count ever changes, rather than hardcoding "bundle max is 2".
      maxPhysicalUnits: 6,

      devicesPerSet() {
        return this.isBundleMode ? Math.max(1, this.bundleDeviceOption1s.length) : 1
      },

      maxQty() {
        return Math.max(1, Math.floor(this.maxPhysicalUnits / this.devicesPerSet()))
      },

      incrementQty() {
        if (this.qty < this.maxQty()) this.qty += 1
        this.resetUnitScentState()
      },
      decrementQty() {
        if (this.qty > 1) this.qty -= 1
        this.resetUnitScentState()
      },
      canAdvanceFromStep1() {
        const hasSelection = this.isBundleMode ? this.bundleDeviceOption1s.length > 0 : !!this.activeVariantId
        return hasSelection && this.qty > 0
      },

      // Gate for the sticky mobile bar's "Continue" button (Step 3 there is
      // "Add to Cart", gated separately by termsAccepted — see the markup).
      // Mirrors whichever in-page CTA is currently hidden on mobile
      // (canAdvanceFromStep1() on Step 1, allUnitsPicked() on Step 2) so the
      // mobile bar enforces the exact same requirements those buttons did,
      // rather than always being enabled just because it's a different button.
      barContinueDisabled() {
        if (this.isStep1()) return !this.canAdvanceFromStep1()
        return !this.allUnitsPicked()
      },

      // Changing the device or the quantity invalidates any "choose for each"
      // picks made on Step 2 (unit count changed / device changed under them)
      // — collapse back to the shared "same for all" mode, matching the
      // concept's selDevice()/chgQty() resets. (Doesn't touch isBundleMode —
      // callers that leave bundle mode set it themselves.)
      resetUnitScentState() {
        this.sameScent = true
        this.perUnitColorVariantId = []
        this.perUnitAddonVariantId = []
        this.perUnitColorsExpanded = false
        // Extras are relative to whatever the base selection was when they
        // were added ("complete your set" around THIS device) — changing
        // the device or quantity invalidates that, same as the per-unit
        // picks above.
        this.extraDeviceOption1s = []
      },

      // ── "Your Selection" reactive confirmation box (design's `.sumbox`) ──
      selectedLine() {
        if (this.isBundleMode) {
          const n = this.bundleDeviceOption1s.length
          if (!n) return null
          let compareAtPerSet = 0
          this.bundleDeviceOption1s.forEach((o1) => {
            const v = this.getVariantById(this.firstAvailableVariantIdForOptionKey(o1))
            if (v) compareAtPerSet += Number(v.compareAtPrice || v.price || 0)
          })
          return {
            option1: this.bundleOption1Value || 'Whole Home + Car Set',
            option2: '',
            qty: this.qty,
            // Crossed-out price scales with how many sets are being added —
            // qty=2 shows double the savings, not just one set's worth.
            compareAt: compareAtPerSet * this.qty,
            // Each "set" is n physical diffusers — used to pluralize/count
            // the sumbox line correctly instead of just echoing qty.
            freeCount: this.qty * n,
          }
        }
        const v = this.getVariantById(this.activeVariantId)
        if (!v) return null
        return {
          option1: v.option1 || v.title || '',
          option2: v.option2 || '',
          qty: this.qty,
          // Same scaling as the bundle branch above — one crossed-out unit
          // price times how many the customer is adding.
          compareAt: Number(v.compareAtPrice || 0) * this.qty,
          freeCount: this.qty,
        }
      },

      // ── Build flat bundle list (Step 1 → Step 2 handoff) ─────────────────
      // `qty` copies of the single selected variant — all identical (same
      // device + color), since the confirmation box's stepper doesn't offer
      // per-unit color choices (matches the concept: "Add a set for another
      // space" just repeats the current selection).
      buildBundles() {
        const variant = this.getVariantById(this.activeVariantId)
        if (!variant) { this.bundles = []; return }
        const bundles = []
        for (let i = 0; i < this.qty; i++) {
          bundles.push({
            bundleId: `_bundle_sq_${variant.id}_s${i}_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
            variantId: Number(variant.id),
            option1: variant.option1 || '',
            option2: variant.option2 || '',
          })
        }
        this.bundles = bundles
      },

      // ── Media-column stat bar (design's ".vis-props") ──────────────────
      // Parses "up to N sq ft" out of the selected variant's featureText —
      // there's no dedicated coverage metafield (checked both reference
      // sections). Falls back to "Your car" for the car diffuser (no sq ft
      // claim), matching the concept's own device-specific fallback.
      coverageLabel() {
        if (this.isBundleMode) return 'Every room'
        const v = this.getVariantById(this.activeVariantId)
        const text = v && v.featureText ? String(v.featureText) : ''
        const m = text.match(/([\d,]+)\s*sq\s*\.?\s*ft/i)
        if (m) return m[1] + ' sq ft'
        if (v && /car/i.test(v.option1 || '')) return 'Your car'
        return 'Portable'
      },

      imageUrlWithWidth(url, width) {
        const src = url != null ? String(url).trim() : ''
        const w = Number(width)
        if (!src) return ''
        if (!w || Number.isNaN(w) || w <= 0) return src
        if (src.includes(' width=')) return src
        if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, `$1${w}`)
        const sep = src.includes('?') ? '&' : '?'
        return `${src}${sep}width=${w}`
      },

      // ── Addon (scent) selection — single-select, filtered to the chosen
      //    device's product type. Accepts an optional option1 override so
      //    bundle-mode's per-unit grids (each unit a different device type)
      //    can ask "what scent fits THIS device" instead of only ever
      //    reading the single shared activeVariantId. ─────────────────────
      // Returns the full matched rule ({ match, productType, collectionFilter })
      // rather than just a type string, so isAddonVariantVisible can also
      // enforce the optional collection filter.
      expectedAddonRule(option1Override) {
        let title = null
        if (option1Override != null) {
          const rep = this.getVariantById(this.firstAvailableVariantIdForOptionKey(option1Override))
          title = rep ? rep.title : null
        } else {
          const main = this.getVariantById(this.activeVariantId)
          title = main ? main.title : null
        }
        if (!title) return null
        const rules = parseSqueezeAddonProductTypeRules(this.addonProductTypeMap)
        for (let i = 0; i < rules.length; i++) { if (String(title).indexOf(rules[i].match) !== -1) return rules[i] }
        return null
      },

      expectedAddonProductType(option1Override) {
        const rule = this.expectedAddonRule(option1Override)
        return rule ? rule.productType : null
      },

      isAddonVariantVisible(addonVariantId, option1Override) {
        const row = this.addonVariantsById[String(addonVariantId)]
        if (!row) return false
        if (row.available === false) return false
        const sp = row.sellingPlanId
        if (sp == null || sp === '' || Number(sp) <= 0) return false
        const rule = this.expectedAddonRule(option1Override)
        if (!rule) return true
        const rowType = row.productType != null ? String(row.productType).trim() : ''
        if (rowType !== rule.productType) return false
        if (rule.collectionFilter) {
          const rowCollection = row.collectionName != null ? String(row.collectionName).trim() : ''
          return rowCollection === rule.collectionFilter
        }
        return true
      },

      // Unsliced match list — shared by visibleAddonRows()/visibleAddonRowsForUnit().
      // Sorted so scentKeys in sharedScentKeys (present on EVERY device — see
      // buildSharedScentKeys()) come first, catalog order preserved within
      // each group otherwise. The grid is hard-capped to 6 with no "show
      // more" (see visibleAddonRows()/visibleAddonRowsForUnit()) and the
      // add-on-products metafield can't currently be curated down to just
      // the shared oils per device, so this sort is what makes the visible
      // 6 the same 6 shared scents regardless of a device's own catalog
      // order/length — sorting here (rather than only in the two slice()
      // call sites) means anything reading "what's visible" agrees.
      allVisibleAddonRows(option1Override) {
        const rows = Object.values(this.addonVariantsById)
          .filter((row) => row && this.isAddonVariantVisible(row.id, option1Override))
        const shared = this.sharedScentKeys
        return rows
          .map((row, i) => ({ row, i, isShared: !!shared[normalizeSqueezeScentKey(row.cardTitle)] }))
          .sort((a, b) => {
            if (a.isShared !== b.isShared) return a.isShared ? -1 : 1
            return a.i - b.i
          })
          .map((entry) => entry.row)
      },

      // Hard cap, no "show more" — see the big comment on allVisibleAddonRows().
      visibleAddonRows(option1Override) {
        const effective = option1Override != null ? option1Override : this.sameScentOption1Override()
        return this.allVisibleAddonRows(effective).slice(0, 6)
      },

      // Per-unit scent grid source for bundle mode's "choose for each"
      // slots — each unit's device can expect a different product type.
      // Same hard 6-row cap, no "show more".
      visibleAddonRowsForUnit(idx) {
        return this.allVisibleAddonRows(this.unitDeviceOption1(idx)).slice(0, 6)
      },

      // "Same scent for all"'s shared grid needs a device to filter
      // compatible product types against. Non-bundle: activeVariantId
      // already provides that for free (expectedAddonRule()'s default
      // branch reads it directly when no override is passed). Bundle mode
      // has no single activeVariantId — it's always null (see
      // selectBundle()) — so this falls back to the set's FIRST device as a
      // stand-in. The tradeoff: the shared oil is only actually guaranteed
      // compatible with that one device; the other two may not stock it.
      // That's the known "may come across an issue with the oil" case —
      // accepted for now rather than solved, per the ask.
      sameScentOption1Override() {
        return this.isBundleMode ? (this.bundleDeviceOption1s[0] || null) : null
      },

      // For each device in the set, finds every addon row that's actually
      // valid for it (same productType/collectionFilter matching
      // isAddonVariantVisible() already does) and indexes it by normalized
      // scentKey — so `map[key][deviceOption1]` gives back exactly the
      // variant that device stocks for that scent, if it stocks it at all.
      buildScentKeyDeviceVariantMap() {
        const map = {}
        const rows = Object.values(this.addonVariantsById)
        this.bundleDeviceOption1s.forEach((deviceOption1) => {
          const rule = this.expectedAddonRule(deviceOption1)
          if (!rule) return
          rows.forEach((row) => {
            if (!row) return
            const rowType = row.productType != null ? String(row.productType).trim() : ''
            if (rowType !== rule.productType) return
            if (rule.collectionFilter) {
              const rowCollection = row.collectionName != null ? String(row.collectionName).trim() : ''
              if (rowCollection !== rule.collectionFilter) return
            }
            const key = normalizeSqueezeScentKey(row.cardTitle)
            if (!key) return
            if (!map[key]) map[key] = {}
            map[key][deviceOption1] = row.id
          })
        })
        return map
      },

      // { [scentKey]: true } for every scentKey stocked by EVERY device in
      // bundleDeviceOption1s — derived from buildScentKeyDeviceVariantMap()
      // (map[key] only has an entry per device that actually stocks that
      // scent, so "every device has one" is just a length check against the
      // device count). Used by allVisibleAddonRows() to sort the shared
      // scents first before the 6-row cap is applied, so the same 6 always
      // surface regardless of a given device's own catalog order.
      buildSharedScentKeys() {
        const shared = {}
        const deviceCount = this.bundleDeviceOption1s.length
        if (!deviceCount) return shared
        Object.keys(this.scentKeyDeviceVariantMap).forEach((key) => {
          const byDevice = this.scentKeyDeviceVariantMap[key]
          if (Object.keys(byDevice).length >= deviceCount) shared[key] = true
        })
        return shared
      },

      // Bundle + "same scent for all": the customer only ever sees/picks
      // ONE card, sourced from the set's first device (see
      // sameScentOption1Override() — kept that way deliberately so the grid
      // itself doesn't change). But each cart line needs THAT unit's own
      // device's matching variant — same fragrance, different SKU/price/
      // selling-plan per device — not the first device's raw id reused for
      // all three (which used to be exactly what shipped: correct for
      // device #1, silently wrong for #2 and #3). Falls back to the shared
      // id if a device has no matching scentKey (shouldn't happen once
      // every device's addon list is curated to the same shared set), so a
      // catalog gap degrades to "wrong SKU for that one device" rather than
      // a missing/broken cart line.
      resolveBundleSameScentAddonId(idx) {
        const selected = this.addonRowById(this.selectedAddonVariantId)
        if (!selected) return this.selectedAddonVariantId
        const key = normalizeSqueezeScentKey(selected.cardTitle)
        const byDevice = this.scentKeyDeviceVariantMap[key]
        const deviceOption1 = this.unitDeviceOption1(idx)
        const resolved = byDevice ? byDevice[deviceOption1] : null
        return resolved != null ? resolved : this.selectedAddonVariantId
      },

      firstVisibleAddonVariantId() {
        const rows = this.visibleAddonRows()
        return rows.length ? rows[0].id : null
      },

      pruneAddonSelection() {
        const sel = this.selectedAddonVariantId
        if (sel == null || !this.isAddonVariantVisible(sel)) {
          this.selectedAddonVariantId = this.firstVisibleAddonVariantId()
        }
      },

      selectAddonVariant(variantId) {
        if (!this.isAddonVariantVisible(variantId, this.sameScentOption1Override())) return
        this.selectedAddonVariantId = variantId
      },

      isAddonSelected(variantId) { return Number(this.selectedAddonVariantId) === Number(variantId) },
      addonRowById(variantId) { return this.addonVariantsById[String(variantId)] || null },

      getAddonScentProfile(variantId) {
        const row = this.addonRowById(variantId)
        return row && Array.isArray(row.scentProfile) ? row.scentProfile : []
      },
      getAddonScentMoods(variantId) {
        const row = this.addonRowById(variantId)
        return row && Array.isArray(row.scentMoods) ? row.scentMoods : []
      },

      // ── Pricing ─────────────────────────────────────────────────────────
      formatPdpMoney(cents) {
        const n = Number(cents)
        if (cents == null || cents === '' || Number.isNaN(n)) return ''
        if (typeof window.formatMoney === 'function') return window.formatMoney(n)
        return String(n)
      },
      formatPdpMoneyOrFree(cents) {
        const n = Number(cents)
        if (!n || n <= 0) return 'FREE'
        return this.formatPdpMoney(n)
      },

      mappedDiscountPercentForType(productType) {
        const pt = productType != null ? String(productType).trim() : ''
        if (!pt) return null
        const rules = parseSqueezeDiscountByProductTypeRules(this.discountByProductTypeMap)
        for (let i = 0; i < rules.length; i++) { if (rules[i].productType === pt) return Number(rules[i].percent) }
        return null
      },

      normalizedPricing(v) {
        if (!v) return { price: 0, compareAtPrice: 0 }
        const originalPrice = Number(v.price || 0)
        const originalCompare = Number(v.compareAtPrice || 0)
        const mappedPct = this.mappedDiscountPercentForType(v.productType)
        if (mappedPct == null) return { price: originalPrice, compareAtPrice: originalCompare }
        const hasOriginalCompare = originalCompare > originalPrice && originalCompare > 0
        if (hasOriginalCompare) {
          const currentPct = ((originalCompare - originalPrice) / originalCompare) * 100
          if (currentPct > mappedPct) return { price: originalPrice, compareAtPrice: originalCompare }
        }
        const base = hasOriginalCompare ? originalCompare : originalPrice
        if (base <= 0) return { price: originalPrice, compareAtPrice: originalCompare }
        const discounted = Math.max(0, Math.round((base * (100 - mappedPct)) / 100))
        if (discounted >= base) return { price: originalPrice, compareAtPrice: originalCompare }
        return { price: discounted, compareAtPrice: base }
      },

      normalizedAddonRowById(id) {
        const row = this.addonRowById(id)
        return row ? this.normalizedPricing(row) : null
      },
      addonHasCompare(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        return p ? Number(p.compareAtPrice) > Number(p.price) : false
      },
      addonDisplayCompare(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        return p ? this.formatPdpMoney(p.compareAtPrice) : ''
      },
      addonDisplayPrice(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        return p ? this.formatPdpMoney(p.price) : ''
      },

      // ── Review step ─────────────────────────────────────────────────────
      isReviewStep() {
        return this.activeStepIndex === 2
      },

      // Drives the external (now-outside-the-swiper) media column's
      // visibility — see the big comment above that markup for why it had
      // to move.
      isStep1() {
        return this.activeStepIndex === 0
      },

      reviewMainVariant() { return this.getVariantById(this.activeVariantId) },

      // Consumed by the shared pdp-swiper-media-col.liquid snippet (media_col_mode:
      // 'review') for the Step 3 media image. The reference sections map this to a
      // merchandiser-configured image by product type; squeeze has no such mapping,
      // so it falls back to the selected diffuser's own image, which is always a
      // sensible "here's what you're getting" review picture.
      reviewMappedImageUrl() {
        const v = this.reviewMainVariant()
        return v && v.image ? this.imageUrlWithWidth(v.image, 2000) : ''
      },
      reviewAddonRow() {
        const id = this.selectedAddonVariantId
        return id == null ? null : (this.addonVariantsById[String(id)] || null)
      },

      // One entry per physical unit (length === qty) — the real source of
      // truth for both the review display and the cart submission, since
      // "same scent for all" vs "choose for each" both collapse to this
      // shape (same/each just decides how the per-unit ids are sourced).
      //
      // variantId always goes through getUnitColorVariantId(), even in
      // "same scent for all" — perUnitColorVariantId is empty there by
      // default, and that getter already falls back to activeVariantId
      // when a unit has no override, so this is identical to reading
      // activeVariantId directly UNLESS the customer used the "Change"
      // link (togglePerUnitColors()) to give one or more units their own
      // color, in which case those overrides now correctly apply.
      //
      // addonVariantId: bundle + "same scent for all" (and now any extra
      // unit from "Complete your set", which is always a different device
      // than the base selection) can't just reuse the shared
      // selectedAddonVariantId directly — see resolveBundleSameScentAddonId()
      // for why (wrong SKU/price/selling-plan for any device other than the
      // one that scent was actually picked against).
      reviewBundles() {
        return this.unitIndexes().map((i) => {
          let addonVariantId
          if (!this.sameScent) {
            addonVariantId = this.getUnitAddonVariantId(i)
          } else if (this.isBundleMode || this.isExtraUnit(i)) {
            addonVariantId = this.resolveBundleSameScentAddonId(i)
          } else {
            addonVariantId = this.selectedAddonVariantId
          }
          return {
            variantId: this.getUnitColorVariantId(i),
            addonVariantId,
          }
        })
      },

      // Collapses identical "same scent for all" bundles into one "× N" row
      // (design's slotList() `entry.all` case); keeps "choose for each"
      // bundles as individual numbered rows.
      reviewGroupedLines() {
        const bundles = this.reviewBundles()
        if (!bundles.length) return []
        // Only collapse into one "× N" row for a genuinely-identical repeated
        // single device. Bundle mode's units are different devices even when
        // sameScent is true (default now — see selectBundle()), and any
        // "Complete your set" extra is by definition a different device too
        // — both cases have their own price/color/addon variant per unit, so
        // grouping them under bundles[0] would sum the wrong numbers into
        // "Due today".
        if (this.sameScent && !this.isBundleMode && !this.extraDeviceOption1s.length) {
          return [{ variantId: bundles[0].variantId, addonVariantId: bundles[0].addonVariantId, count: bundles.length, unitLabel: '' }]
        }
        return bundles.map((b, i) => ({
          variantId: b.variantId,
          addonVariantId: b.addonVariantId,
          count: 1,
          unitLabel: this.isBundleMode ? this.unitLabelSuffix(i) : (bundles.length > 1 ? ' #' + (i + 1) : ''),
        }))
      },

      reviewLineCompareCents(v) {
        if (!v) return 0
        const p = this.normalizedPricing(v)
        const c = Number(p.compareAtPrice || 0)
        const price = Number(p.price || 0)
        return c > price ? c : price
      },

      // Per-card "was" price on the review step — includes the diffuser's
      // own value (normally free, so easy to forget it has one) alongside
      // the oil's, so the crossed-out total actually reflects the full
      // savings ("$139.90 → $27.97/mo") instead of just the oil's own
      // pre-discount price ("$39.95 → $27.97/mo"), which understated it.
      bundleCompareCents(bundle) {
        if (!bundle) return 0
        const main = this.getVariantById(bundle.variantId)
        const addon = this.addonRowById(bundle.addonVariantId)
        return this.reviewLineCompareCents(main) + this.reviewLineCompareCents(addon)
      },
      bundleDisplayCompare(bundle) {
        return this.formatPdpMoney(this.bundleCompareCents(bundle))
      },
      // Only worth showing when it's actually higher than what they'll pay
      // monthly — otherwise crossing out an equal (or lower) number reads
      // as a mistake, not a discount.
      bundleHasCompare(bundle) {
        if (!bundle || !bundle.addonVariantId) return false
        const addon = this.addonRowById(bundle.addonVariantId)
        const addonPrice = addon ? Number(this.normalizedPricing(addon).price || 0) : 0
        return this.bundleCompareCents(bundle) > addonPrice
      },

      reviewSumCompareAtCents() {
        return this.reviewGroupedLines().reduce((sum, line) => {
          const main = this.getVariantById(line.variantId)
          const addon = this.addonRowById(line.addonVariantId)
          return sum + (this.reviewLineCompareCents(main) + this.reviewLineCompareCents(addon)) * line.count
        }, 0)
      },

      reviewSumPriceCents() {
        return this.reviewGroupedLines().reduce((sum, line) => {
          const addon = this.addonRowById(line.addonVariantId)
          const addonPrice = addon ? Number(this.normalizedPricing(addon).price || 0) : 0
          return sum + addonPrice * line.count
        }, 0)
      },

      // ── Terms modal ──────────────────────────────────────────────────
      onTermsAcceptanceChange() { this.termsAcceptedAt = this.termsAccepted ? new Date().toISOString() : null },
      openTermsModal() { this.termsModalOpen = true; document.body.style.overflow = 'hidden' },
      closeTermsModal() { this.termsModalOpen = false; document.body.style.overflow = '' },

      // ── Cart line-item properties — REQUIRED by the third-party discount
      //    app; field names/casing (incl. the existing `_free_diffuser_
      //    tos_aceptance` typo) are reproduced verbatim from pdp-swiper.liquid.
      //    Do not rename. ──────────────────────────────────────────────────
      buildBundleId(mainVariantId, addonVariantId) {
        return `_bundle_${mainVariantId}_${addonVariantId}_plan_30_ts_${Date.now()}`
      },
      compareAtCentsString(variantRow) {
        if (!variantRow) return '0'
        const c = Number(variantRow.compareAtPrice || 0)
        return (!c || c <= 0) ? '0' : String(Math.round(c))
      },
      compareDiscountPercentString(variantRow) {
        if (!variantRow) return '0'
        const cap = Number(variantRow.compareAtPrice || 0)
        const price = Number(variantRow.price || 0)
        if (!cap || cap <= 0 || cap <= price) return '0'
        return String(Math.max(0, Math.round(((cap - price) / cap) * 100)))
      },
      buildBundleLineProperties(variantRow, bundleId, tosAcceptedAt) {
        return {
          _bundle_promo: 'free-diffuser-set',
          _bundle_id: bundleId,
          _bundle_identifier: 'true',
          _compare_at_price: this.compareAtCentsString(variantRow),
          _compare_at_price_discount: this.compareDiscountPercentString(variantRow),
          _free_diffuser_tos_aceptance: tosAcceptedAt != null && tosAcceptedAt !== '' ? String(tosAcceptedAt) : '',
        }
      },

      // ── Add to cart — one main+addon line pair per physical unit ───────
      // Every unit gets its OWN `_bundle_id` (even units sharing the same
      // device/scent under "same for all"), rather than one line with
      // quantity:N — the discount app links each diffuser to its own
      // subscription line, not a shared quantity (see plan doc).
      async addReviewSetToCart() {
        if (!this.termsAccepted || this.addToCartLoading) return
        const bundles = this.reviewBundles()
        if (!bundles.length) return

        this.addToCartLoading = true
        try {
          const tosAt = this.termsAcceptedAt
          const items = []

          bundles.forEach((bundle) => {
            const main = this.getVariantById(bundle.variantId)
            if (!main || main.id == null || !this.variantIsAvailable(main)) return

            const addon = bundle.addonVariantId != null ? this.addonRowById(bundle.addonVariantId) : null
            const addonEligible = !!addon && addon.available !== false
            const mainId = Number(main.id)
            const addonId = addonEligible ? Number(addon.id) : 0
            // Extra random suffix on top of buildBundleId()'s Date.now() —
            // multiple units can be built within the same millisecond in
            // this loop, and each pairing needs a unique id.
            const bundleId = this.buildBundleId(mainId, addonId) + '_' + Math.random().toString(36).slice(2, 7)

            items.push({
              id: mainId,
              quantity: 1,
              properties: this.buildBundleLineProperties(main, bundleId, tosAt),
            })

            if (addonEligible) {
              const addonLine = {
                id: Number(addon.id),
                quantity: 1,
                properties: this.buildBundleLineProperties(addon, bundleId, tosAt),
              }
              const sp = addon.sellingPlanId
              if (sp != null && sp !== '') {
                addonLine.selling_plan = Number(sp)
                addonLine.properties._notes = 'Initial Subscription Order'
              }
              items.push(addonLine)
            }
          })

          if (!items.length) return

          const rootPath = typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/'

          const res = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items }),
          })
          const data = await res.json().catch(() => ({}))
          if (!res.ok || data.status === 422) {
            console.error('[pdp-swiper-squeeze] cart/add error:', data)
            return
          }

          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'))
          document.dispatchEvent(new CustomEvent('eurus:cart:redirect'))
        } catch (err) {
          console.error('[pdp-swiper-squeeze] addReviewSetToCart error:', err)
        } finally {
          this.addToCartLoading = false
        }
      },

    }))
  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-swiper"] && !Shopify.designMode) return;
  try {
    
  const syncStepState = (swiper) => {
    const root = swiper.el.closest('.pdp-swiper')
    if (!root) return
    const active = swiper.activeIndex
    root.setAttribute('data-active-step', String(active))
    root.querySelectorAll('[data-pdp-step]').forEach((btn) => {
      const idx = Number(btn.getAttribute('data-pdp-step'))
      btn.classList.toggle('is-active', idx === active)
    })

    const stepNumber = String(active + 1)
    root.querySelectorAll('[data-step-text-template]').forEach((stepText) => {
      const rawTemplate = stepText.getAttribute('data-step-text-template') || ''
      if (active === 1) {
        stepText.textContent = `Step ${stepNumber}: Choose your scent subscription`
      } else {
        stepText.textContent = rawTemplate.replace(/\{step_number\}/g, stepNumber)
      }
    })
  }

  const bindStepClicks = (swiper) => {
    const root = swiper.el.closest('.pdp-swiper')
    if (!root) return
    root.querySelectorAll('[data-pdp-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const idx = Number(btn.getAttribute('data-pdp-step'))
        if (Number.isNaN(idx)) return
        swiper.slideTo(idx)
      })
    })
  }

  const syncMediaSwipersToVariant = (root, variantId) => {
    if (!root || !variantId) return
    const variantIdString = String(variantId)
    root.querySelectorAll('.pdp-swiper__media-swiper').forEach((mediaEl) => {
      const mediaSwiper = mediaEl.swiper
      if (!mediaSwiper) return
      const targetIndex = mediaSwiper.slides.findIndex(
        (slide) => {
          const csv = slide.getAttribute('data-variant-ids') || ''
          if (!csv) return false
          return csv.split(',').map((id) => id.trim()).includes(variantIdString)
        }
      )
      if (targetIndex >= 0 && targetIndex !== mediaSwiper.activeIndex) {
        mediaSwiper.slideTo(targetIndex)
      }
    })
  }

  const initPdpSwipers = () => {
    if (typeof window.Swiper === 'undefined') return
    document.querySelectorAll('.pdp-swiper').forEach((root) => {
      root.querySelectorAll('.pdp-swiper__media-swiper').forEach((mediaEl) => {
        if (mediaEl.swiper) return
        new Swiper(mediaEl, {
          nested: true,
          slidesPerView: 1,
          speed: 650,
          breakpoints: {
            990: {
              allowTouchMove: false,
              simulateTouch: false,
            },
          },
        })
      })

      const rootSwiperEl = root.querySelector('.pdp-swiper__root')
      if (!rootSwiperEl || rootSwiperEl.swiper) return

      const rootSwiper = new Swiper(rootSwiperEl, {
        slidesPerView: 1,
        speed: 700,
        allowTouchMove: false,
        simulateTouch: false,
        autoHeight: true,
        breakpoints: {
          990: {
            autoHeight: false,
          },
        },
        resistanceRatio: 0.5,
        longSwipesRatio: 0.2,
        on: {
          init(sw) {
            syncStepState(sw)
            bindStepClicks(sw)
          },
          slideChange(sw) {
            syncStepState(sw)
          },
        },
      })

      root.querySelectorAll('.pdp-swiper__next-slide:not(.pdp-swiper__next-slide--atc)').forEach((btn) => {
        btn.addEventListener('click', () => {
          rootSwiper.slideNext()
          if (typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 989px)').matches) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }
        })
      })

      const stateWrapper = root.closest('[x-data]') || root.querySelector('.swiper-wrapper')
      if (stateWrapper) {
        const jsonEl = stateWrapper.querySelector('[data-pdp-variant-state]')
        if (jsonEl) {
          try {
            const state = JSON.parse(jsonEl.textContent || '{}')
            syncMediaSwipersToVariant(root, state.initialSelectedVariantId)
          } catch (e) {
          }
        }
      }
    })
  }

  const initVariantsRowDrag = () => {
    let isDown = false
    let startY = 0
    let scrollTop = 0
    let activeElement = null

    document.addEventListener('mousedown', (e) => {
      const variantsRow = e.target.closest('.pdp-swiper__variants-row')
      if (!variantsRow) return

      isDown = true
      startY = e.clientY
      scrollTop = variantsRow.scrollTop
      activeElement = variantsRow
      variantsRow.classList.add('is-grabbing')
    })

    document.addEventListener('mousemove', (e) => {
      if (!isDown || !activeElement) return
      const y = e.clientY
      const walk = (y - startY) * 0.5
      activeElement.scrollTop = scrollTop - walk
    })

    document.addEventListener('mouseup', () => {
      if (activeElement) {
        activeElement.classList.remove('is-grabbing')
      }
      isDown = false
      activeElement = null
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initPdpSwipers()
      initVariantsRowDrag()
    }, { once: true })
  } else {
    initPdpSwipers()
    initVariantsRowDrag()
  }

  document.addEventListener('pdp-swiper-variant-changed', (event) => {
    const root = event.target.closest('.pdp-swiper')
    if (!root) return
    const variantId = event.detail && event.detail.variantId
    syncMediaSwipersToVariant(root, variantId)
  })

  const parseAddonProductTypeRules = (raw) => {
    if (!raw || typeof raw !== 'string') return []
    return raw
      .replace(/\r\n/g, '\n')
      .split(/[,\n]+/)
      .map((s) => s.trim())
      .filter(Boolean)
      .map((segment) => {
        const idx = segment.indexOf('/')
        if (idx === -1) return null
        const match = segment.slice(0, idx).trim()
        const productType = segment.slice(idx + 1).trim()
        if (!match || !productType) return null
        return { match, productType }
      })
      .filter(Boolean)
  }

  const parseDiscountByProductTypeRules = (raw) => {
    if (!raw || typeof raw !== 'string') return []
    return raw
      .replace(/\r\n/g, '\n')
      .split(/[,\n]+/)
      .map((s) => s.trim())
      .filter(Boolean)
      .map((segment) => {
        const idx = segment.indexOf('/')
        if (idx === -1) return null
        const productType = segment.slice(0, idx).trim()
        const pctRaw = segment.slice(idx + 1).trim()
        const pct = Number(pctRaw)
        if (!productType || Number.isNaN(pct)) return null
        return { productType, percent: Math.max(0, Math.min(100, pct)) }
      })
      .filter(Boolean)
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('pdpSwiperState', () => ({
      variantsById: {},
      defaultByOption1: {},
      activeVariantId: null,
      selectedAddonVariantId: null,
      addonVariantsById: {},
      addonProductTypeMap: '',
      popupOpen: false,
      popupVariant: null,
      popupOption1: null,
      popupSectionsCache: {},
      popupSectionsHtml: '',
      addonPopupOpen: false,
      addonPopupVariant: null,
      addonPopupSectionsCache: {},
      addonPopupSectionsHtml: '',
      discountByProductTypeMap: '',
      termsAccepted: false,
      termsAcceptedAt: null,
      termsModalOpen: false,
      allScentsModalOpen: false,
      allScentsSearch: '',
      allScentsProfileOpen: true,
      allScentsMoodOpen: true,
      allScentsCollectionsOpen: false,
      allScentsDrawerOpen: false,
      selectedScentProfileFilters: [],
      selectedScentMoodFilters: [],
      selectedCollectionFilters: [],
      reviewImageMappings: [],
      pdpSwiperRootEl: null,
      addToCartLoading: false,
      init() {
        this.pdpSwiperRootEl = this.$el && this.$el.closest ? this.$el.closest('.pdp-swiper') : null
        const jsonEl = this.$el.querySelector('[data-pdp-variant-state]')
        if (!jsonEl) return
        let state = null
        try {
          state = JSON.parse(jsonEl.textContent || '{}')
        } catch (e) {
          state = null
        }
        if (!state) return
        ;(state.variants || []).forEach((v) => {
          this.variantsById[String(v.id)] = v
        })
        this.addonVariantsById = {}
        ;(state.addonVariants || []).forEach((row) => {
          if (row && row.id != null) {
            this.addonVariantsById[String(row.id)] = row
          }
        })
        this.addonProductTypeMap =
          typeof state.addonProductTypeMap === 'string' ? state.addonProductTypeMap : ''
        this.discountByProductTypeMap =
          typeof state.discountByProductTypeMap === 'string' ? state.discountByProductTypeMap : ''
        this.reviewImageMappings = Array.isArray(state.reviewImageMappings) ? state.reviewImageMappings : []
        this.defaultByOption1 = { ...(state.defaults || {}) }
        let mainId = state.initialSelectedVariantId || null
        if (!this.variantIsAvailable(this.getVariantById(mainId))) {
          mainId = null
        }
        if (mainId == null) {
          const defIds = Object.values(this.defaultByOption1)
          for (let i = 0; i < defIds.length; i++) {
            const cand = defIds[i]
            if (this.variantIsAvailable(this.getVariantById(cand))) {
              mainId = cand
              break
            }
          }
        }
        if (mainId == null) {
          mainId = this.firstAvailableVariantIdGlobally()
        }
        this.activeVariantId = mainId
        this.selectedAddonVariantId = state.initialAddonVariantId || null
        this.pruneAddonSelection()
        this.$nextTick(() => {
          this.$dispatch('pdp-swiper-variant-changed', { variantId: this.activeVariantId })
        })
      },
      onTermsAcceptanceChange() {
        if (this.termsAccepted) {
          this.termsAcceptedAt = new Date().toISOString()
        } else {
          this.termsAcceptedAt = null
        }
      },
      openTermsModal() {
        this.termsModalOpen = true
        this.updateBodyScrollLock()
      },
      closeTermsModal() {
        this.termsModalOpen = false
        this.updateBodyScrollLock()
      },
      openAllScentsModal() {
        this.allScentsModalOpen = true
        this.allScentsDrawerOpen = false
        this.updateBodyScrollLock()
      },
      closeAllScentsModal() {
        this.allScentsModalOpen = false
        this.allScentsDrawerOpen = false
        this.updateBodyScrollLock()
      },
      openAllScentsDrawer() {
        this.allScentsDrawerOpen = true
      },
      closeAllScentsDrawer() {
        this.allScentsDrawerOpen = false
      },
      updateBodyScrollLock() {
        const lock = this.termsModalOpen || this.allScentsModalOpen
        document.body.style.overflow = lock ? 'hidden' : ''
      },
      buildBundleId(mainVariantId, addonVariantId) {
        return `_bundle_${mainVariantId}_${addonVariantId}_plan_30_ts_${Date.now()}`
      },
      compareAtCentsString(variantRow) {
        if (!variantRow) return '0'
        const c = Number(variantRow.compareAtPrice || 0)
        if (!c || c <= 0) return '0'
        return String(Math.round(c))
      },
      compareDiscountPercentString(variantRow) {
        if (!variantRow) return '0'
        const cap = Number(variantRow.compareAtPrice || 0)
        const price = Number(variantRow.price || 0)
        if (!cap || cap <= 0 || cap <= price) return '0'
        const pct = Math.round(((cap - price) / cap) * 100)
        return String(Math.max(0, pct))
      },
      buildBundleLineProperties(variantRow, bundleId, tosAcceptedAt) {
        const props = {
          _bundle_promo: 'free-diffuser-set',
          _bundle_id: bundleId,
          _bundle_identifier: 'true',
          _compare_at_price: this.compareAtCentsString(variantRow),
          _compare_at_price_discount: this.compareDiscountPercentString(variantRow),
          _free_diffuser_tos_aceptance:
            tosAcceptedAt != null && tosAcceptedAt !== '' ? String(tosAcceptedAt) : '',
        }
        return props
      },
      async addReviewSetToCart() {
        if (!this.termsAccepted || this.addToCartLoading) return
        const main = this.reviewMainVariant()
        if (!main || main.id == null) return
        if (!this.variantIsAvailable(main)) return

        this.addToCartLoading = true
        try {
          const addon = this.reviewAddonRow()
          const mainId = Number(main.id)
          const addonEligible =
            addon && this.selectedAddonVariantId != null && addon.available !== false
          const addonId = addonEligible ? Number(addon.id) : 0
          const bundleId = this.buildBundleId(mainId, addonId)
          const tosAt = this.termsAcceptedAt

          const items = [
            {
              id: mainId,
              properties: this.buildBundleLineProperties(main, bundleId, tosAt),
              quantity: 1,
            },
          ]
          if (addonEligible) {
            const addonLine = {
              id: Number(addon.id),
              properties: this.buildBundleLineProperties(addon, bundleId, tosAt),
              quantity: 1,
            }
            const sp = addon.sellingPlanId
            if (sp != null && sp !== '') {
              addonLine.selling_plan = Number(sp)
              addonLine.properties._notes = "Initial Subscription Order";
            }
            items.push(addonLine)
          }

          const rootPath =
            typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/'
          const payload = { items: items }

          const res = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify(payload),
          })
          const data = await res.json().catch(() => ({}))
          if (!res.ok || data.status === 422) {
            const msg =
              (data && (data.description || data.message)) || res.statusText || 'Could not add to cart'
            console.error('pdp-swiper cart/add', data)
            return
          }
        } catch (err) {
          console.error(err)
        } finally {
          this.addToCartLoading = false
        }
      },
      expectedAddonProductType() {
        const main = this.getVariantById(this.activeVariantId)
        if (!main || !main.title) return null
        const title = String(main.title)
        const rules = parseAddonProductTypeRules(this.addonProductTypeMap)
        for (let i = 0; i < rules.length; i++) {
          const m = rules[i]
          if (title.indexOf(m.match) !== -1) return m.productType
        }
        return null
      },
      isAddonVariantVisible(addonVariantId) {
        const row = this.addonVariantsById[String(addonVariantId)]
        if (!row) return false
        if (row.available === false) return false
        const sp = row.sellingPlanId
        if (sp == null || sp === '' || Number(sp) <= 0) return false
        const expected = this.expectedAddonProductType()
        if (expected === null) return true
        const pt = row.productType != null ? String(row.productType).trim() : ''
        return pt === expected
      },
      isAddonVariantVisibleInStepList(addonVariantId) {
        const targetId = Number(addonVariantId)
        if (!targetId) return false
        const ids = Object.keys(this.addonVariantsById)
        const typeCount = {}
        const perTypeCap = 5
        for (let i = 0; i < ids.length; i++) {
          const id = Number(ids[i])
          if (!this.isAddonVariantVisible(id)) continue
          const row = this.addonVariantsById[String(id)]
          const pt =
            row && row.productType != null && String(row.productType).trim() !== ''
              ? String(row.productType).trim()
              : '__unknown__'
          const nextCount = (typeCount[pt] || 0) + 1
          typeCount[pt] = nextCount
          if (nextCount > perTypeCap) continue
          if (id === targetId) return true
        }
        return false
      },
      firstVisibleAddonVariantId() {
        const ids = Object.keys(this.addonVariantsById)
        for (let i = 0; i < ids.length; i++) {
          const id = ids[i]
          if (this.isAddonVariantVisible(Number(id))) return Number(id)
        }
        return null
      },
      pruneAddonSelection() {
        const sel = this.selectedAddonVariantId
        if (sel == null) return
        if (!this.isAddonVariantVisible(sel)) {
          this.selectedAddonVariantId = this.firstVisibleAddonVariantId()
        }
      },
      formatPdpMoney(cents) {
        const n = Number(cents)
        if (cents == null || cents === '' || Number.isNaN(n)) return ''
        if (typeof window.formatMoney === 'function') {
          return window.formatMoney(n)
        }
        return String(n)
      },
      formatPdpMoneyOrFree(cents) {
        const n = Number(cents)
        if (cents == null || cents === '' || Number.isNaN(n)) return ''
        if (n === 0) return 'FREE'
        return this.formatPdpMoney(n)
      },
      formatPdpMainVariantPrice(v) {
        if (!v) return ''
        if (Number(v.price || 0) === 0) return 'FREE'
        return this.formatPdpMoney(v.price)
      },
      mappedDiscountPercentForType(productType) {
        const pt = productType != null ? String(productType).trim() : ''
        if (!pt) return null
        const rules = parseDiscountByProductTypeRules(this.discountByProductTypeMap)
        for (let i = 0; i < rules.length; i++) {
          const r = rules[i]
          if (r.productType === pt) return Number(r.percent)
        }
        return null
      },
      normalizedPricing(v) {
        if (!v) return { price: 0, compareAtPrice: 0 }
        const originalPrice = Number(v.price || 0)
        const originalCompare = Number(v.compareAtPrice || 0)
        const mappedPct = this.mappedDiscountPercentForType(v.productType)
        if (mappedPct == null) {
          return { price: originalPrice, compareAtPrice: originalCompare }
        }

        const hasOriginalCompare = originalCompare > originalPrice && originalCompare > 0
        if (hasOriginalCompare) {
          const currentPct = ((originalCompare - originalPrice) / originalCompare) * 100
          if (currentPct > mappedPct) {
            return { price: originalPrice, compareAtPrice: originalCompare }
          }
        }

        const base = hasOriginalCompare ? originalCompare : originalPrice
        if (base <= 0) return { price: originalPrice, compareAtPrice: originalCompare }

        const discounted = Math.max(0, Math.round(base * (100 - mappedPct) / 100))
        if (discounted >= base) {
          return { price: originalPrice, compareAtPrice: originalCompare }
        }
        return { price: discounted, compareAtPrice: base }
      },
      normalizedAddonRowById(id) {
        const row = this.addonVariantsById[String(id)]
        if (!row) return null
        return this.normalizedPricing(row)
      },
      addonHasCompare(variantId) {
        const pricing = this.normalizedAddonRowById(variantId)
        if (!pricing) return false
        return Number(pricing.compareAtPrice) > Number(pricing.price)
      },
      addonDisplayCompare(variantId) {
        const pricing = this.normalizedAddonRowById(variantId)
        if (!pricing) return ''
        return this.formatPdpMoney(pricing.compareAtPrice)
      },
      addonDisplayPrice(variantId) {
        const pricing = this.normalizedAddonRowById(variantId)
        if (!pricing) return ''
        return this.formatPdpMoney(pricing.price)
      },
      addonSavePercent(variantId) {
        const pricing = this.normalizedAddonRowById(variantId)
        if (!pricing) return ''
        const compareAt = Number(pricing.compareAtPrice || 0)
        const price = Number(pricing.price || 0)
        if (!compareAt || compareAt <= 0 || compareAt <= price) return ''
        const pct = Math.round(((compareAt - price) / compareAt) * 100)
        if (!pct || pct <= 0) return ''
        return String(pct)
      },
      reviewMainVariant() {
        return this.getVariantById(this.activeVariantId)
      },
      reviewMainDisplayTitle() {
        const v = this.reviewMainVariant()
        if (!v) return ''
        return v.option1 || v.title || ''
      },
      reviewMainHasCompare() {
        const v = this.reviewMainVariant()
        if (!v) return false
        return Number(v.compareAtPrice) > Number(v.price)
      },
      reviewAddonRow() {
        const id = this.selectedAddonVariantId
        if (id == null) return null
        return this.addonVariantsById[String(id)] || null
      },
      reviewAddonHasCompare() {
        const v = this.reviewAddonRow()
        if (!v) return false
        const pricing = this.normalizedPricing(v)
        return Number(pricing.compareAtPrice) > Number(pricing.price)
      },
      reviewAddonSavePercent() {
        const id = this.selectedAddonVariantId
        if (id == null) return ''
        return this.addonSavePercent(id)
      },
      reviewMappedImageUrl() {
        const expectedType = this.expectedAddonProductType()
        if (!expectedType) return ''
        const mappings = Array.isArray(this.reviewImageMappings) ? this.reviewImageMappings : []
        for (let i = 0; i < mappings.length; i++) {
          const row = mappings[i] || {}
          const mapRaw = row.map != null ? String(row.map) : ''
          const parsed = parseAddonProductTypeRules(mapRaw)
          if (!parsed.length) continue
          for (let j = 0; j < parsed.length; j++) {
            const rule = parsed[j]
            if (String(rule.productType).trim() === String(expectedType).trim()) {
              return row.imageUrl != null ? String(row.imageUrl) : ''
            }
          }
        }
        return ''
      },
      reviewLineCompareCents(v) {
        if (!v) return 0
        const pricing = this.normalizedPricing(v)
        const c = Number(pricing.compareAtPrice || 0)
        const p = Number(pricing.price || 0)
        return c > p ? c : p
      },
      reviewSumCompareAtCents() {
        return (
          this.reviewLineCompareCents(this.reviewMainVariant()) +
          this.reviewLineCompareCents(this.reviewAddonRow())
        )
      },
      reviewSumPriceCents() {
        let s = 0
        const m = this.reviewMainVariant()
        const a = this.reviewAddonRow()
        if (m) s += Number(m.price || 0)
        if (a) {
          const addonPricing = this.normalizedPricing(a)
          s += Number(addonPricing.price || 0)
        }
        return s
      },
      getVariantById(id) {
        if (!id) return null
        return this.variantsById[String(id)] || null
      },
      imageUrlWithWidth(url, width) {
        const src = url != null ? String(url).trim() : ''
        const w = Number(width)
        if (!src) return ''
        if (!w || Number.isNaN(w) || w <= 0) return src
        if (src.includes(' width=')) return src
        if (/[?&]width=\d+/.test(src)) {
          return src.replace(/([?&]width=)\d+/, `$1${w}`)
        }
        const sep = src.includes('?') ? '&' : '?'
        return `${src}${sep}width=${w}`
      },
      popupAccordionItems() {
        const option1 = this.popupOption1
        const all = Object.values(this.variantsById)
        const match = all.find(v => v.option1 === option1 && v.accordionItems?.length)
        return match?.accordionItems || this.popupVariant?.accordionItems || []
      },
      popupLinkedProductHandle() {
        const items = this.popupAccordionItems()
        const item = items.find(i => i.linkedProductHandle)
        return item?.linkedProductHandle || null
      },
      _initPopupSectionAnimations() {
        const container = this.$refs.popupSections
        if (!container) return
        const store = Alpine.store('xScrollPromotion')
        if (store) {
          const bannerEl = container.querySelector('.el_animate')?.closest('[class*="section-"]')
          if (bannerEl) { store.load(bannerEl); return }
        }
        container.querySelectorAll('.el_animate').forEach(el => {
          el.classList.add('animate-scroll-banner')
        })
      },
      async fetchPopupSections(handle) {
        if (!handle) return
        if (this.popupSectionsCache[handle] !== undefined) {
          this.popupSectionsHtml = this.popupSectionsCache[handle]
          await this.$nextTick()
          this._initPopupSectionAnimations()
          return
        }
        const items = this.popupAccordionItems()
        const sourceItem = items.find(i => i.linkedProductHandle === handle)
        let sectionIds = [sourceItem?.popupSection1, sourceItem?.popupSection2].filter(Boolean)
        if (sectionIds.length === 0) {
          const sectionMap = {
            'mini360-scent-diffuser': ['scrolling_banner_JGUym3', 'grid_blocks_mp494W'],
            'smart-car-diffuser': ['scrolling_banner_3aBXMF', 'image_with_text_LtBR7i'] 
          }
          sectionIds = sectionMap[handle] || []
        }
        const ratingId = 'pdp-popup-okendo-rating'
        try {
          const url = `${window.location.origin}/products/${handle}`
          // console.log('Fetching product page from:', url)
          const res = await fetch(url)
          // console.log('Fetch response status:', res.status)
          const html = await res.text()

          // Parse HTML and extract sections
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')

          // const allSectionIds = Array.from(doc.querySelectorAll('[id*="shopify-section"]')).map(el => el.id)
          // console.log('Product handle:', handle)
          // console.log('All sections found in page:', allSectionIds)
          // console.log('Looking for section suffixes:', sectionIds)

          // Extract rating section
          const ratingSection = doc.querySelector(`#shopify-section-${ratingId}`)
          const ratingHtml = ratingSection ? ratingSection.outerHTML : ''
          // console.log('Rating section found:', !!ratingSection)
          // console.log('Looking for section ID:', `shopify-section-${ratingId}`)

          if (ratingHtml && this.popupVariant) {
            const tmp = document.createElement('div')
            tmp.innerHTML = ratingHtml
            const el = tmp.querySelector('[data-popup-okendo-rating]')
            if (el) {
              try {
                const rd = JSON.parse(el.textContent)
                this.popupVariant = { ...this.popupVariant, reviewCount: rd.reviewCount, reviewRating: rd.reviewRating }
              } catch(e) {}
            }
          }

          // Extract popup sections dynamically by their suffix
          let sectionHtml = ''
          sectionIds.forEach(sectionSuffix => {
            // Find section that contains this suffix, regardless of template ID
            const section = doc.querySelector(`[id*="${sectionSuffix}"]`)
            if (section) {
              // console.log(`Section ${sectionSuffix} found:`, section.id)
              sectionHtml += section.outerHTML
            } else {
              // console.log(`Section ${sectionSuffix} not found`)
            }
          })

          // console.log('Extracted sections HTML:', sectionHtml)
          this.popupSectionsCache[handle] = sectionHtml
          this.popupSectionsHtml = sectionHtml
          await this.$nextTick()
          this._initPopupSectionAnimations()
        } catch (e) {
          console.error('Error fetching popup sections:', e)
          this.popupSectionsCache[handle] = ''
          this.popupSectionsHtml = ''
        }
      },
      _initAddonPopupSectionAnimations() {
        const container = this.$refs.addonPopupSections
        if (!container) return
        const store = Alpine.store('xScrollPromotion')
        if (store) {
          const bannerEl = container.querySelector('.el_animate')?.closest('[class*="section-"]')
          if (bannerEl) { store.load(bannerEl); return }
        }
        container.querySelectorAll('.el_animate').forEach(el => {
          el.classList.add('animate-scroll-banner')
        })
      },
      async fetchAddonPopupSections(handle) {
        if (!handle) return
        if (this.addonPopupSectionsCache[handle] !== undefined) {
          this.addonPopupSectionsHtml = this.addonPopupSectionsCache[handle]
          await this.$nextTick()
          this._initAddonPopupSectionAnimations()
          return
        }
        const sectionIds = ['scrolling_banner_3aBXMF', 'image_with_text_LtBR7i']
        const ratingId = 'pdp-popup-okendo-rating'
        try {
          const url = `${window.location.origin}/products/${handle}`
          const res = await fetch(url)
          const html = await res.text()

          // Parse HTML and extract sections
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')

          // Extract rating section
          const ratingSection = doc.querySelector(`#shopify-section-${ratingId}`)
          const ratingHtml = ratingSection ? ratingSection.outerHTML : ''

          if (ratingHtml && this.addonPopupVariant) {
            const tmp = document.createElement('div')
            tmp.innerHTML = ratingHtml
            const el = tmp.querySelector('[data-popup-okendo-rating]')
            if (el) {
              try {
                const rd = JSON.parse(el.textContent)
                this.addonPopupVariant = { ...this.addonPopupVariant, reviewCount: rd.reviewCount, reviewRating: rd.reviewRating }
              } catch(e) {}
            }
          }

          // Extract addon popup sections dynamically by their suffix
          let sectionHtml = ''
          sectionIds.forEach(sectionSuffix => {
            const section = doc.querySelector(`[id*="${sectionSuffix}"]`)
            if (section) {
              sectionHtml += section.outerHTML
            }
          })

          this.addonPopupSectionsCache[handle] = sectionHtml
          this.addonPopupSectionsHtml = sectionHtml
          await this.$nextTick()
          this._initAddonPopupSectionAnimations()
        } catch (e) {
          this.addonPopupSectionsCache[handle] = ''
          this.addonPopupSectionsHtml = ''
        }
      },
      richTextToHtml(json) {
        if (!json) return ''
        let tree
        try { tree = typeof json === 'string' ? JSON.parse(json) : json }
        catch (e) { return json }
        function walk(node) {
          if (!node) return ''
          if (node.type === 'text') {
            let t = (node.value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            if (node.bold)   t = '<strong>' + t + '</strong>'
            if (node.italic) t = '<em>' + t + '</em>'
            if (node.code)   t = '<code>' + t + '</code>'
            return t
          }
          const inner = (node.children || []).map(walk).join('')
          switch (node.type) {
            case 'root':      return inner
            case 'paragraph': return '<p>' + inner + '</p>'
            case 'heading':   return '<h' + node.level + '>' + inner + '</h' + node.level + '>'
            case 'list':      return node.listType === 'ordered' ? '<ol>' + inner + '</ol>' : '<ul>' + inner + '</ul>'
            case 'list-item': return '<li>' + inner + '</li>'
            case 'link':      return '<a href="' + (node.url || '') + '"' + (node.target ? ' target="' + node.target + '"' : '') + '>' + inner + '</a>'
            default:          return inner
          }
        }
        return walk(tree)
      },
      variantIsAvailable(v) {
        if (!v) return false
        return v.available !== false
      },
      firstAvailableVariantIdGlobally() {
        const list = Object.values(this.variantsById)
        for (let i = 0; i < list.length; i++) {
          const v = list[i]
          if (this.variantIsAvailable(v)) return v.id
        }
        return null
      },
      firstAvailableVariantIdForOptionKey(optionKey) {
        const key = optionKey != null ? String(optionKey) : ''
        const list = Object.values(this.variantsById)
        for (let i = 0; i < list.length; i++) {
          const v = list[i]
          if (!this.variantIsAvailable(v)) continue
          const o1 = v.option1 != null ? String(v.option1) : ''
          const t = v.title != null ? String(v.title) : ''
          if (o1 === key || t === key) return v.id
        }
        return null
      },
      getCardImage(option1Key) {
        const variant = this.getVariantById(this.activeVariantId)
        if (!variant || variant.option1 !== option1Key) return ''
        return variant && variant.image ? this.imageUrlWithWidth(variant.image, 248) : ''
      },
      getCardAlt(option1Key) {
        const variant = this.getVariantById(this.activeVariantId)
        if (!variant || variant.option1 !== option1Key) return ''
        return variant && variant.title ? variant.title : ''
      },
      getFeatureMetadata() {
        const active = this.getVariantById(this.activeVariantId)
        if (!active) return []
        if (active.featureMetadata && active.featureMetadata.length) return active.featureMetadata
        const match = Object.values(this.variantsById).find(
          v => v.option1 === active.option1 && v.featureMetadata && v.featureMetadata.length
        )
        return match ? match.featureMetadata : []
      },
      getCardFeatureIcon(option1Key) {
        const variant = this.getVariantById(this.activeVariantId)
        if (!variant || variant.option1 !== option1Key) return ''
        return variant && variant.featureIcon ? variant.featureIcon : ''
      },
      getCardFeatureText(option1Key) {
        const variant = this.getVariantById(this.activeVariantId)
        if (!variant || variant.option1 !== option1Key) return ''
        return variant && variant.featureText ? variant.featureText : ''
      },
      getAddonScentProfile(variantId) {
        const row = this.addonVariantsById[String(variantId)]
        if (!row) return []
        const list = row.scentProfile
        return Array.isArray(list) ? list : []
      },
      getAddonScentMoods(variantId) {
        const row = this.addonVariantsById[String(variantId)]
        if (!row) return []
        const list = row.scentMoods
        return Array.isArray(list) ? list : []
      },
      addonRowById(variantId) {
        return this.addonVariantsById[String(variantId)] || null
      },
      allScentsCardImage(variantId) {
        const row = this.addonRowById(variantId)
        if (!row || !row.cardImage) return ''
        const desktop = typeof window !== 'undefined' && window.matchMedia
          ? window.matchMedia('(min-width: 990px)').matches
          : false
        return this.imageUrlWithWidth(row.cardImage, desktop ? 512 : 248)
      },
      normalizeFilterText(value) {
        if (value == null) return ''
        return String(value).trim().toLowerCase()
      },
      availableScentProfiles() {
        const out = []
        const seen = {}
        const ids = Object.keys(this.addonVariantsById)
        for (let i = 0; i < ids.length; i++) {
          const id = Number(ids[i])
          if (!this.isAddonVariantVisible(id)) continue
          const list = this.getAddonScentProfile(id)
          for (let j = 0; j < list.length; j++) {
            const sp = list[j] || {}
            const rawName = sp.name != null ? String(sp.name).trim() : ''
            if (!rawName) continue
            const key = this.normalizeFilterText(rawName)
            if (seen[key]) continue
            seen[key] = true
            out.push({ name: rawName, color: sp.color || '' })
          }
        }
        return out
      },
      availableScentMoods() {
        const out = []
        const seen = {}
        const ids = Object.keys(this.addonVariantsById)
        for (let i = 0; i < ids.length; i++) {
          const id = Number(ids[i])
          if (!this.isAddonVariantVisible(id)) continue
          const list = this.getAddonScentMoods(id)
          for (let j = 0; j < list.length; j++) {
            const sm = list[j] || {}
            const rawName = sm.name != null ? String(sm.name).trim() : ''
            if (!rawName) continue
            const key = this.normalizeFilterText(rawName)
            if (seen[key]) continue
            seen[key] = true
            out.push({ name: rawName, image: sm.image || '' })
          }
        }
        return out
      },
      availableCollections() {
        const out = []
        const seen = {}
        const ids = Object.keys(this.addonVariantsById)
        for (let i = 0; i < ids.length; i++) {
          const id = Number(ids[i])
          if (!this.isAddonVariantVisible(id)) continue
          const row = this.addonVariantsById[String(id)]
          const rawName = row && row.collectionName != null ? String(row.collectionName).trim() : ''
          if (!rawName) continue
          const key = this.normalizeFilterText(rawName)
          if (seen[key]) continue
          seen[key] = true
          out.push({ name: rawName })
        }
        return out
      },
      isProfileFilterSelected(name) {
        const key = this.normalizeFilterText(name)
        return this.selectedScentProfileFilters.includes(key)
      },
      isMoodFilterSelected(name) {
        const key = this.normalizeFilterText(name)
        return this.selectedScentMoodFilters.includes(key)
      },
      isCollectionFilterSelected(name) {
        const key = this.normalizeFilterText(name)
        return this.selectedCollectionFilters.includes(key)
      },
      toggleProfileFilter(name) {
        const key = this.normalizeFilterText(name)
        if (!key) return
        if (this.selectedScentProfileFilters.includes(key)) {
          this.selectedScentProfileFilters = this.selectedScentProfileFilters.filter((x) => x !== key)
        } else {
          this.selectedScentProfileFilters = [...this.selectedScentProfileFilters, key]
        }
      },
      toggleMoodFilter(name) {
        const key = this.normalizeFilterText(name)
        if (!key) return
        if (this.selectedScentMoodFilters.includes(key)) {
          this.selectedScentMoodFilters = this.selectedScentMoodFilters.filter((x) => x !== key)
        } else {
          this.selectedScentMoodFilters = [...this.selectedScentMoodFilters, key]
        }
      },
      toggleCollectionFilter(name) {
        const key = this.normalizeFilterText(name)
        if (!key) return
        if (this.selectedCollectionFilters.includes(key)) {
          this.selectedCollectionFilters = this.selectedCollectionFilters.filter((x) => x !== key)
        } else {
          this.selectedCollectionFilters = [...this.selectedCollectionFilters, key]
        }
      },
      goToReviewStep() {
        const root = this.pdpSwiperRootEl || (this.$el && this.$el.closest ? this.$el.closest('.pdp-swiper') : null)
        if (!root) return
        const rootSwiperEl = root.querySelector('.pdp-swiper__root')
        if (!rootSwiperEl || !rootSwiperEl.swiper) return
        rootSwiperEl.swiper.slideTo(2)
      },
      selectAddonFromAllScents(variantId) {
        this.selectAddonVariant(variantId)
        this.closeAllScentsModal()
        this.$nextTick(() => {
          this.goToReviewStep()
          if (typeof window !== 'undefined') {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }
        })
      },
      addonMatchesSearch(row) {
        const q = this.normalizeFilterText(this.allScentsSearch)
        if (!q) return true
        const title = row && row.cardTitle ? this.normalizeFilterText(row.cardTitle) : ''
        const inspiredBy = row && row.inspiredBy ? this.normalizeFilterText(row.inspiredBy) : ''
        return title.includes(q) || inspiredBy.includes(q)
      },
      addonMatchesProfileFilters(variantId) {
        if (!this.selectedScentProfileFilters.length) return false
        const names = this.getAddonScentProfile(variantId).map((sp) => this.normalizeFilterText(sp && sp.name))
        return this.selectedScentProfileFilters.some((selected) => names.includes(selected))
      },
      addonMatchesMoodFilters(variantId) {
        if (!this.selectedScentMoodFilters.length) return false
        const names = this.getAddonScentMoods(variantId).map((sm) => this.normalizeFilterText(sm && sm.name))
        return this.selectedScentMoodFilters.some((selected) => names.includes(selected))
      },
      addonMatchesCollectionFilters(variantId) {
        if (!this.selectedCollectionFilters.length) return false
        const row = this.addonRowById(variantId)
        const name = this.normalizeFilterText(row && row.collectionName)
        if (!name) return false
        return this.selectedCollectionFilters.includes(name)
      },
      addonMatchesSelectedFilters(variantId) {
        const hasProfileFilters = this.selectedScentProfileFilters.length > 0
        const hasMoodFilters = this.selectedScentMoodFilters.length > 0
        const hasCollectionFilters = this.selectedCollectionFilters.length > 0
        if (!hasProfileFilters && !hasMoodFilters && !hasCollectionFilters) return true
        return (
          this.addonMatchesProfileFilters(variantId) ||
          this.addonMatchesMoodFilters(variantId) ||
          this.addonMatchesCollectionFilters(variantId)
        )
      },
      filteredAddonVariantIds() {
        const ids = Object.keys(this.addonVariantsById)
        const out = []
        for (let i = 0; i < ids.length; i++) {
          const id = Number(ids[i])
          if (!this.isAddonVariantVisible(id)) continue
          const row = this.addonRowById(id)
          if (!row) continue
          if (!this.addonMatchesSearch(row)) continue
          if (!this.addonMatchesSelectedFilters(id)) continue
          out.push(id)
        }
        return out
      },
      selectVariant(option1Key, variantId) {
        const next = this.getVariantById(variantId)
        if (!this.variantIsAvailable(next)) return
        this.activeVariantId = variantId
        this.pruneAddonSelection()
        this.$nextTick(() => {
          this.$dispatch('pdp-swiper-variant-changed', { variantId })
        })
      },
      setActiveCard(option1Key) {
        let id = this.defaultByOption1[option1Key]
        if (id != null && !this.variantIsAvailable(this.getVariantById(id))) {
          id = this.firstAvailableVariantIdForOptionKey(option1Key)
        }
        if (id != null) {
          this.activeVariantId = id
          this.pruneAddonSelection()
          this.$nextTick(() => {
            this.$dispatch('pdp-swiper-variant-changed', { variantId: id })
          })
        }
      },
      isCardActive(option1Key) {
        const active = this.getVariantById(this.activeVariantId)
        if (!active) return false
        return active.option1 === option1Key
      },
      isSwatchSelected(option1Key, variantId) {
        return Number(this.activeVariantId) === Number(variantId)
      },
      selectAddonVariant(variantId) {
        if (!this.isAddonVariantVisible(variantId)) return
        this.selectedAddonVariantId = variantId
        this.$nextTick(() => {
          this.$dispatch('pdp-swiper-variant-changed', { variantId })
        })
      },
      isAddonSelected(variantId) {
        return Number(this.selectedAddonVariantId) === Number(variantId)
      },
      openVariantPopup(option1Key) {
        this.popupOption1 = option1Key
        const id = this.defaultByOption1[option1Key] || this.activeVariantId
        const v = this.getVariantById(id)
        if (v) {
          this.popupVariant = v
          this.popupOpen = true
          this.popupSectionsHtml = ''
          this.$nextTick(() => {
            this.fetchPopupSections(this.popupLinkedProductHandle())
          })
        }
      },
      closePopup() {
        this.popupOpen = false
        this.popupVariant = null
        this.popupOption1 = null
      },
      selectDeviceAndClose() {
        if (this.popupVariant) {
          this.activeVariantId = this.popupVariant.id
          this.pruneAddonSelection()
          this.$nextTick(() => {
            this.$dispatch('pdp-swiper-variant-changed', { variantId: this.activeVariantId })
          })
        }
        this.closePopup()
      },
      openAddonPopup(addonVariantId) {
        const v = this.getAddonVariantById(addonVariantId)
        if (v) {
          this.addonPopupVariant = v
          this.addonPopupOpen = true
          this.addonPopupSectionsHtml = ''
          this.$nextTick(() => {
            this.fetchAddonPopupSections(v.handle)
          })
        }
      },
      closeAddonPopup() {
        this.addonPopupOpen = false
        this.addonPopupVariant = null
      },
      selectAddonAndClose() {
        if (this.addonPopupVariant) {
          this.selectedAddonVariantId = this.addonPopupVariant.id
          this.pruneAddonSelection()
          this.$nextTick(() => {
            this.$dispatch('pdp-swiper-addon-changed', { variantId: this.selectedAddonVariantId })
          })
        }
        this.closeAddonPopup()
      },
      getAddonVariantById(id) {
        return this.addonVariantsById[String(id)] || null
      },
      popupSelectSwatch(variantId) {
        const v = this.getVariantById(variantId)
        if (v) {
          this.popupVariant = v
        }
      },
      popupSwatches() {
        if (!this.popupOption1) return []
        const swatches = []
        const seen = {}
        const allIds = Object.keys(this.variantsById)
        for (let i = 0; i < allIds.length; i++) {
          const v = this.variantsById[allIds[i]]
          if (v.option1 !== this.popupOption1) continue
          if (!v.available) continue
          if (!v.option2 || seen[v.option2]) continue
          seen[v.option2] = true
          swatches.push({ id: v.id, label: v.option2, bg: v.swatchBg || '#e0e0e0' })
        }
        return swatches
      },
      isPopupSwatchActive(variantId) {
        return this.popupVariant && Number(this.popupVariant.id) === Number(variantId)
      },
      popupFeatures() {
        if (!this.popupVariant) return []
        return Array.isArray(this.popupVariant.allFeatures) ? this.popupVariant.allFeatures : []
      },
      popupTitle() {
        if (!this.popupVariant) return ''
        return this.popupVariant.option1 || this.popupVariant.title || ''
      },
      popupSubtitle() {
        if (!this.popupVariant) return ''
        return this.popupVariant.option2 || ''
      },
      popupReviewCount() {
        if (!this.popupVariant) return 0
        return Number(this.popupVariant.reviewCount || 0)
      },
      popupReviewRating() {
        if (!this.popupVariant) return 0
        return Number(this.popupVariant.reviewRating || 0)
      },
      popupImage() {
        if (!this.popupVariant) return ''
        return this.popupVariant.image || ''
      },
      popupRealPrice() {
        if (!this.popupVariant) return ''
        return this.formatPdpMoney(this.popupVariant.realPrice)
      },
      popupCompareAtPrice() {
        if (!this.popupVariant) return ''
        const c = Number(this.popupVariant.compareAtPrice || 0)
        const p = Number(this.popupVariant.realPrice || 0)
        if (c > p) return this.formatPdpMoney(c)
        return ''
      },
      popupSavePercent() {
        if (!this.popupVariant) return ''
        const c = Number(this.popupVariant.compareAtPrice || 0)
        const p = Number(this.popupVariant.realPrice || 0)
        if (c > p && c > 0) return Math.round(((c - p) / c) * 100) + '%'
        return ''
      },
      addonPopupTitle() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.cardTitle || ''
      },
      addonPopupReviewCount() {
        if (!this.addonPopupVariant) return 0
        return Number(this.addonPopupVariant.reviewCount || 0)
      },
      addonPopupReviewRating() {
        if (!this.addonPopupVariant) return 0
        return Number(this.addonPopupVariant.reviewRating || 0)
      },
      addonPopupImage() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.cardImage || ''
      },
      addonPopupPrice() {
        if (!this.addonPopupVariant) return ''
        const pricing = this.normalizedPricing(this.addonPopupVariant)
        return this.formatPdpMoney(pricing.price)
      },
      addonPopupCompareAtPrice() {
        if (!this.addonPopupVariant) return ''
        const pricing = this.normalizedPricing(this.addonPopupVariant)
        const c = Number(pricing.compareAtPrice || 0)
        const p = Number(pricing.price || 0)
        if (c > p) return this.formatPdpMoney(c)
        return ''
      },
      addonPopupHasCompare() {
        if (!this.addonPopupVariant) return false
        const pricing = this.normalizedPricing(this.addonPopupVariant)
        return Number(pricing.compareAtPrice) > Number(pricing.price)
      },
      addonPopupScentProfile() {
        if (!this.addonPopupVariant) return []
        return Array.isArray(this.addonPopupVariant.scentProfile) ? this.addonPopupVariant.scentProfile : []
      },
      addonPopupScentMoods() {
        if (!this.addonPopupVariant) return []
        return Array.isArray(this.addonPopupVariant.scentMoods) ? this.addonPopupVariant.scentMoods : []
      },
      addonPopupInspiredBy() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.inspiredBy || ''
      },
      addonPopupSavePercent() {
        if (!this.addonPopupVariant) return ''
        const pricing = this.normalizedPricing(this.addonPopupVariant)
        const c = Number(pricing.compareAtPrice || 0)
        const p = Number(pricing.price || 0)
        if (c > p && c > 0) return Math.round(((c - p) / c) * 100) + '%'
        return ''
      },
      addonPopupDescription() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.description || ''
      },
    }))
  })

  } catch(e) { console.error(e); }
})();
})();
